// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "event.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "event.proto" (syntax proto3)
// tslint:disable
import { String$ } from "./common";
import { URLObject } from "./s3";
import { PropertyDocumentRequest } from "./email";
import { Empty } from "./common";
import { IDInt32 } from "./common";
import { InvoiceBodyReturn } from "./email";
import { InvoiceBodyRequest } from "./email";
import { Bool } from "./common";
import { Double } from "./common";
import { Int32 } from "./common";
import { ProjectTaskList } from "./task";
import { ProjectTask } from "./task";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { QuoteUsed } from "./quote";
import { QuoteLine } from "./quote";
import { ChangeOrder } from "./projects_core";
import { Expended } from "./projects_core";
import { Estimate } from "./projects_core";
import { Int32List } from "./common";
import { Transaction } from "./transaction";
import { Trip } from "./perdiem";
import { Task } from "./task";
import { PerDiem } from "./perdiem";
import { TimesheetLine } from "./timesheet_line";
import { TripList } from "./perdiem";
import { TaskList } from "./task";
import { PerDiemList } from "./perdiem";
import { TimesheetLineList } from "./timesheet_line";
import { TransactionList } from "./transaction";
import { TimeoffRequest } from "./timesheet_line";
import { LatLng } from "./common";
import { JobTypeSubtype } from "./job_type";
import { JobSubtype } from "./job_type";
import { JobType } from "./job_type";
import { User } from "./user";
import { Property } from "./property";
import { Document } from "./s3";
import { SQSEmail } from "./email";
/**
 * RefrigerantUse is the vocabulary of ServicesRendered.refrigerant_use. The
 * field itself is an int32 (see its comment); this enum names the values.
 *
 * @generated from protobuf enum RefrigerantUse
 */
export var RefrigerantUse;
(function (RefrigerantUse) {
    /**
     * @generated from protobuf enum value: REFRIGERANT_USE_UNANSWERED = 0;
     */
    RefrigerantUse[RefrigerantUse["UNANSWERED"] = 0] = "UNANSWERED";
    /**
     * @generated from protobuf enum value: REFRIGERANT_USE_NO = 1;
     */
    RefrigerantUse[RefrigerantUse["NO"] = 1] = "NO";
    /**
     * @generated from protobuf enum value: REFRIGERANT_USE_YES = 2;
     */
    RefrigerantUse[RefrigerantUse["YES"] = 2] = "YES";
})(RefrigerantUse || (RefrigerantUse = {}));
// @generated message type with reflection information, may provide speed optimized methods
class SubAccountEventRequest$Type extends MessageType {
    constructor() {
        super("SubAccountEventRequest", [
            { no: 1, name: "sub_account_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event", kind: "message", T: () => Event }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subAccountId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 sub_account_id */ 1:
                    message.subAccountId = reader.int32();
                    break;
                case /* Event event */ 2:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 sub_account_id = 1; */
        if (message.subAccountId !== 0)
            writer.tag(1, WireType.Varint).int32(message.subAccountId);
        /* Event event = 2; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SubAccountEventRequest
 */
export const SubAccountEventRequest = new SubAccountEventRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MostLikelyJobRequest$Type extends MessageType {
    constructor() {
        super("MostLikelyJobRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "target_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "include_full_event_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.targetDate = "";
        message.includeFullEventData = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string target_date */ 2:
                    message.targetDate = reader.string();
                    break;
                case /* bool include_full_event_data */ 3:
                    message.includeFullEventData = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string target_date = 2; */
        if (message.targetDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.targetDate);
        /* bool include_full_event_data = 3; */
        if (message.includeFullEventData !== false)
            writer.tag(3, WireType.Varint).bool(message.includeFullEventData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MostLikelyJobRequest
 */
export const MostLikelyJobRequest = new MostLikelyJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStripePaymentLinkRequest$Type extends MessageType {
    constructor() {
        super("GenerateStripePaymentLinkRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "invoice_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0n;
        message.invoiceJobNumber = "";
        message.amount = 0;
        message.description = "";
        message.customerId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 invoice_id */ 1:
                    message.invoiceId = reader.int64().toBigInt();
                    break;
                case /* string invoice_job_number */ 2:
                    message.invoiceJobNumber = reader.string();
                    break;
                case /* double amount */ 3:
                    message.amount = reader.double();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int64 customer_id */ 5:
                    message.customerId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 invoice_id = 1; */
        if (message.invoiceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.invoiceId);
        /* string invoice_job_number = 2; */
        if (message.invoiceJobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceJobNumber);
        /* double amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit64).double(message.amount);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int64 customer_id = 5; */
        if (message.customerId !== 0n)
            writer.tag(5, WireType.Varint).int64(message.customerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GenerateStripePaymentLinkRequest
 */
export const GenerateStripePaymentLinkRequest = new GenerateStripePaymentLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateStripePaymentLinkResponse$Type extends MessageType {
    constructor() {
        super("GenerateStripePaymentLinkResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GenerateStripePaymentLinkResponse
 */
export const GenerateStripePaymentLinkResponse = new GenerateStripePaymentLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicesRendered$Type extends MessageType {
    constructor() {
        super("ServicesRendered", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "technician_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "materials_used", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "service_rendered", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tech_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "datetime", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "time_finished", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "hide_from_timesheet", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "signature_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "signature_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "group_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "id_event_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 25, name: "refrigerant_use", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "refrigerant_signed_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.technicianUserId = 0;
        message.name = "";
        message.materialsUsed = "";
        message.serviceRendered = "";
        message.techNotes = "";
        message.status = "";
        message.datetime = "";
        message.timeStarted = "";
        message.timeFinished = "";
        message.isActive = 0;
        message.hideFromTimesheet = 0;
        message.signatureId = 0;
        message.signatureData = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.dateRange = [];
        message.dateTarget = [];
        message.groupBy = "";
        message.withoutLimit = false;
        message.idEventList = "";
        message.latitude = 0;
        message.longitude = 0;
        message.refrigerantUse = 0;
        message.refrigerantSignedBy = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 technician_user_id */ 3:
                    message.technicianUserId = reader.int32();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string materials_used */ 5:
                    message.materialsUsed = reader.string();
                    break;
                case /* string service_rendered */ 6:
                    message.serviceRendered = reader.string();
                    break;
                case /* string tech_notes */ 7:
                    message.techNotes = reader.string();
                    break;
                case /* string status */ 8:
                    message.status = reader.string();
                    break;
                case /* string datetime */ 9:
                    message.datetime = reader.string();
                    break;
                case /* string time_started */ 10:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_finished */ 11:
                    message.timeFinished = reader.string();
                    break;
                case /* int32 is_active */ 12:
                    message.isActive = reader.int32();
                    break;
                case /* int32 hide_from_timesheet */ 13:
                    message.hideFromTimesheet = reader.int32();
                    break;
                case /* int32 signature_id */ 14:
                    message.signatureId = reader.int32();
                    break;
                case /* string signature_data */ 15:
                    message.signatureData = reader.string();
                    break;
                case /* repeated string field_mask */ 16:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 17:
                    message.pageNumber = reader.int32();
                    break;
                case /* repeated string date_range */ 18:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 19:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string group_by */ 20:
                    message.groupBy = reader.string();
                    break;
                case /* bool without_limit */ 21:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string id_event_list */ 22:
                    message.idEventList = reader.string();
                    break;
                case /* double latitude */ 23:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 24:
                    message.longitude = reader.double();
                    break;
                case /* int32 refrigerant_use */ 25:
                    message.refrigerantUse = reader.int32();
                    break;
                case /* int32 refrigerant_signed_by */ 26:
                    message.refrigerantSignedBy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 technician_user_id = 3; */
        if (message.technicianUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.technicianUserId);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string materials_used = 5; */
        if (message.materialsUsed !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.materialsUsed);
        /* string service_rendered = 6; */
        if (message.serviceRendered !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.serviceRendered);
        /* string tech_notes = 7; */
        if (message.techNotes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.techNotes);
        /* string status = 8; */
        if (message.status !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.status);
        /* string datetime = 9; */
        if (message.datetime !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.datetime);
        /* string time_started = 10; */
        if (message.timeStarted !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_finished = 11; */
        if (message.timeFinished !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.timeFinished);
        /* int32 is_active = 12; */
        if (message.isActive !== 0)
            writer.tag(12, WireType.Varint).int32(message.isActive);
        /* int32 hide_from_timesheet = 13; */
        if (message.hideFromTimesheet !== 0)
            writer.tag(13, WireType.Varint).int32(message.hideFromTimesheet);
        /* int32 signature_id = 14; */
        if (message.signatureId !== 0)
            writer.tag(14, WireType.Varint).int32(message.signatureId);
        /* string signature_data = 15; */
        if (message.signatureData !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.signatureData);
        /* repeated string field_mask = 16; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 17; */
        if (message.pageNumber !== 0)
            writer.tag(17, WireType.Varint).int32(message.pageNumber);
        /* repeated string date_range = 18; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 19; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string group_by = 20; */
        if (message.groupBy !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.groupBy);
        /* bool without_limit = 21; */
        if (message.withoutLimit !== false)
            writer.tag(21, WireType.Varint).bool(message.withoutLimit);
        /* string id_event_list = 22; */
        if (message.idEventList !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.idEventList);
        /* double latitude = 23; */
        if (message.latitude !== 0)
            writer.tag(23, WireType.Bit64).double(message.latitude);
        /* double longitude = 24; */
        if (message.longitude !== 0)
            writer.tag(24, WireType.Bit64).double(message.longitude);
        /* int32 refrigerant_use = 25; */
        if (message.refrigerantUse !== 0)
            writer.tag(25, WireType.Varint).int32(message.refrigerantUse);
        /* int32 refrigerant_signed_by = 26; */
        if (message.refrigerantSignedBy !== 0)
            writer.tag(26, WireType.Varint).int32(message.refrigerantSignedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServicesRendered
 */
export const ServicesRendered = new ServicesRendered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicesRenderedList$Type extends MessageType {
    constructor() {
        super("ServicesRenderedList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicesRendered },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ServicesRendered results */ 1:
                    message.results.push(ServicesRendered.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ServicesRendered results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ServicesRendered.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServicesRenderedList
 */
export const ServicesRenderedList = new ServicesRenderedList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Payment$Type extends MessageType {
    constructor() {
        super("Payment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "collected", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payee_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "amount_collected", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "dl_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "auth_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cheque_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_invoice_data", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "stripe_events_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "helcim_events_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.servicesRenderedId = 0;
        message.collected = 0;
        message.type = "";
        message.payeeUserId = 0;
        message.amountCollected = 0;
        message.dlNumber = "";
        message.authKey = "";
        message.chequeNumber = "";
        message.isInvoiceData = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.notes = "";
        message.stripeEventsId = 0;
        message.helcimEventsId = 0;
        message.invoiceId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 2:
                    message.servicesRenderedId = reader.int32();
                    break;
                case /* int32 collected */ 3:
                    message.collected = reader.int32();
                    break;
                case /* string type */ 4:
                    message.type = reader.string();
                    break;
                case /* int32 payee_user_id */ 5:
                    message.payeeUserId = reader.int32();
                    break;
                case /* double amount_collected */ 6:
                    message.amountCollected = reader.double();
                    break;
                case /* string dl_number */ 7:
                    message.dlNumber = reader.string();
                    break;
                case /* string auth_key */ 8:
                    message.authKey = reader.string();
                    break;
                case /* string cheque_number */ 9:
                    message.chequeNumber = reader.string();
                    break;
                case /* int32 is_invoice_data */ 10:
                    message.isInvoiceData = reader.int32();
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* string notes */ 13:
                    message.notes = reader.string();
                    break;
                case /* int32 stripe_events_id */ 14:
                    message.stripeEventsId = reader.int32();
                    break;
                case /* int32 helcim_events_id */ 15:
                    message.helcimEventsId = reader.int32();
                    break;
                case /* int32 invoice_id */ 16:
                    message.invoiceId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 services_rendered_id = 2; */
        if (message.servicesRenderedId !== 0)
            writer.tag(2, WireType.Varint).int32(message.servicesRenderedId);
        /* int32 collected = 3; */
        if (message.collected !== 0)
            writer.tag(3, WireType.Varint).int32(message.collected);
        /* string type = 4; */
        if (message.type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.type);
        /* int32 payee_user_id = 5; */
        if (message.payeeUserId !== 0)
            writer.tag(5, WireType.Varint).int32(message.payeeUserId);
        /* double amount_collected = 6; */
        if (message.amountCollected !== 0)
            writer.tag(6, WireType.Bit64).double(message.amountCollected);
        /* string dl_number = 7; */
        if (message.dlNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dlNumber);
        /* string auth_key = 8; */
        if (message.authKey !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authKey);
        /* string cheque_number = 9; */
        if (message.chequeNumber !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.chequeNumber);
        /* int32 is_invoice_data = 10; */
        if (message.isInvoiceData !== 0)
            writer.tag(10, WireType.Varint).int32(message.isInvoiceData);
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* string notes = 13; */
        if (message.notes !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.notes);
        /* int32 stripe_events_id = 14; */
        if (message.stripeEventsId !== 0)
            writer.tag(14, WireType.Varint).int32(message.stripeEventsId);
        /* int32 helcim_events_id = 15; */
        if (message.helcimEventsId !== 0)
            writer.tag(15, WireType.Varint).int32(message.helcimEventsId);
        /* int32 invoice_id = 16; */
        if (message.invoiceId !== 0)
            writer.tag(16, WireType.Varint).int32(message.invoiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Payment
 */
export const Payment = new Payment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentList$Type extends MessageType {
    constructor() {
        super("PaymentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Payment },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Payment results */ 1:
                    message.results.push(Payment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Payment results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Payment.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentList
 */
export const PaymentList = new PaymentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MaintenanceQuestion$Type extends MessageType {
    constructor() {
        super("MaintenanceQuestion", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "tstat_brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "thermostat", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "plateform", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "float_switch", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "evaporator_coil", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "condenser_coil", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "hurricane_pad", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "lineset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "drain_line", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "gas_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "burner", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "heat_exchanger", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "condition_notes1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "condition_notes2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "condition_notes3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "condition_rating1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "condition_rating2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "condition_rating3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "reading_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.tstatBrand = "";
        message.thermostat = 0;
        message.plateform = 0;
        message.floatSwitch = 0;
        message.evaporatorCoil = 0;
        message.condenserCoil = 0;
        message.hurricanePad = 0;
        message.lineset = 0;
        message.drainLine = 0;
        message.gasType = 0;
        message.burner = 0;
        message.heatExchanger = 0;
        message.conditionNotes1 = "";
        message.conditionNotes2 = "";
        message.conditionNotes3 = "";
        message.conditionRating1 = "";
        message.conditionRating2 = "";
        message.conditionRating3 = "";
        message.readingId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string tstat_brand */ 2:
                    message.tstatBrand = reader.string();
                    break;
                case /* int32 thermostat */ 3:
                    message.thermostat = reader.int32();
                    break;
                case /* int32 plateform */ 4:
                    message.plateform = reader.int32();
                    break;
                case /* int32 float_switch */ 5:
                    message.floatSwitch = reader.int32();
                    break;
                case /* int32 evaporator_coil */ 6:
                    message.evaporatorCoil = reader.int32();
                    break;
                case /* int32 condenser_coil */ 7:
                    message.condenserCoil = reader.int32();
                    break;
                case /* int32 hurricane_pad */ 8:
                    message.hurricanePad = reader.int32();
                    break;
                case /* int32 lineset */ 9:
                    message.lineset = reader.int32();
                    break;
                case /* int32 drain_line */ 10:
                    message.drainLine = reader.int32();
                    break;
                case /* int32 gas_type */ 11:
                    message.gasType = reader.int32();
                    break;
                case /* int32 burner */ 12:
                    message.burner = reader.int32();
                    break;
                case /* int32 heat_exchanger */ 13:
                    message.heatExchanger = reader.int32();
                    break;
                case /* string condition_notes1 */ 14:
                    message.conditionNotes1 = reader.string();
                    break;
                case /* string condition_notes2 */ 15:
                    message.conditionNotes2 = reader.string();
                    break;
                case /* string condition_notes3 */ 16:
                    message.conditionNotes3 = reader.string();
                    break;
                case /* string condition_rating1 */ 17:
                    message.conditionRating1 = reader.string();
                    break;
                case /* string condition_rating2 */ 18:
                    message.conditionRating2 = reader.string();
                    break;
                case /* string condition_rating3 */ 19:
                    message.conditionRating3 = reader.string();
                    break;
                case /* int32 reading_id */ 20:
                    message.readingId = reader.int32();
                    break;
                case /* repeated string field_mask */ 21:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 22:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string tstat_brand = 2; */
        if (message.tstatBrand !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tstatBrand);
        /* int32 thermostat = 3; */
        if (message.thermostat !== 0)
            writer.tag(3, WireType.Varint).int32(message.thermostat);
        /* int32 plateform = 4; */
        if (message.plateform !== 0)
            writer.tag(4, WireType.Varint).int32(message.plateform);
        /* int32 float_switch = 5; */
        if (message.floatSwitch !== 0)
            writer.tag(5, WireType.Varint).int32(message.floatSwitch);
        /* int32 evaporator_coil = 6; */
        if (message.evaporatorCoil !== 0)
            writer.tag(6, WireType.Varint).int32(message.evaporatorCoil);
        /* int32 condenser_coil = 7; */
        if (message.condenserCoil !== 0)
            writer.tag(7, WireType.Varint).int32(message.condenserCoil);
        /* int32 hurricane_pad = 8; */
        if (message.hurricanePad !== 0)
            writer.tag(8, WireType.Varint).int32(message.hurricanePad);
        /* int32 lineset = 9; */
        if (message.lineset !== 0)
            writer.tag(9, WireType.Varint).int32(message.lineset);
        /* int32 drain_line = 10; */
        if (message.drainLine !== 0)
            writer.tag(10, WireType.Varint).int32(message.drainLine);
        /* int32 gas_type = 11; */
        if (message.gasType !== 0)
            writer.tag(11, WireType.Varint).int32(message.gasType);
        /* int32 burner = 12; */
        if (message.burner !== 0)
            writer.tag(12, WireType.Varint).int32(message.burner);
        /* int32 heat_exchanger = 13; */
        if (message.heatExchanger !== 0)
            writer.tag(13, WireType.Varint).int32(message.heatExchanger);
        /* string condition_notes1 = 14; */
        if (message.conditionNotes1 !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.conditionNotes1);
        /* string condition_notes2 = 15; */
        if (message.conditionNotes2 !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.conditionNotes2);
        /* string condition_notes3 = 16; */
        if (message.conditionNotes3 !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.conditionNotes3);
        /* string condition_rating1 = 17; */
        if (message.conditionRating1 !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.conditionRating1);
        /* string condition_rating2 = 18; */
        if (message.conditionRating2 !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.conditionRating2);
        /* string condition_rating3 = 19; */
        if (message.conditionRating3 !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.conditionRating3);
        /* int32 reading_id = 20; */
        if (message.readingId !== 0)
            writer.tag(20, WireType.Varint).int32(message.readingId);
        /* repeated string field_mask = 21; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 22; */
        if (message.pageNumber !== 0)
            writer.tag(22, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MaintenanceQuestion
 */
export const MaintenanceQuestion = new MaintenanceQuestion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MaintenanceQuestionList$Type extends MessageType {
    constructor() {
        super("MaintenanceQuestionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MaintenanceQuestion },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MaintenanceQuestion results */ 1:
                    message.results.push(MaintenanceQuestion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MaintenanceQuestion results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MaintenanceQuestion.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MaintenanceQuestionList
 */
export const MaintenanceQuestionList = new MaintenanceQuestionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SQSEmailAndDocument$Type extends MessageType {
    constructor() {
        super("SQSEmailAndDocument", [
            { no: 1, name: "email", kind: "message", T: () => SQSEmail },
            { no: 2, name: "document", kind: "message", T: () => Document },
            { no: 3, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.paymentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* SQSEmail email */ 1:
                    message.email = SQSEmail.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* Document document */ 2:
                    message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
                    break;
                case /* string payment_type */ 3:
                    message.paymentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* SQSEmail email = 1; */
        if (message.email)
            SQSEmail.internalBinaryWrite(message.email, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Document document = 2; */
        if (message.document)
            Document.internalBinaryWrite(message.document, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string payment_type = 3; */
        if (message.paymentType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SQSEmailAndDocument
 */
export const SQSEmailAndDocument = new SQSEmailAndDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice$Type extends MessageType {
    constructor() {
        super("Invoice", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "system_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "system_type_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "compressor_amps", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "condensing_fan_amps", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "serial", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "suction_pressure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "head_pressure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "model_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "brand_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "return_temperature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "serial_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "start_date_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "supply_temperature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "tstat_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "tstat_brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "subcool", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "filter_sizes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "superheat", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "properties", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "servicesperformedrow1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "totalamountrow1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "servicesperformedrow2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "totalamountrow2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "servicesperformedrow3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "totalamountrow3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "servicesperformedrow4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "totalamountrow4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "discount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "discountcost", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "totalamounttotal", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "credit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "cash", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 43, name: "by_check", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 44, name: "billing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 45, name: "payment_yes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 46, name: "payment_no", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "service_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "log_payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "log_payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 50, name: "property_billing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 51, name: "material_used", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 52, name: "material_total", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 54, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 55, name: "signature_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 56, name: "signature_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "tax", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 58, name: "tax_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 59, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "retainage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 61, name: "display_invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 62, name: "signature_override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 63, name: "contract_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 64, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.contractId = 0;
        message.userId = 0;
        message.propertyId = 0;
        message.systemType = "";
        message.systemType2 = "";
        message.compressorAmps = "";
        message.model = "";
        message.brand = "";
        message.condensingFanAmps = "";
        message.serial = "";
        message.startDate = "";
        message.suctionPressure = "";
        message.headPressure = "";
        message.model2 = "";
        message.brand2 = "";
        message.returnTemperature = "";
        message.serial2 = "";
        message.startDate2 = "";
        message.supplyTemperature = "";
        message.tstatType = "";
        message.tstatBrand = "";
        message.subcool = "";
        message.filterSizes = "";
        message.superheat = "";
        message.notes = "";
        message.properties = "";
        message.terms = "";
        message.servicesperformedrow1 = "";
        message.totalamountrow1 = "";
        message.servicesperformedrow2 = "";
        message.totalamountrow2 = "";
        message.servicesperformedrow3 = "";
        message.totalamountrow3 = "";
        message.servicesperformedrow4 = "";
        message.totalamountrow4 = "";
        message.discount = "";
        message.discountcost = "";
        message.totalamounttotal = "";
        message.credit = 0;
        message.cash = 0;
        message.byCheck = 0;
        message.billing = 0;
        message.paymentYes = 0;
        message.paymentNo = 0;
        message.serviceItem = "";
        message.logPaymentType = "";
        message.logPaymentStatus = "";
        message.propertyBilling = 0;
        message.materialUsed = "";
        message.materialTotal = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.signatureFileId = 0;
        message.signatureName = "";
        message.tax = 0;
        message.taxCost = 0;
        message.projectId = 0;
        message.retainage = 0;
        message.displayInvoiceNumber = "";
        message.signatureOverrideNote = "";
        message.contractIdList = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 contract_id */ 3:
                    message.contractId = reader.int32();
                    break;
                case /* int32 user_id */ 4:
                    message.userId = reader.int32();
                    break;
                case /* int32 property_id */ 5:
                    message.propertyId = reader.int32();
                    break;
                case /* string system_type */ 6:
                    message.systemType = reader.string();
                    break;
                case /* string system_type_2 */ 7:
                    message.systemType2 = reader.string();
                    break;
                case /* string compressor_amps */ 8:
                    message.compressorAmps = reader.string();
                    break;
                case /* string model */ 9:
                    message.model = reader.string();
                    break;
                case /* string brand */ 10:
                    message.brand = reader.string();
                    break;
                case /* string condensing_fan_amps */ 11:
                    message.condensingFanAmps = reader.string();
                    break;
                case /* string serial */ 12:
                    message.serial = reader.string();
                    break;
                case /* string start_date */ 13:
                    message.startDate = reader.string();
                    break;
                case /* string suction_pressure */ 14:
                    message.suctionPressure = reader.string();
                    break;
                case /* string head_pressure */ 15:
                    message.headPressure = reader.string();
                    break;
                case /* string model_2 */ 16:
                    message.model2 = reader.string();
                    break;
                case /* string brand_2 */ 17:
                    message.brand2 = reader.string();
                    break;
                case /* string return_temperature */ 18:
                    message.returnTemperature = reader.string();
                    break;
                case /* string serial_2 */ 19:
                    message.serial2 = reader.string();
                    break;
                case /* string start_date_2 */ 20:
                    message.startDate2 = reader.string();
                    break;
                case /* string supply_temperature */ 21:
                    message.supplyTemperature = reader.string();
                    break;
                case /* string tstat_type */ 22:
                    message.tstatType = reader.string();
                    break;
                case /* string tstat_brand */ 23:
                    message.tstatBrand = reader.string();
                    break;
                case /* string subcool */ 24:
                    message.subcool = reader.string();
                    break;
                case /* string filter_sizes */ 25:
                    message.filterSizes = reader.string();
                    break;
                case /* string superheat */ 26:
                    message.superheat = reader.string();
                    break;
                case /* string notes */ 27:
                    message.notes = reader.string();
                    break;
                case /* string properties */ 28:
                    message.properties = reader.string();
                    break;
                case /* string terms */ 29:
                    message.terms = reader.string();
                    break;
                case /* string servicesperformedrow1 */ 30:
                    message.servicesperformedrow1 = reader.string();
                    break;
                case /* string totalamountrow1 */ 31:
                    message.totalamountrow1 = reader.string();
                    break;
                case /* string servicesperformedrow2 */ 32:
                    message.servicesperformedrow2 = reader.string();
                    break;
                case /* string totalamountrow2 */ 33:
                    message.totalamountrow2 = reader.string();
                    break;
                case /* string servicesperformedrow3 */ 34:
                    message.servicesperformedrow3 = reader.string();
                    break;
                case /* string totalamountrow3 */ 35:
                    message.totalamountrow3 = reader.string();
                    break;
                case /* string servicesperformedrow4 */ 36:
                    message.servicesperformedrow4 = reader.string();
                    break;
                case /* string totalamountrow4 */ 37:
                    message.totalamountrow4 = reader.string();
                    break;
                case /* string discount */ 38:
                    message.discount = reader.string();
                    break;
                case /* string discountcost */ 39:
                    message.discountcost = reader.string();
                    break;
                case /* string totalamounttotal */ 40:
                    message.totalamounttotal = reader.string();
                    break;
                case /* int32 credit */ 41:
                    message.credit = reader.int32();
                    break;
                case /* int32 cash */ 42:
                    message.cash = reader.int32();
                    break;
                case /* int32 by_check */ 43:
                    message.byCheck = reader.int32();
                    break;
                case /* int32 billing */ 44:
                    message.billing = reader.int32();
                    break;
                case /* int32 payment_yes */ 45:
                    message.paymentYes = reader.int32();
                    break;
                case /* int32 payment_no */ 46:
                    message.paymentNo = reader.int32();
                    break;
                case /* string service_item */ 47:
                    message.serviceItem = reader.string();
                    break;
                case /* string log_payment_type */ 48:
                    message.logPaymentType = reader.string();
                    break;
                case /* string log_payment_status */ 49:
                    message.logPaymentStatus = reader.string();
                    break;
                case /* int32 property_billing */ 50:
                    message.propertyBilling = reader.int32();
                    break;
                case /* string material_used */ 51:
                    message.materialUsed = reader.string();
                    break;
                case /* string material_total */ 52:
                    message.materialTotal = reader.string();
                    break;
                case /* repeated string field_mask */ 53:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 54:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 signature_file_id */ 55:
                    message.signatureFileId = reader.int32();
                    break;
                case /* string signature_name */ 56:
                    message.signatureName = reader.string();
                    break;
                case /* float tax */ 57:
                    message.tax = reader.float();
                    break;
                case /* float tax_cost */ 58:
                    message.taxCost = reader.float();
                    break;
                case /* int32 project_id */ 59:
                    message.projectId = reader.int32();
                    break;
                case /* double retainage */ 60:
                    message.retainage = reader.double();
                    break;
                case /* string display_invoice_number */ 61:
                    message.displayInvoiceNumber = reader.string();
                    break;
                case /* string signature_override_note = 62 [deprecated = true] */ 62:
                    message.signatureOverrideNote = reader.string();
                    break;
                case /* string contract_id_list */ 63:
                    message.contractIdList = reader.string();
                    break;
                case /* bool without_limit */ 64:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 contract_id = 3; */
        if (message.contractId !== 0)
            writer.tag(3, WireType.Varint).int32(message.contractId);
        /* int32 user_id = 4; */
        if (message.userId !== 0)
            writer.tag(4, WireType.Varint).int32(message.userId);
        /* int32 property_id = 5; */
        if (message.propertyId !== 0)
            writer.tag(5, WireType.Varint).int32(message.propertyId);
        /* string system_type = 6; */
        if (message.systemType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.systemType);
        /* string system_type_2 = 7; */
        if (message.systemType2 !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.systemType2);
        /* string compressor_amps = 8; */
        if (message.compressorAmps !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.compressorAmps);
        /* string model = 9; */
        if (message.model !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.model);
        /* string brand = 10; */
        if (message.brand !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.brand);
        /* string condensing_fan_amps = 11; */
        if (message.condensingFanAmps !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.condensingFanAmps);
        /* string serial = 12; */
        if (message.serial !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.serial);
        /* string start_date = 13; */
        if (message.startDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.startDate);
        /* string suction_pressure = 14; */
        if (message.suctionPressure !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.suctionPressure);
        /* string head_pressure = 15; */
        if (message.headPressure !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.headPressure);
        /* string model_2 = 16; */
        if (message.model2 !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.model2);
        /* string brand_2 = 17; */
        if (message.brand2 !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.brand2);
        /* string return_temperature = 18; */
        if (message.returnTemperature !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.returnTemperature);
        /* string serial_2 = 19; */
        if (message.serial2 !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.serial2);
        /* string start_date_2 = 20; */
        if (message.startDate2 !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.startDate2);
        /* string supply_temperature = 21; */
        if (message.supplyTemperature !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.supplyTemperature);
        /* string tstat_type = 22; */
        if (message.tstatType !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.tstatType);
        /* string tstat_brand = 23; */
        if (message.tstatBrand !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.tstatBrand);
        /* string subcool = 24; */
        if (message.subcool !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.subcool);
        /* string filter_sizes = 25; */
        if (message.filterSizes !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.filterSizes);
        /* string superheat = 26; */
        if (message.superheat !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.superheat);
        /* string notes = 27; */
        if (message.notes !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.notes);
        /* string properties = 28; */
        if (message.properties !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.properties);
        /* string terms = 29; */
        if (message.terms !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.terms);
        /* string servicesperformedrow1 = 30; */
        if (message.servicesperformedrow1 !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.servicesperformedrow1);
        /* string totalamountrow1 = 31; */
        if (message.totalamountrow1 !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.totalamountrow1);
        /* string servicesperformedrow2 = 32; */
        if (message.servicesperformedrow2 !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.servicesperformedrow2);
        /* string totalamountrow2 = 33; */
        if (message.totalamountrow2 !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.totalamountrow2);
        /* string servicesperformedrow3 = 34; */
        if (message.servicesperformedrow3 !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.servicesperformedrow3);
        /* string totalamountrow3 = 35; */
        if (message.totalamountrow3 !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.totalamountrow3);
        /* string servicesperformedrow4 = 36; */
        if (message.servicesperformedrow4 !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.servicesperformedrow4);
        /* string totalamountrow4 = 37; */
        if (message.totalamountrow4 !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.totalamountrow4);
        /* string discount = 38; */
        if (message.discount !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.discount);
        /* string discountcost = 39; */
        if (message.discountcost !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.discountcost);
        /* string totalamounttotal = 40; */
        if (message.totalamounttotal !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.totalamounttotal);
        /* int32 credit = 41; */
        if (message.credit !== 0)
            writer.tag(41, WireType.Varint).int32(message.credit);
        /* int32 cash = 42; */
        if (message.cash !== 0)
            writer.tag(42, WireType.Varint).int32(message.cash);
        /* int32 by_check = 43; */
        if (message.byCheck !== 0)
            writer.tag(43, WireType.Varint).int32(message.byCheck);
        /* int32 billing = 44; */
        if (message.billing !== 0)
            writer.tag(44, WireType.Varint).int32(message.billing);
        /* int32 payment_yes = 45; */
        if (message.paymentYes !== 0)
            writer.tag(45, WireType.Varint).int32(message.paymentYes);
        /* int32 payment_no = 46; */
        if (message.paymentNo !== 0)
            writer.tag(46, WireType.Varint).int32(message.paymentNo);
        /* string service_item = 47; */
        if (message.serviceItem !== "")
            writer.tag(47, WireType.LengthDelimited).string(message.serviceItem);
        /* string log_payment_type = 48; */
        if (message.logPaymentType !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.logPaymentType);
        /* string log_payment_status = 49; */
        if (message.logPaymentStatus !== "")
            writer.tag(49, WireType.LengthDelimited).string(message.logPaymentStatus);
        /* int32 property_billing = 50; */
        if (message.propertyBilling !== 0)
            writer.tag(50, WireType.Varint).int32(message.propertyBilling);
        /* string material_used = 51; */
        if (message.materialUsed !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.materialUsed);
        /* string material_total = 52; */
        if (message.materialTotal !== "")
            writer.tag(52, WireType.LengthDelimited).string(message.materialTotal);
        /* repeated string field_mask = 53; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(53, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 54; */
        if (message.pageNumber !== 0)
            writer.tag(54, WireType.Varint).int32(message.pageNumber);
        /* int32 signature_file_id = 55; */
        if (message.signatureFileId !== 0)
            writer.tag(55, WireType.Varint).int32(message.signatureFileId);
        /* string signature_name = 56; */
        if (message.signatureName !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.signatureName);
        /* float tax = 57; */
        if (message.tax !== 0)
            writer.tag(57, WireType.Bit32).float(message.tax);
        /* float tax_cost = 58; */
        if (message.taxCost !== 0)
            writer.tag(58, WireType.Bit32).float(message.taxCost);
        /* int32 project_id = 59; */
        if (message.projectId !== 0)
            writer.tag(59, WireType.Varint).int32(message.projectId);
        /* double retainage = 60; */
        if (message.retainage !== 0)
            writer.tag(60, WireType.Bit64).double(message.retainage);
        /* string display_invoice_number = 61; */
        if (message.displayInvoiceNumber !== "")
            writer.tag(61, WireType.LengthDelimited).string(message.displayInvoiceNumber);
        /* string signature_override_note = 62 [deprecated = true]; */
        if (message.signatureOverrideNote !== "")
            writer.tag(62, WireType.LengthDelimited).string(message.signatureOverrideNote);
        /* string contract_id_list = 63; */
        if (message.contractIdList !== "")
            writer.tag(63, WireType.LengthDelimited).string(message.contractIdList);
        /* bool without_limit = 64; */
        if (message.withoutLimit !== false)
            writer.tag(64, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Invoice
 */
export const Invoice = new Invoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceList$Type extends MessageType {
    constructor() {
        super("InvoiceList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Invoice },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Invoice results */ 1:
                    message.results.push(Invoice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Invoice results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Invoice.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceList
 */
export const InvoiceList = new InvoiceList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SiLink$Type extends MessageType {
    constructor() {
        super("SiLink", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.serviceItemId = 0;
        message.url = "";
        message.description = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 service_item_id */ 2:
                    message.serviceItemId = reader.int32();
                    break;
                case /* string url */ 3:
                    message.url = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 service_item_id = 2; */
        if (message.serviceItemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.serviceItemId);
        /* string url = 3; */
        if (message.url !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.url);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SiLink
 */
export const SiLink = new SiLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SiLinkList$Type extends MessageType {
    constructor() {
        super("SiLinkList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SiLink },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SiLink results */ 1:
                    message.results.push(SiLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SiLink results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SiLink.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SiLinkList
 */
export const SiLinkList = new SiLinkList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractFrequency$Type extends MessageType {
    constructor() {
        super("ContractFrequency", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "maintenance_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.interval = 0;
        message.maintenanceCount = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.isActive = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 interval */ 3:
                    message.interval = reader.int32();
                    break;
                case /* int32 maintenance_count */ 4:
                    message.maintenanceCount = reader.int32();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 interval = 3; */
        if (message.interval !== 0)
            writer.tag(3, WireType.Varint).int32(message.interval);
        /* int32 maintenance_count = 4; */
        if (message.maintenanceCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.maintenanceCount);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractFrequency
 */
export const ContractFrequency = new ContractFrequency$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractFrequencyList$Type extends MessageType {
    constructor() {
        super("ContractFrequencyList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContractFrequency },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ContractFrequency results */ 1:
                    message.results.push(ContractFrequency.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ContractFrequency results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ContractFrequency.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractFrequencyList
 */
export const ContractFrequencyList = new ContractFrequencyList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobNumberRequest$Type extends MessageType {
    constructor() {
        super("JobNumberRequest", [
            { no: 1, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_number */ 1:
                    message.jobNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_number = 1; */
        if (message.jobNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobNumberRequest
 */
export const JobNumberRequest = new JobNumberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventDetails$Type extends MessageType {
    constructor() {
        super("EventDetails", [
            { no: 1, name: "event", kind: "message", T: () => Event },
            { no: 2, name: "property", kind: "message", T: () => Property },
            { no: 3, name: "customer", kind: "message", T: () => User },
            { no: 4, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobType },
            { no: 5, name: "job_subtypes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobSubtype },
            { no: 6, name: "job_types_subtypes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobTypeSubtype },
            { no: 7, name: "job_admins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobAdmin },
            { no: 8, name: "services_rendered", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicesRendered },
            { no: 9, name: "invoice", kind: "message", T: () => Invoice },
            { no: 10, name: "payment", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Payment },
            { no: 11, name: "property_event", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypes = [];
        message.jobSubtypes = [];
        message.jobTypesSubtypes = [];
        message.jobAdmins = [];
        message.servicesRendered = [];
        message.payment = [];
        message.propertyEvent = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event event */ 1:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* Property property */ 2:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* User customer */ 3:
                    message.customer = User.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* repeated JobType job_types */ 4:
                    message.jobTypes.push(JobType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated JobSubtype job_subtypes */ 5:
                    message.jobSubtypes.push(JobSubtype.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated JobTypeSubtype job_types_subtypes */ 6:
                    message.jobTypesSubtypes.push(JobTypeSubtype.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated JobAdmin job_admins */ 7:
                    message.jobAdmins.push(JobAdmin.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ServicesRendered services_rendered */ 8:
                    message.servicesRendered.push(ServicesRendered.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* Invoice invoice */ 9:
                    message.invoice = Invoice.internalBinaryRead(reader, reader.uint32(), options, message.invoice);
                    break;
                case /* repeated Payment payment */ 10:
                    message.payment.push(Payment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Event property_event */ 11:
                    message.propertyEvent.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event event = 1; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 2; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* User customer = 3; */
        if (message.customer)
            User.internalBinaryWrite(message.customer, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated JobType job_types = 4; */
        for (let i = 0; i < message.jobTypes.length; i++)
            JobType.internalBinaryWrite(message.jobTypes[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated JobSubtype job_subtypes = 5; */
        for (let i = 0; i < message.jobSubtypes.length; i++)
            JobSubtype.internalBinaryWrite(message.jobSubtypes[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated JobTypeSubtype job_types_subtypes = 6; */
        for (let i = 0; i < message.jobTypesSubtypes.length; i++)
            JobTypeSubtype.internalBinaryWrite(message.jobTypesSubtypes[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated JobAdmin job_admins = 7; */
        for (let i = 0; i < message.jobAdmins.length; i++)
            JobAdmin.internalBinaryWrite(message.jobAdmins[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated ServicesRendered services_rendered = 8; */
        for (let i = 0; i < message.servicesRendered.length; i++)
            ServicesRendered.internalBinaryWrite(message.servicesRendered[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* Invoice invoice = 9; */
        if (message.invoice)
            Invoice.internalBinaryWrite(message.invoice, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated Payment payment = 10; */
        for (let i = 0; i < message.payment.length; i++)
            Payment.internalBinaryWrite(message.payment[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event property_event = 11; */
        for (let i = 0; i < message.propertyEvent.length; i++)
            Event.internalBinaryWrite(message.propertyEvent[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventDetails
 */
export const EventDetails = new EventDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Contract$Type extends MessageType {
    constructor() {
        super("Contract", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "properties", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "frequency", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "group_billing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "payment_terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "time_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "contract_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "review_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "sold_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "welcome_call_due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "welcome_call_completed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "billing_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "helcim_subscription_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "renewed_from_contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.number = "";
        message.properties = "";
        message.dateCreated = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.frequency = 0;
        message.groupBilling = 0;
        message.paymentStatus = "";
        message.paymentTerms = "";
        message.notes = "";
        message.paymentType = "";
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.dateTarget = [];
        message.dateRange = [];
        message.lastName = "";
        message.businessName = "";
        message.departmentId = 0;
        message.timeStarted = "";
        message.timeEnded = "";
        message.withoutLimit = false;
        message.contractIdList = "";
        message.reviewStatus = "";
        message.poNumber = "";
        message.soldByUserId = 0;
        message.welcomeCallDueDate = "";
        message.welcomeCallCompletedAt = "";
        message.billingTypeId = 0;
        message.helcimSubscriptionId = 0;
        message.renewedFromContractId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string number */ 3:
                    message.number = reader.string();
                    break;
                case /* string properties */ 4:
                    message.properties = reader.string();
                    break;
                case /* string date_created */ 5:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_started */ 6:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 7:
                    message.dateEnded = reader.string();
                    break;
                case /* int32 frequency */ 8:
                    message.frequency = reader.int32();
                    break;
                case /* int32 group_billing */ 9:
                    message.groupBilling = reader.int32();
                    break;
                case /* string payment_status */ 10:
                    message.paymentStatus = reader.string();
                    break;
                case /* string payment_terms */ 11:
                    message.paymentTerms = reader.string();
                    break;
                case /* string notes */ 12:
                    message.notes = reader.string();
                    break;
                case /* string payment_type */ 13:
                    message.paymentType = reader.string();
                    break;
                case /* int32 is_active */ 14:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 15:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 16:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_target */ 19:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 20:
                    message.dateRange.push(reader.string());
                    break;
                case /* string last_name */ 21:
                    message.lastName = reader.string();
                    break;
                case /* string business_name */ 22:
                    message.businessName = reader.string();
                    break;
                case /* int32 department_id */ 23:
                    message.departmentId = reader.int32();
                    break;
                case /* string time_started */ 24:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_ended */ 25:
                    message.timeEnded = reader.string();
                    break;
                case /* bool without_limit */ 26:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string contract_id_list */ 27:
                    message.contractIdList = reader.string();
                    break;
                case /* string review_status */ 28:
                    message.reviewStatus = reader.string();
                    break;
                case /* string po_number */ 29:
                    message.poNumber = reader.string();
                    break;
                case /* int32 sold_by_user_id */ 30:
                    message.soldByUserId = reader.int32();
                    break;
                case /* string welcome_call_due_date */ 31:
                    message.welcomeCallDueDate = reader.string();
                    break;
                case /* string welcome_call_completed_at */ 32:
                    message.welcomeCallCompletedAt = reader.string();
                    break;
                case /* int32 billing_type_id */ 33:
                    message.billingTypeId = reader.int32();
                    break;
                case /* int32 helcim_subscription_id */ 34:
                    message.helcimSubscriptionId = reader.int32();
                    break;
                case /* int32 renewed_from_contract_id */ 35:
                    message.renewedFromContractId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string number = 3; */
        if (message.number !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.number);
        /* string properties = 4; */
        if (message.properties !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.properties);
        /* string date_created = 5; */
        if (message.dateCreated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_started = 6; */
        if (message.dateStarted !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 7; */
        if (message.dateEnded !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateEnded);
        /* int32 frequency = 8; */
        if (message.frequency !== 0)
            writer.tag(8, WireType.Varint).int32(message.frequency);
        /* int32 group_billing = 9; */
        if (message.groupBilling !== 0)
            writer.tag(9, WireType.Varint).int32(message.groupBilling);
        /* string payment_status = 10; */
        if (message.paymentStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.paymentStatus);
        /* string payment_terms = 11; */
        if (message.paymentTerms !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.paymentTerms);
        /* string notes = 12; */
        if (message.notes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.notes);
        /* string payment_type = 13; */
        if (message.paymentType !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.paymentType);
        /* int32 is_active = 14; */
        if (message.isActive !== 0)
            writer.tag(14, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 15; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 16; */
        if (message.pageNumber !== 0)
            writer.tag(16, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_target = 19; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string date_range = 20; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.dateRange[i]);
        /* string last_name = 21; */
        if (message.lastName !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.lastName);
        /* string business_name = 22; */
        if (message.businessName !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.businessName);
        /* int32 department_id = 23; */
        if (message.departmentId !== 0)
            writer.tag(23, WireType.Varint).int32(message.departmentId);
        /* string time_started = 24; */
        if (message.timeStarted !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_ended = 25; */
        if (message.timeEnded !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.timeEnded);
        /* bool without_limit = 26; */
        if (message.withoutLimit !== false)
            writer.tag(26, WireType.Varint).bool(message.withoutLimit);
        /* string contract_id_list = 27; */
        if (message.contractIdList !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.contractIdList);
        /* string review_status = 28; */
        if (message.reviewStatus !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.reviewStatus);
        /* string po_number = 29; */
        if (message.poNumber !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.poNumber);
        /* int32 sold_by_user_id = 30; */
        if (message.soldByUserId !== 0)
            writer.tag(30, WireType.Varint).int32(message.soldByUserId);
        /* string welcome_call_due_date = 31; */
        if (message.welcomeCallDueDate !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.welcomeCallDueDate);
        /* string welcome_call_completed_at = 32; */
        if (message.welcomeCallCompletedAt !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.welcomeCallCompletedAt);
        /* int32 billing_type_id = 33; */
        if (message.billingTypeId !== 0)
            writer.tag(33, WireType.Varint).int32(message.billingTypeId);
        /* int32 helcim_subscription_id = 34; */
        if (message.helcimSubscriptionId !== 0)
            writer.tag(34, WireType.Varint).int32(message.helcimSubscriptionId);
        /* int32 renewed_from_contract_id = 35; */
        if (message.renewedFromContractId !== 0)
            writer.tag(35, WireType.Varint).int32(message.renewedFromContractId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Contract
 */
export const Contract = new Contract$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompleteWelcomeCallRequest$Type extends MessageType {
    constructor() {
        super("CompleteWelcomeCallRequest", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.completed = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* bool completed */ 2:
                    message.completed = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* bool completed = 2; */
        if (message.completed !== false)
            writer.tag(2, WireType.Varint).bool(message.completed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CompleteWelcomeCallRequest
 */
export const CompleteWelcomeCallRequest = new CompleteWelcomeCallRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateContractSubscriptionReq$Type extends MessageType {
    constructor() {
        super("CreateContractSubscriptionReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "date_activated", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.invoiceId = 0;
        message.dateActivated = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* int32 invoice_id */ 2:
                    message.invoiceId = reader.int32();
                    break;
                case /* string date_activated */ 3:
                    message.dateActivated = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* int32 invoice_id = 2; */
        if (message.invoiceId !== 0)
            writer.tag(2, WireType.Varint).int32(message.invoiceId);
        /* string date_activated = 3; */
        if (message.dateActivated !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dateActivated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateContractSubscriptionReq
 */
export const CreateContractSubscriptionReq = new CreateContractSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelContractSubscriptionReq$Type extends MessageType {
    constructor() {
        super("CancelContractSubscriptionReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelContractSubscriptionReq
 */
export const CancelContractSubscriptionReq = new CancelContractSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurgeContractReq$Type extends MessageType {
    constructor() {
        super("PurgeContractReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurgeContractReq
 */
export const PurgeContractReq = new PurgeContractReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurgeContractPreview$Type extends MessageType {
    constructor() {
        super("PurgeContractPreview", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "jobs_to_hide", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "filter_orders_to_cancel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "memberships_to_deactivate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "paid_invoices", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "subscription_to_cancel", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.jobsToHide = 0;
        message.filterOrdersToCancel = 0;
        message.membershipsToDeactivate = 0;
        message.paidInvoices = 0;
        message.subscriptionToCancel = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* int32 jobs_to_hide */ 2:
                    message.jobsToHide = reader.int32();
                    break;
                case /* int32 filter_orders_to_cancel */ 3:
                    message.filterOrdersToCancel = reader.int32();
                    break;
                case /* int32 memberships_to_deactivate */ 4:
                    message.membershipsToDeactivate = reader.int32();
                    break;
                case /* int32 paid_invoices */ 5:
                    message.paidInvoices = reader.int32();
                    break;
                case /* bool subscription_to_cancel */ 6:
                    message.subscriptionToCancel = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* int32 jobs_to_hide = 2; */
        if (message.jobsToHide !== 0)
            writer.tag(2, WireType.Varint).int32(message.jobsToHide);
        /* int32 filter_orders_to_cancel = 3; */
        if (message.filterOrdersToCancel !== 0)
            writer.tag(3, WireType.Varint).int32(message.filterOrdersToCancel);
        /* int32 memberships_to_deactivate = 4; */
        if (message.membershipsToDeactivate !== 0)
            writer.tag(4, WireType.Varint).int32(message.membershipsToDeactivate);
        /* int32 paid_invoices = 5; */
        if (message.paidInvoices !== 0)
            writer.tag(5, WireType.Varint).int32(message.paidInvoices);
        /* bool subscription_to_cancel = 6; */
        if (message.subscriptionToCancel !== false)
            writer.tag(6, WireType.Varint).bool(message.subscriptionToCancel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurgeContractPreview
 */
export const PurgeContractPreview = new PurgeContractPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenewContractReq$Type extends MessageType {
    constructor() {
        super("RenewContractReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount_collected", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "cheque_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "bank_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.paymentType = "";
        message.amountCollected = 0;
        message.chequeNumber = "";
        message.bankName = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* string payment_type */ 2:
                    message.paymentType = reader.string();
                    break;
                case /* double amount_collected */ 3:
                    message.amountCollected = reader.double();
                    break;
                case /* string cheque_number */ 4:
                    message.chequeNumber = reader.string();
                    break;
                case /* string bank_name */ 5:
                    message.bankName = reader.string();
                    break;
                case /* string notes */ 6:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* string payment_type = 2; */
        if (message.paymentType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentType);
        /* double amount_collected = 3; */
        if (message.amountCollected !== 0)
            writer.tag(3, WireType.Bit64).double(message.amountCollected);
        /* string cheque_number = 4; */
        if (message.chequeNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.chequeNumber);
        /* string bank_name = 5; */
        if (message.bankName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bankName);
        /* string notes = 6; */
        if (message.notes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RenewContractReq
 */
export const RenewContractReq = new RenewContractReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UndoContractRenewalReq$Type extends MessageType {
    constructor() {
        super("UndoContractRenewalReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UndoContractRenewalReq
 */
export const UndoContractRenewalReq = new UndoContractRenewalReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractMaterial$Type extends MessageType {
    constructor() {
        super("ContractMaterial", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "serviceItem_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "material_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "material_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "material_partNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "material_vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "material_quantity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.serviceItemId = 0;
        message.materialId = 0;
        message.materialName = "";
        message.materialPartNumber = "";
        message.materialVendor = "";
        message.materialQuantity = "";
        message.propertyId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* string property_address */ 2:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 3:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 4:
                    message.propertyState = reader.string();
                    break;
                case /* int32 serviceItem_id */ 5:
                    message.serviceItemId = reader.int32();
                    break;
                case /* int32 material_id */ 6:
                    message.materialId = reader.int32();
                    break;
                case /* string material_name */ 7:
                    message.materialName = reader.string();
                    break;
                case /* string material_partNumber */ 8:
                    message.materialPartNumber = reader.string();
                    break;
                case /* string material_vendor */ 9:
                    message.materialVendor = reader.string();
                    break;
                case /* string material_quantity */ 10:
                    message.materialQuantity = reader.string();
                    break;
                case /* int32 property_id */ 11:
                    message.propertyId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* string property_address = 2; */
        if (message.propertyAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 3; */
        if (message.propertyCity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 4; */
        if (message.propertyState !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.propertyState);
        /* int32 serviceItem_id = 5; */
        if (message.serviceItemId !== 0)
            writer.tag(5, WireType.Varint).int32(message.serviceItemId);
        /* int32 material_id = 6; */
        if (message.materialId !== 0)
            writer.tag(6, WireType.Varint).int32(message.materialId);
        /* string material_name = 7; */
        if (message.materialName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.materialName);
        /* string material_partNumber = 8; */
        if (message.materialPartNumber !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.materialPartNumber);
        /* string material_vendor = 9; */
        if (message.materialVendor !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.materialVendor);
        /* string material_quantity = 10; */
        if (message.materialQuantity !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.materialQuantity);
        /* int32 property_id = 11; */
        if (message.propertyId !== 0)
            writer.tag(11, WireType.Varint).int32(message.propertyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractMaterial
 */
export const ContractMaterial = new ContractMaterial$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractMaterialList$Type extends MessageType {
    constructor() {
        super("ContractMaterialList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContractMaterial },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ContractMaterial results */ 1:
                    message.results.push(ContractMaterial.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ContractMaterial results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ContractMaterial.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractMaterialList
 */
export const ContractMaterialList = new ContractMaterialList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractList$Type extends MessageType {
    constructor() {
        super("ContractList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Contract },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Contract results */ 1:
                    message.results.push(Contract.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Contract results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Contract.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractList
 */
export const ContractList = new ContractList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestPropertyRequest$Type extends MessageType {
    constructor() {
        super("ClosestPropertyRequest", [
            { no: 1, name: "coords", kind: "message", T: () => LatLng },
            { no: 2, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.timestamp = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* LatLng coords */ 1:
                    message.coords = LatLng.internalBinaryRead(reader, reader.uint32(), options, message.coords);
                    break;
                case /* string timestamp */ 2:
                    message.timestamp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* LatLng coords = 1; */
        if (message.coords)
            LatLng.internalBinaryWrite(message.coords, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string timestamp = 2; */
        if (message.timestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClosestPropertyRequest
 */
export const ClosestPropertyRequest = new ClosestPropertyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestPropertyResult$Type extends MessageType {
    constructor() {
        super("ClosestPropertyResult", [
            { no: 1, name: "property", kind: "message", T: () => Property },
            { no: 2, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.events = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Property property */ 1:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* repeated Event events */ 2:
                    message.events.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Property property = 1; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event events = 2; */
        for (let i = 0; i < message.events.length; i++)
            Event.internalBinaryWrite(message.events[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClosestPropertyResult
 */
export const ClosestPropertyResult = new ClosestPropertyResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Event$Type extends MessageType {
    constructor() {
        super("Event", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "time_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_all_day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "repeat_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "contract_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "log_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "log_job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "log_po", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "log_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "log_technician_assigned", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "log_date_completed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "log_materials_used", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "log_service_rendered", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "log_tech_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "log_billing_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "log_amount_charged", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "log_payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "log_payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "log_time_in", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "log_time_out", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "log_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "log_contract_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "invoice_service_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "tstat_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "tstat_brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "compressor_amps", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "condensing_fan_amps", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "suction_pressure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "head_pressure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "return_temperature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "supply_temperature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "subcool", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "superheat", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "services", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "servicesperformedrow1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "totalamountrow1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "servicesperformedrow2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "totalamountrow2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 50, name: "servicesperformedrow3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 51, name: "totalamountrow3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 52, name: "servicesperformedrow4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "totalamountrow4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 54, name: "discount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 55, name: "discountcost", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "log_notification", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "diagnostic_quoted", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 58, name: "amount_quoted", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 59, name: "property_billing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "is_callback", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 61, name: "log_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 62, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 63, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 64, name: "callback_original_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 65, name: "callback_disposition", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 66, name: "callback_comments", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 67, name: "callback_technician", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 68, name: "callback_approval_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 69, name: "callback_comment_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 70, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 71, name: "material_used", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 72, name: "material_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 73, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 74, name: "parent_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 75, name: "is_lmpc", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 76, name: "high_priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 77, name: "is_residential", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 78, name: "job_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 79, name: "job_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 80, name: "customer", kind: "message", T: () => User },
            { no: 81, name: "property", kind: "message", T: () => Property },
            { no: 82, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 83, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 84, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 85, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 89, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 86, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 87, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 88, name: "quote_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Quotable },
            { no: 90, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 91, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 92, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 93, name: "is_generated_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 94, name: "only_events", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 95, name: "job_admin", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobAdmin },
            { no: 96, name: "job_admin_search", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 97, name: "callback_user_ids", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 98, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "sold_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 100, name: "lead_generated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 101, name: "quote_expire_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 102, name: "summary_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 103, name: "is_project", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 104, name: "job_mode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 105, name: "total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 106, name: "unity_build_contract_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 107, name: "project_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 108, name: "project_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 109, name: "project_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 110, name: "is_unity_sync_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 111, name: "tax", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 112, name: "tax_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 113, name: "manual_percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 114, name: "is_window_block", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 115, name: "is_new_customer", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 116, name: "quote_pending", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 118, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 119, name: "public_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 120, name: "assigned_csr_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 121, name: "service_channel_wo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 122, name: "sla_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 123, name: "customer_priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 124, name: "schedule_confidence", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 125, name: "follow_up_owner_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 126, name: "next_follow_up_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 127, name: "cancel_protected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 128, name: "acknowledged_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 129, name: "acknowledged_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 130, name: "pending_billing_queue", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 131, name: "is_project_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 132, name: "is_outside_service_area", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 133, name: "is_waitlisted", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 134, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.description = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.timeStarted = "";
        message.timeEnded = "";
        message.isAllDay = 0;
        message.repeatType = 0;
        message.color = "";
        message.dateUpdated = "";
        message.dateCreated = "";
        message.propertyId = 0;
        message.contractId = 0;
        message.contractNumber = "";
        message.logJobNumber = "";
        message.logJobStatus = "";
        message.logPo = "";
        message.logNotes = "";
        message.logTechnicianAssigned = "";
        message.logDateCompleted = "";
        message.logMaterialsUsed = "";
        message.logServiceRendered = "";
        message.logTechNotes = "";
        message.logBillingDate = "";
        message.logAmountCharged = "";
        message.logPaymentType = "";
        message.logPaymentStatus = "";
        message.logTimeIn = "";
        message.logTimeOut = "";
        message.logType = "";
        message.logContractNotes = "";
        message.invoiceServiceItem = "";
        message.tstatType = "";
        message.tstatBrand = "";
        message.compressorAmps = "";
        message.condensingFanAmps = "";
        message.suctionPressure = "";
        message.headPressure = "";
        message.returnTemperature = "";
        message.supplyTemperature = "";
        message.subcool = "";
        message.superheat = "";
        message.notes = "";
        message.services = "";
        message.servicesperformedrow1 = "";
        message.totalamountrow1 = "";
        message.servicesperformedrow2 = "";
        message.totalamountrow2 = "";
        message.servicesperformedrow3 = "";
        message.totalamountrow3 = "";
        message.servicesperformedrow4 = "";
        message.totalamountrow4 = "";
        message.discount = "";
        message.discountcost = "";
        message.logNotification = "";
        message.diagnosticQuoted = 0;
        message.amountQuoted = "";
        message.propertyBilling = 0;
        message.isCallback = 0;
        message.logVersion = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.callbackOriginalId = 0;
        message.callbackDisposition = 0;
        message.callbackComments = "";
        message.callbackTechnician = 0;
        message.callbackApprovalTimestamp = "";
        message.callbackCommentBy = 0;
        message.documentId = 0;
        message.materialUsed = "";
        message.materialTotal = 0;
        message.isActive = 0;
        message.parentId = 0;
        message.isLmpc = 0;
        message.highPriority = 0;
        message.isResidential = 0;
        message.jobType = "";
        message.jobSubtype = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.dateTarget = [];
        message.dateRange = [];
        message.countOnly = false;
        message.quoteData = [];
        message.departmentId = 0;
        message.notEquals = [];
        message.withoutLimit = false;
        message.isGeneratedInvoice = false;
        message.onlyEvents = false;
        message.jobAdmin = [];
        message.jobAdminSearch = 0;
        message.callbackUserIds = "";
        message.idList = "";
        message.soldBy = 0;
        message.leadGeneratedBy = 0;
        message.quoteExpireDate = "";
        message.summaryId = "";
        message.isProject = false;
        message.jobMode = "";
        message.totalBudget = 0;
        message.unityBuildContractId = "";
        message.projectStartDate = "";
        message.projectEndDate = "";
        message.projectStatus = "";
        message.isUnitySyncEnabled = false;
        message.tax = 0;
        message.taxCost = 0;
        message.manualPercentComplete = 0;
        message.isWindowBlock = 0;
        message.isNewCustomer = 0;
        message.quotePending = false;
        message.membershipId = 0;
        message.publicId = "";
        message.assignedCsrUserId = 0;
        message.serviceChannelWo = "";
        message.slaDue = "";
        message.customerPriorityId = 0;
        message.scheduleConfidence = "";
        message.followUpOwnerId = 0;
        message.nextFollowUpDate = "";
        message.cancelProtected = false;
        message.acknowledgedBy = 0;
        message.acknowledgedDate = "";
        message.pendingBillingQueue = false;
        message.isProjectPrimary = false;
        message.isOutsideServiceArea = 0;
        message.isWaitlisted = 0;
        message.eventTradeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string date_started */ 4:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 5:
                    message.dateEnded = reader.string();
                    break;
                case /* string time_started */ 6:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_ended */ 7:
                    message.timeEnded = reader.string();
                    break;
                case /* int32 is_all_day */ 8:
                    message.isAllDay = reader.int32();
                    break;
                case /* int32 repeat_type */ 9:
                    message.repeatType = reader.int32();
                    break;
                case /* string color */ 10:
                    message.color = reader.string();
                    break;
                case /* string date_updated */ 11:
                    message.dateUpdated = reader.string();
                    break;
                case /* string date_created */ 12:
                    message.dateCreated = reader.string();
                    break;
                case /* int32 property_id */ 13:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 contract_id */ 14:
                    message.contractId = reader.int32();
                    break;
                case /* string contract_number */ 15:
                    message.contractNumber = reader.string();
                    break;
                case /* string log_job_number */ 16:
                    message.logJobNumber = reader.string();
                    break;
                case /* string log_job_status */ 17:
                    message.logJobStatus = reader.string();
                    break;
                case /* string log_po */ 18:
                    message.logPo = reader.string();
                    break;
                case /* string log_notes */ 19:
                    message.logNotes = reader.string();
                    break;
                case /* string log_technician_assigned */ 20:
                    message.logTechnicianAssigned = reader.string();
                    break;
                case /* string log_date_completed */ 21:
                    message.logDateCompleted = reader.string();
                    break;
                case /* string log_materials_used */ 22:
                    message.logMaterialsUsed = reader.string();
                    break;
                case /* string log_service_rendered */ 23:
                    message.logServiceRendered = reader.string();
                    break;
                case /* string log_tech_notes */ 24:
                    message.logTechNotes = reader.string();
                    break;
                case /* string log_billing_date */ 25:
                    message.logBillingDate = reader.string();
                    break;
                case /* string log_amount_charged */ 26:
                    message.logAmountCharged = reader.string();
                    break;
                case /* string log_payment_type */ 27:
                    message.logPaymentType = reader.string();
                    break;
                case /* string log_payment_status */ 28:
                    message.logPaymentStatus = reader.string();
                    break;
                case /* string log_time_in */ 29:
                    message.logTimeIn = reader.string();
                    break;
                case /* string log_time_out */ 30:
                    message.logTimeOut = reader.string();
                    break;
                case /* string log_type */ 31:
                    message.logType = reader.string();
                    break;
                case /* string log_contract_notes */ 32:
                    message.logContractNotes = reader.string();
                    break;
                case /* string invoice_service_item */ 33:
                    message.invoiceServiceItem = reader.string();
                    break;
                case /* string tstat_type */ 34:
                    message.tstatType = reader.string();
                    break;
                case /* string tstat_brand */ 35:
                    message.tstatBrand = reader.string();
                    break;
                case /* string compressor_amps */ 36:
                    message.compressorAmps = reader.string();
                    break;
                case /* string condensing_fan_amps */ 37:
                    message.condensingFanAmps = reader.string();
                    break;
                case /* string suction_pressure */ 38:
                    message.suctionPressure = reader.string();
                    break;
                case /* string head_pressure */ 39:
                    message.headPressure = reader.string();
                    break;
                case /* string return_temperature */ 40:
                    message.returnTemperature = reader.string();
                    break;
                case /* string supply_temperature */ 41:
                    message.supplyTemperature = reader.string();
                    break;
                case /* string subcool */ 42:
                    message.subcool = reader.string();
                    break;
                case /* string superheat */ 43:
                    message.superheat = reader.string();
                    break;
                case /* string notes */ 44:
                    message.notes = reader.string();
                    break;
                case /* string services */ 45:
                    message.services = reader.string();
                    break;
                case /* string servicesperformedrow1 */ 46:
                    message.servicesperformedrow1 = reader.string();
                    break;
                case /* string totalamountrow1 */ 47:
                    message.totalamountrow1 = reader.string();
                    break;
                case /* string servicesperformedrow2 */ 48:
                    message.servicesperformedrow2 = reader.string();
                    break;
                case /* string totalamountrow2 */ 49:
                    message.totalamountrow2 = reader.string();
                    break;
                case /* string servicesperformedrow3 */ 50:
                    message.servicesperformedrow3 = reader.string();
                    break;
                case /* string totalamountrow3 */ 51:
                    message.totalamountrow3 = reader.string();
                    break;
                case /* string servicesperformedrow4 */ 52:
                    message.servicesperformedrow4 = reader.string();
                    break;
                case /* string totalamountrow4 */ 53:
                    message.totalamountrow4 = reader.string();
                    break;
                case /* string discount */ 54:
                    message.discount = reader.string();
                    break;
                case /* string discountcost */ 55:
                    message.discountcost = reader.string();
                    break;
                case /* string log_notification */ 56:
                    message.logNotification = reader.string();
                    break;
                case /* int32 diagnostic_quoted */ 57:
                    message.diagnosticQuoted = reader.int32();
                    break;
                case /* string amount_quoted */ 58:
                    message.amountQuoted = reader.string();
                    break;
                case /* int32 property_billing */ 59:
                    message.propertyBilling = reader.int32();
                    break;
                case /* int32 is_callback */ 60:
                    message.isCallback = reader.int32();
                    break;
                case /* int32 log_version */ 61:
                    message.logVersion = reader.int32();
                    break;
                case /* int32 job_type_id */ 62:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 63:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* int32 callback_original_id */ 64:
                    message.callbackOriginalId = reader.int32();
                    break;
                case /* int32 callback_disposition */ 65:
                    message.callbackDisposition = reader.int32();
                    break;
                case /* string callback_comments */ 66:
                    message.callbackComments = reader.string();
                    break;
                case /* int32 callback_technician */ 67:
                    message.callbackTechnician = reader.int32();
                    break;
                case /* string callback_approval_timestamp */ 68:
                    message.callbackApprovalTimestamp = reader.string();
                    break;
                case /* int32 callback_comment_by */ 69:
                    message.callbackCommentBy = reader.int32();
                    break;
                case /* int32 document_id */ 70:
                    message.documentId = reader.int32();
                    break;
                case /* string material_used */ 71:
                    message.materialUsed = reader.string();
                    break;
                case /* double material_total */ 72:
                    message.materialTotal = reader.double();
                    break;
                case /* int32 is_active */ 73:
                    message.isActive = reader.int32();
                    break;
                case /* int32 parent_id */ 74:
                    message.parentId = reader.int32();
                    break;
                case /* int32 is_lmpc */ 75:
                    message.isLmpc = reader.int32();
                    break;
                case /* int32 high_priority */ 76:
                    message.highPriority = reader.int32();
                    break;
                case /* int32 is_residential */ 77:
                    message.isResidential = reader.int32();
                    break;
                case /* string job_type */ 78:
                    message.jobType = reader.string();
                    break;
                case /* string job_subtype */ 79:
                    message.jobSubtype = reader.string();
                    break;
                case /* User customer */ 80:
                    message.customer = User.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* Property property */ 81:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* repeated string field_mask */ 82:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 83:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 84:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 85:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_target */ 89:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 86:
                    message.dateRange.push(reader.string());
                    break;
                case /* bool count_only */ 87:
                    message.countOnly = reader.bool();
                    break;
                case /* repeated Quotable quote_data */ 88:
                    message.quoteData.push(Quotable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 department_id */ 90:
                    message.departmentId = reader.int32();
                    break;
                case /* repeated string not_equals */ 91:
                    message.notEquals.push(reader.string());
                    break;
                case /* bool without_limit */ 92:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool is_generated_invoice */ 93:
                    message.isGeneratedInvoice = reader.bool();
                    break;
                case /* bool only_events */ 94:
                    message.onlyEvents = reader.bool();
                    break;
                case /* repeated JobAdmin job_admin */ 95:
                    message.jobAdmin.push(JobAdmin.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 job_admin_search */ 96:
                    message.jobAdminSearch = reader.int32();
                    break;
                case /* string callback_user_ids */ 97:
                    message.callbackUserIds = reader.string();
                    break;
                case /* string id_list */ 98:
                    message.idList = reader.string();
                    break;
                case /* int32 sold_by */ 99:
                    message.soldBy = reader.int32();
                    break;
                case /* int32 lead_generated_by */ 100:
                    message.leadGeneratedBy = reader.int32();
                    break;
                case /* string quote_expire_date */ 101:
                    message.quoteExpireDate = reader.string();
                    break;
                case /* string summary_id */ 102:
                    message.summaryId = reader.string();
                    break;
                case /* bool is_project */ 103:
                    message.isProject = reader.bool();
                    break;
                case /* string job_mode */ 104:
                    message.jobMode = reader.string();
                    break;
                case /* double total_budget */ 105:
                    message.totalBudget = reader.double();
                    break;
                case /* string unity_build_contract_id */ 106:
                    message.unityBuildContractId = reader.string();
                    break;
                case /* string project_start_date */ 107:
                    message.projectStartDate = reader.string();
                    break;
                case /* string project_end_date */ 108:
                    message.projectEndDate = reader.string();
                    break;
                case /* string project_status */ 109:
                    message.projectStatus = reader.string();
                    break;
                case /* bool is_unity_sync_enabled */ 110:
                    message.isUnitySyncEnabled = reader.bool();
                    break;
                case /* float tax */ 111:
                    message.tax = reader.float();
                    break;
                case /* float tax_cost */ 112:
                    message.taxCost = reader.float();
                    break;
                case /* double manual_percent_complete */ 113:
                    message.manualPercentComplete = reader.double();
                    break;
                case /* int32 is_window_block */ 114:
                    message.isWindowBlock = reader.int32();
                    break;
                case /* int32 is_new_customer */ 115:
                    message.isNewCustomer = reader.int32();
                    break;
                case /* bool quote_pending */ 116:
                    message.quotePending = reader.bool();
                    break;
                case /* int32 membership_id */ 118:
                    message.membershipId = reader.int32();
                    break;
                case /* string public_id */ 119:
                    message.publicId = reader.string();
                    break;
                case /* int32 assigned_csr_user_id */ 120:
                    message.assignedCsrUserId = reader.int32();
                    break;
                case /* string service_channel_wo */ 121:
                    message.serviceChannelWo = reader.string();
                    break;
                case /* string sla_due */ 122:
                    message.slaDue = reader.string();
                    break;
                case /* int32 customer_priority_id */ 123:
                    message.customerPriorityId = reader.int32();
                    break;
                case /* string schedule_confidence */ 124:
                    message.scheduleConfidence = reader.string();
                    break;
                case /* int32 follow_up_owner_id */ 125:
                    message.followUpOwnerId = reader.int32();
                    break;
                case /* string next_follow_up_date */ 126:
                    message.nextFollowUpDate = reader.string();
                    break;
                case /* bool cancel_protected */ 127:
                    message.cancelProtected = reader.bool();
                    break;
                case /* int32 acknowledged_by */ 128:
                    message.acknowledgedBy = reader.int32();
                    break;
                case /* string acknowledged_date */ 129:
                    message.acknowledgedDate = reader.string();
                    break;
                case /* bool pending_billing_queue */ 130:
                    message.pendingBillingQueue = reader.bool();
                    break;
                case /* bool is_project_primary */ 131:
                    message.isProjectPrimary = reader.bool();
                    break;
                case /* int32 is_outside_service_area */ 132:
                    message.isOutsideServiceArea = reader.int32();
                    break;
                case /* int32 is_waitlisted */ 133:
                    message.isWaitlisted = reader.int32();
                    break;
                case /* int32 event_trade_id */ 134:
                    message.eventTradeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string date_started = 4; */
        if (message.dateStarted !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 5; */
        if (message.dateEnded !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateEnded);
        /* string time_started = 6; */
        if (message.timeStarted !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_ended = 7; */
        if (message.timeEnded !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.timeEnded);
        /* int32 is_all_day = 8; */
        if (message.isAllDay !== 0)
            writer.tag(8, WireType.Varint).int32(message.isAllDay);
        /* int32 repeat_type = 9; */
        if (message.repeatType !== 0)
            writer.tag(9, WireType.Varint).int32(message.repeatType);
        /* string color = 10; */
        if (message.color !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.color);
        /* string date_updated = 11; */
        if (message.dateUpdated !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateUpdated);
        /* string date_created = 12; */
        if (message.dateCreated !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.dateCreated);
        /* int32 property_id = 13; */
        if (message.propertyId !== 0)
            writer.tag(13, WireType.Varint).int32(message.propertyId);
        /* int32 contract_id = 14; */
        if (message.contractId !== 0)
            writer.tag(14, WireType.Varint).int32(message.contractId);
        /* string contract_number = 15; */
        if (message.contractNumber !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.contractNumber);
        /* string log_job_number = 16; */
        if (message.logJobNumber !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.logJobNumber);
        /* string log_job_status = 17; */
        if (message.logJobStatus !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.logJobStatus);
        /* string log_po = 18; */
        if (message.logPo !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.logPo);
        /* string log_notes = 19; */
        if (message.logNotes !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.logNotes);
        /* string log_technician_assigned = 20; */
        if (message.logTechnicianAssigned !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.logTechnicianAssigned);
        /* string log_date_completed = 21; */
        if (message.logDateCompleted !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.logDateCompleted);
        /* string log_materials_used = 22; */
        if (message.logMaterialsUsed !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.logMaterialsUsed);
        /* string log_service_rendered = 23; */
        if (message.logServiceRendered !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.logServiceRendered);
        /* string log_tech_notes = 24; */
        if (message.logTechNotes !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.logTechNotes);
        /* string log_billing_date = 25; */
        if (message.logBillingDate !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.logBillingDate);
        /* string log_amount_charged = 26; */
        if (message.logAmountCharged !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.logAmountCharged);
        /* string log_payment_type = 27; */
        if (message.logPaymentType !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.logPaymentType);
        /* string log_payment_status = 28; */
        if (message.logPaymentStatus !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.logPaymentStatus);
        /* string log_time_in = 29; */
        if (message.logTimeIn !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.logTimeIn);
        /* string log_time_out = 30; */
        if (message.logTimeOut !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.logTimeOut);
        /* string log_type = 31; */
        if (message.logType !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.logType);
        /* string log_contract_notes = 32; */
        if (message.logContractNotes !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.logContractNotes);
        /* string invoice_service_item = 33; */
        if (message.invoiceServiceItem !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.invoiceServiceItem);
        /* string tstat_type = 34; */
        if (message.tstatType !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.tstatType);
        /* string tstat_brand = 35; */
        if (message.tstatBrand !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.tstatBrand);
        /* string compressor_amps = 36; */
        if (message.compressorAmps !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.compressorAmps);
        /* string condensing_fan_amps = 37; */
        if (message.condensingFanAmps !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.condensingFanAmps);
        /* string suction_pressure = 38; */
        if (message.suctionPressure !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.suctionPressure);
        /* string head_pressure = 39; */
        if (message.headPressure !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.headPressure);
        /* string return_temperature = 40; */
        if (message.returnTemperature !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.returnTemperature);
        /* string supply_temperature = 41; */
        if (message.supplyTemperature !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.supplyTemperature);
        /* string subcool = 42; */
        if (message.subcool !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.subcool);
        /* string superheat = 43; */
        if (message.superheat !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.superheat);
        /* string notes = 44; */
        if (message.notes !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.notes);
        /* string services = 45; */
        if (message.services !== "")
            writer.tag(45, WireType.LengthDelimited).string(message.services);
        /* string servicesperformedrow1 = 46; */
        if (message.servicesperformedrow1 !== "")
            writer.tag(46, WireType.LengthDelimited).string(message.servicesperformedrow1);
        /* string totalamountrow1 = 47; */
        if (message.totalamountrow1 !== "")
            writer.tag(47, WireType.LengthDelimited).string(message.totalamountrow1);
        /* string servicesperformedrow2 = 48; */
        if (message.servicesperformedrow2 !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.servicesperformedrow2);
        /* string totalamountrow2 = 49; */
        if (message.totalamountrow2 !== "")
            writer.tag(49, WireType.LengthDelimited).string(message.totalamountrow2);
        /* string servicesperformedrow3 = 50; */
        if (message.servicesperformedrow3 !== "")
            writer.tag(50, WireType.LengthDelimited).string(message.servicesperformedrow3);
        /* string totalamountrow3 = 51; */
        if (message.totalamountrow3 !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.totalamountrow3);
        /* string servicesperformedrow4 = 52; */
        if (message.servicesperformedrow4 !== "")
            writer.tag(52, WireType.LengthDelimited).string(message.servicesperformedrow4);
        /* string totalamountrow4 = 53; */
        if (message.totalamountrow4 !== "")
            writer.tag(53, WireType.LengthDelimited).string(message.totalamountrow4);
        /* string discount = 54; */
        if (message.discount !== "")
            writer.tag(54, WireType.LengthDelimited).string(message.discount);
        /* string discountcost = 55; */
        if (message.discountcost !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.discountcost);
        /* string log_notification = 56; */
        if (message.logNotification !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.logNotification);
        /* int32 diagnostic_quoted = 57; */
        if (message.diagnosticQuoted !== 0)
            writer.tag(57, WireType.Varint).int32(message.diagnosticQuoted);
        /* string amount_quoted = 58; */
        if (message.amountQuoted !== "")
            writer.tag(58, WireType.LengthDelimited).string(message.amountQuoted);
        /* int32 property_billing = 59; */
        if (message.propertyBilling !== 0)
            writer.tag(59, WireType.Varint).int32(message.propertyBilling);
        /* int32 is_callback = 60; */
        if (message.isCallback !== 0)
            writer.tag(60, WireType.Varint).int32(message.isCallback);
        /* int32 log_version = 61; */
        if (message.logVersion !== 0)
            writer.tag(61, WireType.Varint).int32(message.logVersion);
        /* int32 job_type_id = 62; */
        if (message.jobTypeId !== 0)
            writer.tag(62, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 63; */
        if (message.jobSubtypeId !== 0)
            writer.tag(63, WireType.Varint).int32(message.jobSubtypeId);
        /* int32 callback_original_id = 64; */
        if (message.callbackOriginalId !== 0)
            writer.tag(64, WireType.Varint).int32(message.callbackOriginalId);
        /* int32 callback_disposition = 65; */
        if (message.callbackDisposition !== 0)
            writer.tag(65, WireType.Varint).int32(message.callbackDisposition);
        /* string callback_comments = 66; */
        if (message.callbackComments !== "")
            writer.tag(66, WireType.LengthDelimited).string(message.callbackComments);
        /* int32 callback_technician = 67; */
        if (message.callbackTechnician !== 0)
            writer.tag(67, WireType.Varint).int32(message.callbackTechnician);
        /* string callback_approval_timestamp = 68; */
        if (message.callbackApprovalTimestamp !== "")
            writer.tag(68, WireType.LengthDelimited).string(message.callbackApprovalTimestamp);
        /* int32 callback_comment_by = 69; */
        if (message.callbackCommentBy !== 0)
            writer.tag(69, WireType.Varint).int32(message.callbackCommentBy);
        /* int32 document_id = 70; */
        if (message.documentId !== 0)
            writer.tag(70, WireType.Varint).int32(message.documentId);
        /* string material_used = 71; */
        if (message.materialUsed !== "")
            writer.tag(71, WireType.LengthDelimited).string(message.materialUsed);
        /* double material_total = 72; */
        if (message.materialTotal !== 0)
            writer.tag(72, WireType.Bit64).double(message.materialTotal);
        /* int32 is_active = 73; */
        if (message.isActive !== 0)
            writer.tag(73, WireType.Varint).int32(message.isActive);
        /* int32 parent_id = 74; */
        if (message.parentId !== 0)
            writer.tag(74, WireType.Varint).int32(message.parentId);
        /* int32 is_lmpc = 75; */
        if (message.isLmpc !== 0)
            writer.tag(75, WireType.Varint).int32(message.isLmpc);
        /* int32 high_priority = 76; */
        if (message.highPriority !== 0)
            writer.tag(76, WireType.Varint).int32(message.highPriority);
        /* int32 is_residential = 77; */
        if (message.isResidential !== 0)
            writer.tag(77, WireType.Varint).int32(message.isResidential);
        /* string job_type = 78; */
        if (message.jobType !== "")
            writer.tag(78, WireType.LengthDelimited).string(message.jobType);
        /* string job_subtype = 79; */
        if (message.jobSubtype !== "")
            writer.tag(79, WireType.LengthDelimited).string(message.jobSubtype);
        /* User customer = 80; */
        if (message.customer)
            User.internalBinaryWrite(message.customer, writer.tag(80, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 81; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 82; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(82, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 83; */
        if (message.pageNumber !== 0)
            writer.tag(83, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 84; */
        if (message.orderBy !== "")
            writer.tag(84, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 85; */
        if (message.orderDir !== "")
            writer.tag(85, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_range = 86; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(86, WireType.LengthDelimited).string(message.dateRange[i]);
        /* bool count_only = 87; */
        if (message.countOnly !== false)
            writer.tag(87, WireType.Varint).bool(message.countOnly);
        /* repeated Quotable quote_data = 88; */
        for (let i = 0; i < message.quoteData.length; i++)
            Quotable.internalBinaryWrite(message.quoteData[i], writer.tag(88, WireType.LengthDelimited).fork(), options).join();
        /* repeated string date_target = 89; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(89, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* int32 department_id = 90; */
        if (message.departmentId !== 0)
            writer.tag(90, WireType.Varint).int32(message.departmentId);
        /* repeated string not_equals = 91; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(91, WireType.LengthDelimited).string(message.notEquals[i]);
        /* bool without_limit = 92; */
        if (message.withoutLimit !== false)
            writer.tag(92, WireType.Varint).bool(message.withoutLimit);
        /* bool is_generated_invoice = 93; */
        if (message.isGeneratedInvoice !== false)
            writer.tag(93, WireType.Varint).bool(message.isGeneratedInvoice);
        /* bool only_events = 94; */
        if (message.onlyEvents !== false)
            writer.tag(94, WireType.Varint).bool(message.onlyEvents);
        /* repeated JobAdmin job_admin = 95; */
        for (let i = 0; i < message.jobAdmin.length; i++)
            JobAdmin.internalBinaryWrite(message.jobAdmin[i], writer.tag(95, WireType.LengthDelimited).fork(), options).join();
        /* int32 job_admin_search = 96; */
        if (message.jobAdminSearch !== 0)
            writer.tag(96, WireType.Varint).int32(message.jobAdminSearch);
        /* string callback_user_ids = 97; */
        if (message.callbackUserIds !== "")
            writer.tag(97, WireType.LengthDelimited).string(message.callbackUserIds);
        /* string id_list = 98; */
        if (message.idList !== "")
            writer.tag(98, WireType.LengthDelimited).string(message.idList);
        /* int32 sold_by = 99; */
        if (message.soldBy !== 0)
            writer.tag(99, WireType.Varint).int32(message.soldBy);
        /* int32 lead_generated_by = 100; */
        if (message.leadGeneratedBy !== 0)
            writer.tag(100, WireType.Varint).int32(message.leadGeneratedBy);
        /* string quote_expire_date = 101; */
        if (message.quoteExpireDate !== "")
            writer.tag(101, WireType.LengthDelimited).string(message.quoteExpireDate);
        /* string summary_id = 102; */
        if (message.summaryId !== "")
            writer.tag(102, WireType.LengthDelimited).string(message.summaryId);
        /* bool is_project = 103; */
        if (message.isProject !== false)
            writer.tag(103, WireType.Varint).bool(message.isProject);
        /* string job_mode = 104; */
        if (message.jobMode !== "")
            writer.tag(104, WireType.LengthDelimited).string(message.jobMode);
        /* double total_budget = 105; */
        if (message.totalBudget !== 0)
            writer.tag(105, WireType.Bit64).double(message.totalBudget);
        /* string unity_build_contract_id = 106; */
        if (message.unityBuildContractId !== "")
            writer.tag(106, WireType.LengthDelimited).string(message.unityBuildContractId);
        /* string project_start_date = 107; */
        if (message.projectStartDate !== "")
            writer.tag(107, WireType.LengthDelimited).string(message.projectStartDate);
        /* string project_end_date = 108; */
        if (message.projectEndDate !== "")
            writer.tag(108, WireType.LengthDelimited).string(message.projectEndDate);
        /* string project_status = 109; */
        if (message.projectStatus !== "")
            writer.tag(109, WireType.LengthDelimited).string(message.projectStatus);
        /* bool is_unity_sync_enabled = 110; */
        if (message.isUnitySyncEnabled !== false)
            writer.tag(110, WireType.Varint).bool(message.isUnitySyncEnabled);
        /* float tax = 111; */
        if (message.tax !== 0)
            writer.tag(111, WireType.Bit32).float(message.tax);
        /* float tax_cost = 112; */
        if (message.taxCost !== 0)
            writer.tag(112, WireType.Bit32).float(message.taxCost);
        /* double manual_percent_complete = 113; */
        if (message.manualPercentComplete !== 0)
            writer.tag(113, WireType.Bit64).double(message.manualPercentComplete);
        /* int32 is_window_block = 114; */
        if (message.isWindowBlock !== 0)
            writer.tag(114, WireType.Varint).int32(message.isWindowBlock);
        /* int32 is_new_customer = 115; */
        if (message.isNewCustomer !== 0)
            writer.tag(115, WireType.Varint).int32(message.isNewCustomer);
        /* bool quote_pending = 116; */
        if (message.quotePending !== false)
            writer.tag(116, WireType.Varint).bool(message.quotePending);
        /* int32 membership_id = 118; */
        if (message.membershipId !== 0)
            writer.tag(118, WireType.Varint).int32(message.membershipId);
        /* string public_id = 119; */
        if (message.publicId !== "")
            writer.tag(119, WireType.LengthDelimited).string(message.publicId);
        /* int32 assigned_csr_user_id = 120; */
        if (message.assignedCsrUserId !== 0)
            writer.tag(120, WireType.Varint).int32(message.assignedCsrUserId);
        /* string service_channel_wo = 121; */
        if (message.serviceChannelWo !== "")
            writer.tag(121, WireType.LengthDelimited).string(message.serviceChannelWo);
        /* string sla_due = 122; */
        if (message.slaDue !== "")
            writer.tag(122, WireType.LengthDelimited).string(message.slaDue);
        /* int32 customer_priority_id = 123; */
        if (message.customerPriorityId !== 0)
            writer.tag(123, WireType.Varint).int32(message.customerPriorityId);
        /* string schedule_confidence = 124; */
        if (message.scheduleConfidence !== "")
            writer.tag(124, WireType.LengthDelimited).string(message.scheduleConfidence);
        /* int32 follow_up_owner_id = 125; */
        if (message.followUpOwnerId !== 0)
            writer.tag(125, WireType.Varint).int32(message.followUpOwnerId);
        /* string next_follow_up_date = 126; */
        if (message.nextFollowUpDate !== "")
            writer.tag(126, WireType.LengthDelimited).string(message.nextFollowUpDate);
        /* bool cancel_protected = 127; */
        if (message.cancelProtected !== false)
            writer.tag(127, WireType.Varint).bool(message.cancelProtected);
        /* int32 acknowledged_by = 128; */
        if (message.acknowledgedBy !== 0)
            writer.tag(128, WireType.Varint).int32(message.acknowledgedBy);
        /* string acknowledged_date = 129; */
        if (message.acknowledgedDate !== "")
            writer.tag(129, WireType.LengthDelimited).string(message.acknowledgedDate);
        /* bool pending_billing_queue = 130; */
        if (message.pendingBillingQueue !== false)
            writer.tag(130, WireType.Varint).bool(message.pendingBillingQueue);
        /* bool is_project_primary = 131; */
        if (message.isProjectPrimary !== false)
            writer.tag(131, WireType.Varint).bool(message.isProjectPrimary);
        /* int32 is_outside_service_area = 132; */
        if (message.isOutsideServiceArea !== 0)
            writer.tag(132, WireType.Varint).int32(message.isOutsideServiceArea);
        /* int32 is_waitlisted = 133; */
        if (message.isWaitlisted !== 0)
            writer.tag(133, WireType.Varint).int32(message.isWaitlisted);
        /* int32 event_trade_id = 134; */
        if (message.eventTradeId !== 0)
            writer.tag(134, WireType.Varint).int32(message.eventTradeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Event
 */
export const Event = new Event$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventList$Type extends MessageType {
    constructor() {
        super("EventList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Event results */ 1:
                    message.results.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Event results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Event.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventList
 */
export const EventList = new EventList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarDay$Type extends MessageType {
    constructor() {
        super("CalendarDay", [
            { no: 1, name: "service_calls", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 2, name: "completed_service_calls", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 3, name: "reminders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 4, name: "timeoff_requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeoffRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.serviceCalls = [];
        message.completedServiceCalls = [];
        message.reminders = [];
        message.timeoffRequests = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Event service_calls */ 1:
                    message.serviceCalls.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Event completed_service_calls */ 2:
                    message.completedServiceCalls.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Event reminders */ 3:
                    message.reminders.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated TimeoffRequest timeoff_requests */ 4:
                    message.timeoffRequests.push(TimeoffRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Event service_calls = 1; */
        for (let i = 0; i < message.serviceCalls.length; i++)
            Event.internalBinaryWrite(message.serviceCalls[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event completed_service_calls = 2; */
        for (let i = 0; i < message.completedServiceCalls.length; i++)
            Event.internalBinaryWrite(message.completedServiceCalls[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event reminders = 3; */
        for (let i = 0; i < message.reminders.length; i++)
            Event.internalBinaryWrite(message.reminders[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated TimeoffRequest timeoff_requests = 4; */
        for (let i = 0; i < message.timeoffRequests.length; i++)
            TimeoffRequest.internalBinaryWrite(message.timeoffRequests[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CalendarDay
 */
export const CalendarDay = new CalendarDay$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarData$Type extends MessageType {
    constructor() {
        super("CalendarData", [
            { no: 1, name: "dates", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => CalendarDay } },
            { no: 2, name: "customers", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "zip_codes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 4, name: "states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dates = {};
        message.customers = {};
        message.zipCodes = {};
        message.states = {};
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, CalendarDay> dates */ 1:
                    this.binaryReadMap1(message.dates, reader, options);
                    break;
                case /* map<int32, string> customers */ 2:
                    this.binaryReadMap2(message.customers, reader, options);
                    break;
                case /* map<string, string> zip_codes */ 3:
                    this.binaryReadMap3(message.zipCodes, reader, options);
                    break;
                case /* map<string, string> states */ 4:
                    this.binaryReadMap4(message.states, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap1(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = CalendarDay.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for CalendarData.dates");
            }
        }
        map[key ?? ""] = val ?? CalendarDay.create();
    }
    binaryReadMap2(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for CalendarData.customers");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    binaryReadMap3(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for CalendarData.zip_codes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    binaryReadMap4(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for CalendarData.states");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* map<string, CalendarDay> dates = 1; */
        for (let k of globalThis.Object.keys(message.dates)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            CalendarDay.internalBinaryWrite(message.dates[k], writer, options);
            writer.join().join();
        }
        /* map<int32, string> customers = 2; */
        for (let k of globalThis.Object.keys(message.customers))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.customers[k]).join();
        /* map<string, string> zip_codes = 3; */
        for (let k of globalThis.Object.keys(message.zipCodes))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.zipCodes[k]).join();
        /* map<string, string> states = 4; */
        for (let k of globalThis.Object.keys(message.states))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.states[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CalendarData
 */
export const CalendarData = new CalendarData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Quotable$Type extends MessageType {
    constructor() {
        super("Quotable", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_used_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "quote_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "quoted_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "is_billable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "is_lmpc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "is_flatrate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "is_complex", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "include_in_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "direct_event_association_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "direct_event_association_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "project_primary_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "quote_line_sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "quote_used_sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "exclude_invoice_discount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.quoteUsedId = 0;
        message.servicesRenderedId = 0;
        message.quoteLineId = 0;
        message.description = "";
        message.quotedPrice = 0;
        message.quantity = 0;
        message.isBillable = false;
        message.isLmpc = false;
        message.isFlatrate = false;
        message.isComplex = false;
        message.isActive = false;
        message.fieldMask = [];
        message.includeInInvoice = false;
        message.directEventAssociationId = 0;
        message.directEventAssociationDepartmentId = 0;
        message.projectId = 0;
        message.projectPrimaryEventId = 0;
        message.invoiceId = 0;
        message.quoteLineSortOrder = 0;
        message.quoteUsedSortOrder = 0;
        message.quoteDocumentId = 0;
        message.excludeInvoiceDiscount = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 quote_used_id */ 3:
                    message.quoteUsedId = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 4:
                    message.servicesRenderedId = reader.int32();
                    break;
                case /* int32 quote_line_id */ 5:
                    message.quoteLineId = reader.int32();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* double quoted_price */ 7:
                    message.quotedPrice = reader.double();
                    break;
                case /* double quantity */ 8:
                    message.quantity = reader.double();
                    break;
                case /* bool is_billable */ 9:
                    message.isBillable = reader.bool();
                    break;
                case /* bool is_lmpc */ 10:
                    message.isLmpc = reader.bool();
                    break;
                case /* bool is_flatrate */ 11:
                    message.isFlatrate = reader.bool();
                    break;
                case /* bool is_complex */ 12:
                    message.isComplex = reader.bool();
                    break;
                case /* bool is_active */ 13:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 14:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool include_in_invoice */ 15:
                    message.includeInInvoice = reader.bool();
                    break;
                case /* int32 direct_event_association_id */ 16:
                    message.directEventAssociationId = reader.int32();
                    break;
                case /* int32 direct_event_association_department_id */ 17:
                    message.directEventAssociationDepartmentId = reader.int32();
                    break;
                case /* int32 project_id */ 18:
                    message.projectId = reader.int32();
                    break;
                case /* int32 project_primary_event_id */ 19:
                    message.projectPrimaryEventId = reader.int32();
                    break;
                case /* int32 invoice_id */ 20:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 quote_line_sort_order */ 21:
                    message.quoteLineSortOrder = reader.int32();
                    break;
                case /* int32 quote_used_sort_order */ 22:
                    message.quoteUsedSortOrder = reader.int32();
                    break;
                case /* int32 quote_document_id */ 23:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* bool exclude_invoice_discount */ 24:
                    message.excludeInvoiceDiscount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 quote_used_id = 3; */
        if (message.quoteUsedId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteUsedId);
        /* int32 services_rendered_id = 4; */
        if (message.servicesRenderedId !== 0)
            writer.tag(4, WireType.Varint).int32(message.servicesRenderedId);
        /* int32 quote_line_id = 5; */
        if (message.quoteLineId !== 0)
            writer.tag(5, WireType.Varint).int32(message.quoteLineId);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* double quoted_price = 7; */
        if (message.quotedPrice !== 0)
            writer.tag(7, WireType.Bit64).double(message.quotedPrice);
        /* double quantity = 8; */
        if (message.quantity !== 0)
            writer.tag(8, WireType.Bit64).double(message.quantity);
        /* bool is_billable = 9; */
        if (message.isBillable !== false)
            writer.tag(9, WireType.Varint).bool(message.isBillable);
        /* bool is_lmpc = 10; */
        if (message.isLmpc !== false)
            writer.tag(10, WireType.Varint).bool(message.isLmpc);
        /* bool is_flatrate = 11; */
        if (message.isFlatrate !== false)
            writer.tag(11, WireType.Varint).bool(message.isFlatrate);
        /* bool is_complex = 12; */
        if (message.isComplex !== false)
            writer.tag(12, WireType.Varint).bool(message.isComplex);
        /* bool is_active = 13; */
        if (message.isActive !== false)
            writer.tag(13, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 14; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool include_in_invoice = 15; */
        if (message.includeInInvoice !== false)
            writer.tag(15, WireType.Varint).bool(message.includeInInvoice);
        /* int32 direct_event_association_id = 16; */
        if (message.directEventAssociationId !== 0)
            writer.tag(16, WireType.Varint).int32(message.directEventAssociationId);
        /* int32 direct_event_association_department_id = 17; */
        if (message.directEventAssociationDepartmentId !== 0)
            writer.tag(17, WireType.Varint).int32(message.directEventAssociationDepartmentId);
        /* int32 project_id = 18; */
        if (message.projectId !== 0)
            writer.tag(18, WireType.Varint).int32(message.projectId);
        /* int32 project_primary_event_id = 19; */
        if (message.projectPrimaryEventId !== 0)
            writer.tag(19, WireType.Varint).int32(message.projectPrimaryEventId);
        /* int32 invoice_id = 20; */
        if (message.invoiceId !== 0)
            writer.tag(20, WireType.Varint).int32(message.invoiceId);
        /* int32 quote_line_sort_order = 21; */
        if (message.quoteLineSortOrder !== 0)
            writer.tag(21, WireType.Varint).int32(message.quoteLineSortOrder);
        /* int32 quote_used_sort_order = 22; */
        if (message.quoteUsedSortOrder !== 0)
            writer.tag(22, WireType.Varint).int32(message.quoteUsedSortOrder);
        /* int32 quote_document_id = 23; */
        if (message.quoteDocumentId !== 0)
            writer.tag(23, WireType.Varint).int32(message.quoteDocumentId);
        /* bool exclude_invoice_discount = 24; */
        if (message.excludeInvoiceDiscount !== false)
            writer.tag(24, WireType.Varint).bool(message.excludeInvoiceDiscount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Quotable
 */
export const Quotable = new Quotable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotableRead$Type extends MessageType {
    constructor() {
        super("QuotableRead", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_used_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "quote_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "quoted_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "is_billable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "is_lmpc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "is_flatrate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "is_complex", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "include_in_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "direct_event_association_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "direct_event_association_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "project_primary_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "quote_line_sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "quote_used_sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "exclude_invoice_discount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.quoteUsedId = 0;
        message.servicesRenderedId = 0;
        message.quoteLineId = 0;
        message.description = "";
        message.quotedPrice = 0;
        message.quantity = 0;
        message.isBillable = false;
        message.isLmpc = false;
        message.isFlatrate = false;
        message.isComplex = false;
        message.isActive = false;
        message.fieldMask = [];
        message.notEquals = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.includeInInvoice = false;
        message.directEventAssociationId = 0;
        message.directEventAssociationDepartmentId = 0;
        message.projectId = 0;
        message.projectPrimaryEventId = 0;
        message.invoiceId = 0;
        message.quoteLineSortOrder = 0;
        message.quoteUsedSortOrder = 0;
        message.quoteDocumentId = 0;
        message.excludeInvoiceDiscount = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 quote_used_id */ 3:
                    message.quoteUsedId = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 4:
                    message.servicesRenderedId = reader.int32();
                    break;
                case /* int32 quote_line_id */ 5:
                    message.quoteLineId = reader.int32();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* double quoted_price */ 7:
                    message.quotedPrice = reader.double();
                    break;
                case /* double quantity */ 8:
                    message.quantity = reader.double();
                    break;
                case /* bool is_billable */ 9:
                    message.isBillable = reader.bool();
                    break;
                case /* bool is_lmpc */ 10:
                    message.isLmpc = reader.bool();
                    break;
                case /* bool is_flatrate */ 11:
                    message.isFlatrate = reader.bool();
                    break;
                case /* bool is_complex */ 12:
                    message.isComplex = reader.bool();
                    break;
                case /* bool is_active */ 13:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 14:
                    message.fieldMask.push(reader.string());
                    break;
                case /* repeated string not_equals */ 15:
                    message.notEquals.push(reader.string());
                    break;
                case /* int32 page_number */ 16:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 19:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool include_in_invoice */ 20:
                    message.includeInInvoice = reader.bool();
                    break;
                case /* int32 direct_event_association_id */ 21:
                    message.directEventAssociationId = reader.int32();
                    break;
                case /* int32 direct_event_association_department_id */ 22:
                    message.directEventAssociationDepartmentId = reader.int32();
                    break;
                case /* int32 project_id */ 23:
                    message.projectId = reader.int32();
                    break;
                case /* int32 project_primary_event_id */ 24:
                    message.projectPrimaryEventId = reader.int32();
                    break;
                case /* int32 invoice_id */ 25:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 quote_line_sort_order */ 26:
                    message.quoteLineSortOrder = reader.int32();
                    break;
                case /* int32 quote_used_sort_order */ 27:
                    message.quoteUsedSortOrder = reader.int32();
                    break;
                case /* int32 quote_document_id */ 28:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* bool exclude_invoice_discount */ 29:
                    message.excludeInvoiceDiscount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 quote_used_id = 3; */
        if (message.quoteUsedId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteUsedId);
        /* int32 services_rendered_id = 4; */
        if (message.servicesRenderedId !== 0)
            writer.tag(4, WireType.Varint).int32(message.servicesRenderedId);
        /* int32 quote_line_id = 5; */
        if (message.quoteLineId !== 0)
            writer.tag(5, WireType.Varint).int32(message.quoteLineId);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* double quoted_price = 7; */
        if (message.quotedPrice !== 0)
            writer.tag(7, WireType.Bit64).double(message.quotedPrice);
        /* double quantity = 8; */
        if (message.quantity !== 0)
            writer.tag(8, WireType.Bit64).double(message.quantity);
        /* bool is_billable = 9; */
        if (message.isBillable !== false)
            writer.tag(9, WireType.Varint).bool(message.isBillable);
        /* bool is_lmpc = 10; */
        if (message.isLmpc !== false)
            writer.tag(10, WireType.Varint).bool(message.isLmpc);
        /* bool is_flatrate = 11; */
        if (message.isFlatrate !== false)
            writer.tag(11, WireType.Varint).bool(message.isFlatrate);
        /* bool is_complex = 12; */
        if (message.isComplex !== false)
            writer.tag(12, WireType.Varint).bool(message.isComplex);
        /* bool is_active = 13; */
        if (message.isActive !== false)
            writer.tag(13, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 14; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* repeated string not_equals = 15; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.notEquals[i]);
        /* int32 page_number = 16; */
        if (message.pageNumber !== 0)
            writer.tag(16, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 19; */
        if (message.withoutLimit !== false)
            writer.tag(19, WireType.Varint).bool(message.withoutLimit);
        /* bool include_in_invoice = 20; */
        if (message.includeInInvoice !== false)
            writer.tag(20, WireType.Varint).bool(message.includeInInvoice);
        /* int32 direct_event_association_id = 21; */
        if (message.directEventAssociationId !== 0)
            writer.tag(21, WireType.Varint).int32(message.directEventAssociationId);
        /* int32 direct_event_association_department_id = 22; */
        if (message.directEventAssociationDepartmentId !== 0)
            writer.tag(22, WireType.Varint).int32(message.directEventAssociationDepartmentId);
        /* int32 project_id = 23; */
        if (message.projectId !== 0)
            writer.tag(23, WireType.Varint).int32(message.projectId);
        /* int32 project_primary_event_id = 24; */
        if (message.projectPrimaryEventId !== 0)
            writer.tag(24, WireType.Varint).int32(message.projectPrimaryEventId);
        /* int32 invoice_id = 25; */
        if (message.invoiceId !== 0)
            writer.tag(25, WireType.Varint).int32(message.invoiceId);
        /* int32 quote_line_sort_order = 26; */
        if (message.quoteLineSortOrder !== 0)
            writer.tag(26, WireType.Varint).int32(message.quoteLineSortOrder);
        /* int32 quote_used_sort_order = 27; */
        if (message.quoteUsedSortOrder !== 0)
            writer.tag(27, WireType.Varint).int32(message.quoteUsedSortOrder);
        /* int32 quote_document_id = 28; */
        if (message.quoteDocumentId !== 0)
            writer.tag(28, WireType.Varint).int32(message.quoteDocumentId);
        /* bool exclude_invoice_discount = 29; */
        if (message.excludeInvoiceDiscount !== false)
            writer.tag(29, WireType.Varint).bool(message.excludeInvoiceDiscount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotableRead
 */
export const QuotableRead = new QuotableRead$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotableList$Type extends MessageType {
    constructor() {
        super("QuotableList", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Quotable },
            { no: 19, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Quotable data */ 1:
                    message.data.push(Quotable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 19:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Quotable data = 1; */
        for (let i = 0; i < message.data.length; i++)
            Quotable.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 19; */
        if (message.totalCount !== 0)
            writer.tag(19, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotableList
 */
export const QuotableList = new QuotableList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostReportData$Type extends MessageType {
    constructor() {
        super("CostReportData", [
            { no: 1, name: "transaction_results", kind: "message", T: () => TransactionList },
            { no: 2, name: "timesheet_results", kind: "message", T: () => TimesheetLineList },
            { no: 3, name: "per_diem_results", kind: "message", T: () => PerDiemList },
            { no: 4, name: "task_results", kind: "message", T: () => TaskList },
            { no: 5, name: "trip_results", kind: "message", T: () => TripList },
            { no: 6, name: "event_result", kind: "message", T: () => Event },
            { no: 7, name: "lodging_assignment_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lodgingAssignmentTotal = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TransactionList transaction_results */ 1:
                    message.transactionResults = TransactionList.internalBinaryRead(reader, reader.uint32(), options, message.transactionResults);
                    break;
                case /* TimesheetLineList timesheet_results */ 2:
                    message.timesheetResults = TimesheetLineList.internalBinaryRead(reader, reader.uint32(), options, message.timesheetResults);
                    break;
                case /* PerDiemList per_diem_results */ 3:
                    message.perDiemResults = PerDiemList.internalBinaryRead(reader, reader.uint32(), options, message.perDiemResults);
                    break;
                case /* TaskList task_results */ 4:
                    message.taskResults = TaskList.internalBinaryRead(reader, reader.uint32(), options, message.taskResults);
                    break;
                case /* TripList trip_results */ 5:
                    message.tripResults = TripList.internalBinaryRead(reader, reader.uint32(), options, message.tripResults);
                    break;
                case /* Event event_result */ 6:
                    message.eventResult = Event.internalBinaryRead(reader, reader.uint32(), options, message.eventResult);
                    break;
                case /* double lodging_assignment_total */ 7:
                    message.lodgingAssignmentTotal = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TransactionList transaction_results = 1; */
        if (message.transactionResults)
            TransactionList.internalBinaryWrite(message.transactionResults, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* TimesheetLineList timesheet_results = 2; */
        if (message.timesheetResults)
            TimesheetLineList.internalBinaryWrite(message.timesheetResults, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* PerDiemList per_diem_results = 3; */
        if (message.perDiemResults)
            PerDiemList.internalBinaryWrite(message.perDiemResults, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* TaskList task_results = 4; */
        if (message.taskResults)
            TaskList.internalBinaryWrite(message.taskResults, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* TripList trip_results = 5; */
        if (message.tripResults)
            TripList.internalBinaryWrite(message.tripResults, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* Event event_result = 6; */
        if (message.eventResult)
            Event.internalBinaryWrite(message.eventResult, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* double lodging_assignment_total = 7; */
        if (message.lodgingAssignmentTotal !== 0)
            writer.tag(7, WireType.Bit64).double(message.lodgingAssignmentTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CostReportData
 */
export const CostReportData = new CostReportData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostReportReq$Type extends MessageType {
    constructor() {
        super("CostReportReq", [
            { no: 1, name: "timesheet_req", kind: "message", T: () => TimesheetLine },
            { no: 2, name: "perDiem_req", kind: "message", T: () => PerDiem },
            { no: 3, name: "task_req", kind: "message", T: () => Task },
            { no: 4, name: "trip_req", kind: "message", T: () => Trip },
            { no: 5, name: "transaction_req", kind: "message", T: () => Transaction }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TimesheetLine timesheet_req */ 1:
                    message.timesheetReq = TimesheetLine.internalBinaryRead(reader, reader.uint32(), options, message.timesheetReq);
                    break;
                case /* PerDiem perDiem_req */ 2:
                    message.perDiemReq = PerDiem.internalBinaryRead(reader, reader.uint32(), options, message.perDiemReq);
                    break;
                case /* Task task_req */ 3:
                    message.taskReq = Task.internalBinaryRead(reader, reader.uint32(), options, message.taskReq);
                    break;
                case /* Trip trip_req */ 4:
                    message.tripReq = Trip.internalBinaryRead(reader, reader.uint32(), options, message.tripReq);
                    break;
                case /* Transaction transaction_req */ 5:
                    message.transactionReq = Transaction.internalBinaryRead(reader, reader.uint32(), options, message.transactionReq);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TimesheetLine timesheet_req = 1; */
        if (message.timesheetReq)
            TimesheetLine.internalBinaryWrite(message.timesheetReq, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* PerDiem perDiem_req = 2; */
        if (message.perDiemReq)
            PerDiem.internalBinaryWrite(message.perDiemReq, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Task task_req = 3; */
        if (message.taskReq)
            Task.internalBinaryWrite(message.taskReq, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Trip trip_req = 4; */
        if (message.tripReq)
            Trip.internalBinaryWrite(message.tripReq, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* Transaction transaction_req = 5; */
        if (message.transactionReq)
            Transaction.internalBinaryWrite(message.transactionReq, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CostReportReq
 */
export const CostReportReq = new CostReportReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobAdmin$Type extends MessageType {
    constructor() {
        super("JobAdmin", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.jobNumber = 0;
        message.userId = 0;
        message.title = "";
        message.isActive = false;
        message.pageNumber = 0;
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 job_number */ 2:
                    message.jobNumber = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 job_number = 2; */
        if (message.jobNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.jobNumber);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobAdmin
 */
export const JobAdmin = new JobAdmin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobAdminList$Type extends MessageType {
    constructor() {
        super("JobAdminList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobAdmin },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated JobAdmin results */ 1:
                    message.results.push(JobAdmin.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated JobAdmin results = 1; */
        for (let i = 0; i < message.results.length; i++)
            JobAdmin.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobAdminList
 */
export const JobAdminList = new JobAdminList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventAssignment$Type extends MessageType {
    constructor() {
        super("EventAssignment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.eventId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 5:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 6:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 7:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 5; */
        if (message.pageNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 6; */
        if (message.orderBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 7; */
        if (message.orderDir !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventAssignment
 */
export const EventAssignment = new EventAssignment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventAssignmentList$Type extends MessageType {
    constructor() {
        super("EventAssignmentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventAssignment },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated EventAssignment results */ 1:
                    message.results.push(EventAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated EventAssignment results = 1; */
        for (let i = 0; i < message.results.length; i++)
            EventAssignment.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventAssignmentList
 */
export const EventAssignmentList = new EventAssignmentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuickBooksTrackingCode$Type extends MessageType {
    constructor() {
        super("QuickBooksTrackingCode", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "tracking_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.trackingCode = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* string tracking_code */ 3:
                    message.trackingCode = reader.string();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 5:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* string tracking_code = 3; */
        if (message.trackingCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.trackingCode);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 5; */
        if (message.pageNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuickBooksTrackingCode
 */
export const QuickBooksTrackingCode = new QuickBooksTrackingCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuickBooksTrackingCodeList$Type extends MessageType {
    constructor() {
        super("QuickBooksTrackingCodeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuickBooksTrackingCode },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuickBooksTrackingCode results */ 1:
                    message.results.push(QuickBooksTrackingCode.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuickBooksTrackingCode results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuickBooksTrackingCode.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuickBooksTrackingCodeList
 */
export const QuickBooksTrackingCodeList = new QuickBooksTrackingCodeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingBilling$Type extends MessageType {
    constructor() {
        super("PendingBilling", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_completed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.propertyId = 0;
        message.userId = 0;
        message.customerName = "";
        message.businessName = "";
        message.dateCompleted = "";
        message.address = "";
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 property_id */ 2:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string customer_name */ 4:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 5:
                    message.businessName = reader.string();
                    break;
                case /* string date_completed */ 6:
                    message.dateCompleted = reader.string();
                    break;
                case /* string address */ 7:
                    message.address = reader.string();
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 property_id = 2; */
        if (message.propertyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.propertyId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string customer_name = 4; */
        if (message.customerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 5; */
        if (message.businessName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.businessName);
        /* string date_completed = 6; */
        if (message.dateCompleted !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCompleted);
        /* string address = 7; */
        if (message.address !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.address);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PendingBilling
 */
export const PendingBilling = new PendingBilling$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingBillingList$Type extends MessageType {
    constructor() {
        super("PendingBillingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingBilling },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PendingBilling results */ 1:
                    message.results.push(PendingBilling.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PendingBilling results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PendingBilling.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PendingBillingList
 */
export const PendingBillingList = new PendingBillingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeolocationTimesheetData$Type extends MessageType {
    constructor() {
        super("GeolocationTimesheetData", [
            { no: 1, name: "timesheet_data", kind: "message", T: () => TimesheetLineList },
            { no: 2, name: "geolocation_id_list", kind: "message", T: () => Int32List }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TimesheetLineList timesheet_data */ 1:
                    message.timesheetData = TimesheetLineList.internalBinaryRead(reader, reader.uint32(), options, message.timesheetData);
                    break;
                case /* Int32List geolocation_id_list */ 2:
                    message.geolocationIdList = Int32List.internalBinaryRead(reader, reader.uint32(), options, message.geolocationIdList);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TimesheetLineList timesheet_data = 1; */
        if (message.timesheetData)
            TimesheetLineList.internalBinaryWrite(message.timesheetData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Int32List geolocation_id_list = 2; */
        if (message.geolocationIdList)
            Int32List.internalBinaryWrite(message.geolocationIdList, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeolocationTimesheetData
 */
export const GeolocationTimesheetData = new GeolocationTimesheetData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceLink$Type extends MessageType {
    constructor() {
        super("InvoiceLink", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "invoice_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0n;
        message.invoiceJobNumber = "";
        message.customerId = 0n;
        message.amount = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 invoice_id */ 1:
                    message.invoiceId = reader.int64().toBigInt();
                    break;
                case /* string invoice_job_number */ 2:
                    message.invoiceJobNumber = reader.string();
                    break;
                case /* int64 customer_id */ 3:
                    message.customerId = reader.int64().toBigInt();
                    break;
                case /* double amount */ 4:
                    message.amount = reader.double();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 invoice_id = 1; */
        if (message.invoiceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.invoiceId);
        /* string invoice_job_number = 2; */
        if (message.invoiceJobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceJobNumber);
        /* int64 customer_id = 3; */
        if (message.customerId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.customerId);
        /* double amount = 4; */
        if (message.amount !== 0)
            writer.tag(4, WireType.Bit64).double(message.amount);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceLink
 */
export const InvoiceLink = new InvoiceLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrder$Type extends MessageType {
    constructor() {
        super("PurchaseOrder", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "purchase_order_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "updated_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "requisition_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrderRequisitionItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.purchaseOrderNumber = 0;
        message.jobId = 0;
        message.createdDate = "";
        message.updatedDate = "";
        message.requisitionItems = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 purchase_order_number */ 3:
                    message.purchaseOrderNumber = reader.int32();
                    break;
                case /* int32 job_id */ 4:
                    message.jobId = reader.int32();
                    break;
                case /* string created_date */ 5:
                    message.createdDate = reader.string();
                    break;
                case /* string updated_date */ 6:
                    message.updatedDate = reader.string();
                    break;
                case /* repeated PurchaseOrderRequisitionItem requisition_items */ 10:
                    message.requisitionItems.push(PurchaseOrderRequisitionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 purchase_order_number = 3; */
        if (message.purchaseOrderNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.purchaseOrderNumber);
        /* int32 job_id = 4; */
        if (message.jobId !== 0)
            writer.tag(4, WireType.Varint).int32(message.jobId);
        /* string created_date = 5; */
        if (message.createdDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdDate);
        /* string updated_date = 6; */
        if (message.updatedDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.updatedDate);
        /* repeated PurchaseOrderRequisitionItem requisition_items = 10; */
        for (let i = 0; i < message.requisitionItems.length; i++)
            PurchaseOrderRequisitionItem.internalBinaryWrite(message.requisitionItems[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrder
 */
export const PurchaseOrder = new PurchaseOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderBatchGetRequest$Type extends MessageType {
    constructor() {
        super("PurchaseOrderBatchGetRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "purchase_order_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.purchaseOrderNumber = 0;
        message.jobId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 purchase_order_number */ 2:
                    message.purchaseOrderNumber = reader.int32();
                    break;
                case /* int32 job_id */ 3:
                    message.jobId = reader.int32();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 page_size */ 12:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 purchase_order_number = 2; */
        if (message.purchaseOrderNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.purchaseOrderNumber);
        /* int32 job_id = 3; */
        if (message.jobId !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobId);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* int32 page_size = 12; */
        if (message.pageSize !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderBatchGetRequest
 */
export const PurchaseOrderBatchGetRequest = new PurchaseOrderBatchGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderUpdateRequest$Type extends MessageType {
    constructor() {
        super("PurchaseOrderUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "purchase_order_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "requisition_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrderRequisitionItem },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.purchaseOrderNumber = 0;
        message.jobId = 0;
        message.requisitionItems = [];
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 purchase_order_number */ 3:
                    message.purchaseOrderNumber = reader.int32();
                    break;
                case /* int32 job_id */ 4:
                    message.jobId = reader.int32();
                    break;
                case /* repeated PurchaseOrderRequisitionItem requisition_items */ 5:
                    message.requisitionItems.push(PurchaseOrderRequisitionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 purchase_order_number = 3; */
        if (message.purchaseOrderNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.purchaseOrderNumber);
        /* int32 job_id = 4; */
        if (message.jobId !== 0)
            writer.tag(4, WireType.Varint).int32(message.jobId);
        /* repeated PurchaseOrderRequisitionItem requisition_items = 5; */
        for (let i = 0; i < message.requisitionItems.length; i++)
            PurchaseOrderRequisitionItem.internalBinaryWrite(message.requisitionItems[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderUpdateRequest
 */
export const PurchaseOrderUpdateRequest = new PurchaseOrderUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderList$Type extends MessageType {
    constructor() {
        super("PurchaseOrderList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrder },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PurchaseOrder results */ 1:
                    message.results.push(PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PurchaseOrder results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PurchaseOrder.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderList
 */
export const PurchaseOrderList = new PurchaseOrderList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderRequisitionItem$Type extends MessageType {
    constructor() {
        super("PurchaseOrderRequisitionItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "purchase_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "updated_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.purchaseOrderId = 0;
        message.itemName = "";
        message.quantity = 0;
        message.createdDate = "";
        message.updatedDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 purchase_order_id */ 2:
                    message.purchaseOrderId = reader.int32();
                    break;
                case /* string item_name */ 3:
                    message.itemName = reader.string();
                    break;
                case /* int32 quantity */ 4:
                    message.quantity = reader.int32();
                    break;
                case /* string created_date */ 5:
                    message.createdDate = reader.string();
                    break;
                case /* string updated_date */ 6:
                    message.updatedDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 purchase_order_id = 2; */
        if (message.purchaseOrderId !== 0)
            writer.tag(2, WireType.Varint).int32(message.purchaseOrderId);
        /* string item_name = 3; */
        if (message.itemName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.itemName);
        /* int32 quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantity);
        /* string created_date = 5; */
        if (message.createdDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdDate);
        /* string updated_date = 6; */
        if (message.updatedDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.updatedDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderRequisitionItem
 */
export const PurchaseOrderRequisitionItem = new PurchaseOrderRequisitionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderRequisitionItemBatchGetRequest$Type extends MessageType {
    constructor() {
        super("PurchaseOrderRequisitionItemBatchGetRequest", [
            { no: 1, name: "purchase_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.purchaseOrderId = 0;
        message.itemName = "";
        message.quantity = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 purchase_order_id */ 1:
                    message.purchaseOrderId = reader.int32();
                    break;
                case /* string item_name */ 2:
                    message.itemName = reader.string();
                    break;
                case /* int32 quantity */ 3:
                    message.quantity = reader.int32();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 page_size */ 12:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 purchase_order_id = 1; */
        if (message.purchaseOrderId !== 0)
            writer.tag(1, WireType.Varint).int32(message.purchaseOrderId);
        /* string item_name = 2; */
        if (message.itemName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.itemName);
        /* int32 quantity = 3; */
        if (message.quantity !== 0)
            writer.tag(3, WireType.Varint).int32(message.quantity);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* int32 page_size = 12; */
        if (message.pageSize !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderRequisitionItemBatchGetRequest
 */
export const PurchaseOrderRequisitionItemBatchGetRequest = new PurchaseOrderRequisitionItemBatchGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderRequisitionItemUpdateRequest$Type extends MessageType {
    constructor() {
        super("PurchaseOrderRequisitionItemUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "purchase_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.purchaseOrderId = 0;
        message.itemName = "";
        message.quantity = 0;
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 purchase_order_id */ 2:
                    message.purchaseOrderId = reader.int32();
                    break;
                case /* string item_name */ 3:
                    message.itemName = reader.string();
                    break;
                case /* int32 quantity */ 4:
                    message.quantity = reader.int32();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 purchase_order_id = 2; */
        if (message.purchaseOrderId !== 0)
            writer.tag(2, WireType.Varint).int32(message.purchaseOrderId);
        /* string item_name = 3; */
        if (message.itemName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.itemName);
        /* int32 quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantity);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderRequisitionItemUpdateRequest
 */
export const PurchaseOrderRequisitionItemUpdateRequest = new PurchaseOrderRequisitionItemUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PurchaseOrderRequisitionItemList$Type extends MessageType {
    constructor() {
        super("PurchaseOrderRequisitionItemList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrderRequisitionItem },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PurchaseOrderRequisitionItem results */ 1:
                    message.results.push(PurchaseOrderRequisitionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PurchaseOrderRequisitionItem results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PurchaseOrderRequisitionItem.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PurchaseOrderRequisitionItemList
 */
export const PurchaseOrderRequisitionItemList = new PurchaseOrderRequisitionItemList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeolocationCheckoutRequest$Type extends MessageType {
    constructor() {
        super("GeolocationCheckoutRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "startTimestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "endTimestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.startTimestamp = "";
        message.endTimestamp = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string startTimestamp */ 2:
                    message.startTimestamp = reader.string();
                    break;
                case /* string endTimestamp */ 3:
                    message.endTimestamp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string startTimestamp = 2; */
        if (message.startTimestamp !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.startTimestamp);
        /* string endTimestamp = 3; */
        if (message.endTimestamp !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.endTimestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeolocationCheckoutRequest
 */
export const GeolocationCheckoutRequest = new GeolocationCheckoutRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectEvent$Type extends MessageType {
    constructor() {
        super("ProjectEvent", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "searchJobNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "primary_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.propertyId = 0;
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.userId = 0;
        message.customerName = "";
        message.propertyAddress = "";
        message.searchJobNumber = 0;
        message.primaryEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 property_id */ 3:
                    message.propertyId = reader.int32();
                    break;
                case /* bool is_active */ 4:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 user_id */ 7:
                    message.userId = reader.int32();
                    break;
                case /* string customer_name */ 8:
                    message.customerName = reader.string();
                    break;
                case /* string property_address */ 9:
                    message.propertyAddress = reader.string();
                    break;
                case /* int32 searchJobNumber */ 10:
                    message.searchJobNumber = reader.int32();
                    break;
                case /* int32 primary_event_id */ 11:
                    message.primaryEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 property_id = 3; */
        if (message.propertyId !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyId);
        /* bool is_active = 4; */
        if (message.isActive !== false)
            writer.tag(4, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* int32 user_id = 7; */
        if (message.userId !== 0)
            writer.tag(7, WireType.Varint).int32(message.userId);
        /* string customer_name = 8; */
        if (message.customerName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customerName);
        /* string property_address = 9; */
        if (message.propertyAddress !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.propertyAddress);
        /* int32 searchJobNumber = 10; */
        if (message.searchJobNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.searchJobNumber);
        /* int32 primary_event_id = 11; */
        if (message.primaryEventId !== 0)
            writer.tag(11, WireType.Varint).int32(message.primaryEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectEvent
 */
export const ProjectEvent = new ProjectEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectEventList$Type extends MessageType {
    constructor() {
        super("ProjectEventList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectEvent },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectEvent results */ 1:
                    message.results.push(ProjectEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectEvent results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectEvent.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectEventList
 */
export const ProjectEventList = new ProjectEventList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePayment$Type extends MessageType {
    constructor() {
        super("InvoicePayment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payment_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "creator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "include_payment_line", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "payment_line", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoicePaymentLine }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.amount = 0;
        message.createdDate = "";
        message.paymentDate = "";
        message.paymentTypeId = "";
        message.customerId = 0;
        message.creatorId = 0;
        message.isActive = false;
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.includePaymentLine = false;
        message.paymentLine = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* double amount */ 2:
                    message.amount = reader.double();
                    break;
                case /* string created_date */ 3:
                    message.createdDate = reader.string();
                    break;
                case /* string payment_date */ 4:
                    message.paymentDate = reader.string();
                    break;
                case /* string payment_type_id */ 5:
                    message.paymentTypeId = reader.string();
                    break;
                case /* int32 customer_id */ 6:
                    message.customerId = reader.int32();
                    break;
                case /* int32 creator_id */ 7:
                    message.creatorId = reader.int32();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 10:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 11:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool include_payment_line */ 13:
                    message.includePaymentLine = reader.bool();
                    break;
                case /* repeated InvoicePaymentLine payment_line */ 14:
                    message.paymentLine.push(InvoicePaymentLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* double amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit64).double(message.amount);
        /* string created_date = 3; */
        if (message.createdDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.createdDate);
        /* string payment_date = 4; */
        if (message.paymentDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.paymentDate);
        /* string payment_type_id = 5; */
        if (message.paymentTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentTypeId);
        /* int32 customer_id = 6; */
        if (message.customerId !== 0)
            writer.tag(6, WireType.Varint).int32(message.customerId);
        /* int32 creator_id = 7; */
        if (message.creatorId !== 0)
            writer.tag(7, WireType.Varint).int32(message.creatorId);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 10; */
        if (message.orderBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 11; */
        if (message.orderDir !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* bool include_payment_line = 13; */
        if (message.includePaymentLine !== false)
            writer.tag(13, WireType.Varint).bool(message.includePaymentLine);
        /* repeated InvoicePaymentLine payment_line = 14; */
        for (let i = 0; i < message.paymentLine.length; i++)
            InvoicePaymentLine.internalBinaryWrite(message.paymentLine[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePayment
 */
export const InvoicePayment = new InvoicePayment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentList$Type extends MessageType {
    constructor() {
        super("InvoicePaymentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoicePayment },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated InvoicePayment results */ 1:
                    message.results.push(InvoicePayment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated InvoicePayment results = 1; */
        for (let i = 0; i < message.results.length; i++)
            InvoicePayment.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentList
 */
export const InvoicePaymentList = new InvoicePaymentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentLine$Type extends MessageType {
    constructor() {
        super("InvoicePaymentLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "payment_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "creator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.invoiceId = 0;
        message.paymentId = 0;
        message.amount = 0;
        message.createdDate = "";
        message.isActive = false;
        message.creatorId = 0;
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 invoice_id */ 2:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 payment_id */ 3:
                    message.paymentId = reader.int32();
                    break;
                case /* double amount */ 4:
                    message.amount = reader.double();
                    break;
                case /* string created_date */ 5:
                    message.createdDate = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* int32 creator_id */ 7:
                    message.creatorId = reader.int32();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 event_id */ 12:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 invoice_id = 2; */
        if (message.invoiceId !== 0)
            writer.tag(2, WireType.Varint).int32(message.invoiceId);
        /* int32 payment_id = 3; */
        if (message.paymentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.paymentId);
        /* double amount = 4; */
        if (message.amount !== 0)
            writer.tag(4, WireType.Bit64).double(message.amount);
        /* string created_date = 5; */
        if (message.createdDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdDate);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* int32 creator_id = 7; */
        if (message.creatorId !== 0)
            writer.tag(7, WireType.Varint).int32(message.creatorId);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* int32 event_id = 12; */
        if (message.eventId !== 0)
            writer.tag(12, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentLine
 */
export const InvoicePaymentLine = new InvoicePaymentLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentLineList$Type extends MessageType {
    constructor() {
        super("InvoicePaymentLineList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoicePaymentLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated InvoicePaymentLine results */ 1:
                    message.results.push(InvoicePaymentLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated InvoicePaymentLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            InvoicePaymentLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentLineList
 */
export const InvoicePaymentLineList = new InvoicePaymentLineList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallCountResponse$Type extends MessageType {
    constructor() {
        super("CallCountResponse", [
            { no: 1, name: "call_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "jobs_in_window", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.callCount = 0;
        message.jobsInWindow = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 call_count */ 1:
                    message.callCount = reader.int32();
                    break;
                case /* repeated Event jobs_in_window */ 2:
                    message.jobsInWindow.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 call_count = 1; */
        if (message.callCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.callCount);
        /* repeated Event jobs_in_window = 2; */
        for (let i = 0; i < message.jobsInWindow.length; i++)
            Event.internalBinaryWrite(message.jobsInWindow[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallCountResponse
 */
export const CallCountResponse = new CallCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallCountRequest$Type extends MessageType {
    constructor() {
        super("CallCountRequest", [
            { no: 1, name: "start_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startTime = "";
        message.endTime = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string start_time */ 1:
                    message.startTime = reader.string();
                    break;
                case /* string end_time */ 2:
                    message.endTime = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string start_time = 1; */
        if (message.startTime !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.startTime);
        /* string end_time = 2; */
        if (message.endTime !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.endTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallCountRequest
 */
export const CallCountRequest = new CallCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserByPhoneRequest$Type extends MessageType {
    constructor() {
        super("SearchUserByPhoneRequest", [
            { no: 1, name: "phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "date_target", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "interval_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.phoneNumber = "";
        message.dateTarget = "";
        message.intervalDays = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string phone_number */ 1:
                    message.phoneNumber = reader.string();
                    break;
                case /* string date_target */ 2:
                    message.dateTarget = reader.string();
                    break;
                case /* int32 interval_days */ 3:
                    message.intervalDays = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string phone_number = 1; */
        if (message.phoneNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.phoneNumber);
        /* string date_target = 2; */
        if (message.dateTarget !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateTarget);
        /* int32 interval_days = 3; */
        if (message.intervalDays !== 0)
            writer.tag(3, WireType.Varint).int32(message.intervalDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchUserByPhoneRequest
 */
export const SearchUserByPhoneRequest = new SearchUserByPhoneRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserByPhoneResponse$Type extends MessageType {
    constructor() {
        super("SearchUserByPhoneResponse", [
            { no: 1, name: "user_activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRelevantData },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userActivities = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated UserRelevantData user_activities */ 1:
                    message.userActivities.push(UserRelevantData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* User user */ 3:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated UserRelevantData user_activities = 1; */
        for (let i = 0; i < message.userActivities.length; i++)
            UserRelevantData.internalBinaryWrite(message.userActivities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* User user = 3; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchUserByPhoneResponse
 */
export const SearchUserByPhoneResponse = new SearchUserByPhoneResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserRelevantData$Type extends MessageType {
    constructor() {
        super("UserRelevantData", [
            { no: 1, name: "data_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "data_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "data_internal_reference", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiring_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "priority", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dataId = 0;
        message.userId = 0;
        message.dataType = "";
        message.dataInternalReference = "";
        message.typeDescription = "";
        message.expiringDate = "";
        message.priority = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 data_id */ 1:
                    message.dataId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string data_type */ 3:
                    message.dataType = reader.string();
                    break;
                case /* string data_internal_reference */ 4:
                    message.dataInternalReference = reader.string();
                    break;
                case /* string type_description */ 5:
                    message.typeDescription = reader.string();
                    break;
                case /* string expiring_date */ 6:
                    message.expiringDate = reader.string();
                    break;
                case /* float priority */ 7:
                    message.priority = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 data_id = 1; */
        if (message.dataId !== 0)
            writer.tag(1, WireType.Varint).int32(message.dataId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string data_type = 3; */
        if (message.dataType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dataType);
        /* string data_internal_reference = 4; */
        if (message.dataInternalReference !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dataInternalReference);
        /* string type_description = 5; */
        if (message.typeDescription !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.typeDescription);
        /* string expiring_date = 6; */
        if (message.expiringDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.expiringDate);
        /* float priority = 7; */
        if (message.priority !== 0)
            writer.tag(7, WireType.Bit32).float(message.priority);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserRelevantData
 */
export const UserRelevantData = new UserRelevantData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentType$Type extends MessageType {
    constructor() {
        super("PaymentType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string field_mask */ 3:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 4:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string field_mask = 3; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 4; */
        if (message.pageNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentType
 */
export const PaymentType = new PaymentType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentTypeList$Type extends MessageType {
    constructor() {
        super("PaymentTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PaymentType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PaymentType results */ 1:
                    message.results.push(PaymentType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PaymentType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PaymentType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentTypeList
 */
export const PaymentTypeList = new PaymentTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicesRenderedPaymentType$Type extends MessageType {
    constructor() {
        super("ServicesRenderedPaymentType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_collected", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.isCollected = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 is_collected */ 3:
                    message.isCollected = reader.int32();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 5:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 is_collected = 3; */
        if (message.isCollected !== 0)
            writer.tag(3, WireType.Varint).int32(message.isCollected);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 5; */
        if (message.pageNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServicesRenderedPaymentType
 */
export const ServicesRenderedPaymentType = new ServicesRenderedPaymentType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicesRenderedPaymentTypeList$Type extends MessageType {
    constructor() {
        super("ServicesRenderedPaymentTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicesRenderedPaymentType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ServicesRenderedPaymentType results */ 1:
                    message.results.push(ServicesRenderedPaymentType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ServicesRenderedPaymentType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ServicesRenderedPaymentType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServicesRenderedPaymentTypeList
 */
export const ServicesRenderedPaymentTypeList = new ServicesRenderedPaymentTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FetchProjectCostAndEstimateRequest$Type extends MessageType {
    constructor() {
        super("FetchProjectCostAndEstimateRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FetchProjectCostAndEstimateRequest
 */
export const FetchProjectCostAndEstimateRequest = new FetchProjectCostAndEstimateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FetchProjectCostAndEstimateResponse$Type extends MessageType {
    constructor() {
        super("FetchProjectCostAndEstimateResponse", [
            { no: 1, name: "transaction_results", kind: "message", T: () => TransactionList },
            { no: 2, name: "timesheet_results", kind: "message", T: () => TimesheetLineList },
            { no: 3, name: "perdiem_results", kind: "message", T: () => PerDiemList },
            { no: 4, name: "trip_results", kind: "message", T: () => TripList },
            { no: 5, name: "estimates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Estimate },
            { no: 6, name: "expends", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Expended },
            { no: 7, name: "changeOrders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ChangeOrder }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.estimates = [];
        message.expends = [];
        message.changeOrders = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TransactionList transaction_results */ 1:
                    message.transactionResults = TransactionList.internalBinaryRead(reader, reader.uint32(), options, message.transactionResults);
                    break;
                case /* TimesheetLineList timesheet_results */ 2:
                    message.timesheetResults = TimesheetLineList.internalBinaryRead(reader, reader.uint32(), options, message.timesheetResults);
                    break;
                case /* PerDiemList perdiem_results */ 3:
                    message.perdiemResults = PerDiemList.internalBinaryRead(reader, reader.uint32(), options, message.perdiemResults);
                    break;
                case /* TripList trip_results */ 4:
                    message.tripResults = TripList.internalBinaryRead(reader, reader.uint32(), options, message.tripResults);
                    break;
                case /* repeated Estimate estimates */ 5:
                    message.estimates.push(Estimate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Expended expends */ 6:
                    message.expends.push(Expended.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ChangeOrder changeOrders */ 7:
                    message.changeOrders.push(ChangeOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TransactionList transaction_results = 1; */
        if (message.transactionResults)
            TransactionList.internalBinaryWrite(message.transactionResults, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* TimesheetLineList timesheet_results = 2; */
        if (message.timesheetResults)
            TimesheetLineList.internalBinaryWrite(message.timesheetResults, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* PerDiemList perdiem_results = 3; */
        if (message.perdiemResults)
            PerDiemList.internalBinaryWrite(message.perdiemResults, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* TripList trip_results = 4; */
        if (message.tripResults)
            TripList.internalBinaryWrite(message.tripResults, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated Estimate estimates = 5; */
        for (let i = 0; i < message.estimates.length; i++)
            Estimate.internalBinaryWrite(message.estimates[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated Expended expends = 6; */
        for (let i = 0; i < message.expends.length; i++)
            Expended.internalBinaryWrite(message.expends[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated ChangeOrder changeOrders = 7; */
        for (let i = 0; i < message.changeOrders.length; i++)
            ChangeOrder.internalBinaryWrite(message.changeOrders[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FetchProjectCostAndEstimateResponse
 */
export const FetchProjectCostAndEstimateResponse = new FetchProjectCostAndEstimateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceRequest$Type extends MessageType {
    constructor() {
        super("InvoiceRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "email_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email_cc", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "signature", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "includePaymentLink", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "skip_email", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.emailTo = "";
        message.emailCc = [];
        message.signature = false;
        message.includePaymentLink = false;
        message.skipEmail = false;
        message.paymentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* string email_to */ 2:
                    message.emailTo = reader.string();
                    break;
                case /* repeated string email_cc */ 3:
                    message.emailCc.push(reader.string());
                    break;
                case /* bool signature */ 4:
                    message.signature = reader.bool();
                    break;
                case /* bool includePaymentLink */ 5:
                    message.includePaymentLink = reader.bool();
                    break;
                case /* bool skip_email */ 6:
                    message.skipEmail = reader.bool();
                    break;
                case /* string payment_type */ 7:
                    message.paymentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* string email_to = 2; */
        if (message.emailTo !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailTo);
        /* repeated string email_cc = 3; */
        for (let i = 0; i < message.emailCc.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.emailCc[i]);
        /* bool signature = 4; */
        if (message.signature !== false)
            writer.tag(4, WireType.Varint).bool(message.signature);
        /* bool includePaymentLink = 5; */
        if (message.includePaymentLink !== false)
            writer.tag(5, WireType.Varint).bool(message.includePaymentLink);
        /* bool skip_email = 6; */
        if (message.skipEmail !== false)
            writer.tag(6, WireType.Varint).bool(message.skipEmail);
        /* string payment_type = 7; */
        if (message.paymentType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.paymentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceRequest
 */
export const InvoiceRequest = new InvoiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePaymentIntentRequest$Type extends MessageType {
    constructor() {
        super("CreatePaymentIntentRequest", [
            { no: 1, name: "amount", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "invoice_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "customer_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customer_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.amount = 0n;
        message.currency = "";
        message.description = "";
        message.invoiceId = 0n;
        message.customerId = 0n;
        message.jobNumber = "";
        message.customerEmail = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 amount */ 1:
                    message.amount = reader.int64().toBigInt();
                    break;
                case /* string currency */ 2:
                    message.currency = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* int64 invoice_id */ 4:
                    message.invoiceId = reader.int64().toBigInt();
                    break;
                case /* int64 customer_id */ 5:
                    message.customerId = reader.int64().toBigInt();
                    break;
                case /* string job_number */ 6:
                    message.jobNumber = reader.string();
                    break;
                case /* string customer_email */ 7:
                    message.customerEmail = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 amount = 1; */
        if (message.amount !== 0n)
            writer.tag(1, WireType.Varint).int64(message.amount);
        /* string currency = 2; */
        if (message.currency !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.currency);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* int64 invoice_id = 4; */
        if (message.invoiceId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.invoiceId);
        /* int64 customer_id = 5; */
        if (message.customerId !== 0n)
            writer.tag(5, WireType.Varint).int64(message.customerId);
        /* string job_number = 6; */
        if (message.jobNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.jobNumber);
        /* string customer_email = 7; */
        if (message.customerEmail !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customerEmail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePaymentIntentRequest
 */
export const CreatePaymentIntentRequest = new CreatePaymentIntentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePaymentIntentResponse$Type extends MessageType {
    constructor() {
        super("CreatePaymentIntentResponse", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.clientSecret = "";
        message.paymentIntentId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_secret */ 1:
                    message.clientSecret = reader.string();
                    break;
                case /* string payment_intent_id */ 2:
                    message.paymentIntentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string client_secret = 1; */
        if (message.clientSecret !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientSecret);
        /* string payment_intent_id = 2; */
        if (message.paymentIntentId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentIntentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePaymentIntentResponse
 */
export const CreatePaymentIntentResponse = new CreatePaymentIntentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentTokenRequest$Type extends MessageType {
    constructor() {
        super("InvoicePaymentTokenRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "expiring_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.expiringDate = "";
        message.paymentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* string expiring_date */ 2:
                    message.expiringDate = reader.string();
                    break;
                case /* string payment_type */ 3:
                    message.paymentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* string expiring_date = 2; */
        if (message.expiringDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.expiringDate);
        /* string payment_type = 3; */
        if (message.paymentType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentTokenRequest
 */
export const InvoicePaymentTokenRequest = new InvoicePaymentTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentLinkRequest$Type extends MessageType {
    constructor() {
        super("InvoicePaymentLinkRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "days_to_expire", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.daysToExpire = 0;
        message.paymentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 days_to_expire */ 2:
                    message.daysToExpire = reader.int32();
                    break;
                case /* string payment_type */ 3:
                    message.paymentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* int32 days_to_expire = 2; */
        if (message.daysToExpire !== 0)
            writer.tag(2, WireType.Varint).int32(message.daysToExpire);
        /* string payment_type = 3; */
        if (message.paymentType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentLinkRequest
 */
export const InvoicePaymentLinkRequest = new InvoicePaymentLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentTokenResponse$Type extends MessageType {
    constructor() {
        super("InvoicePaymentTokenResponse", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "payment_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.paymentUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string payment_url */ 2:
                    message.paymentUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string payment_url = 2; */
        if (message.paymentUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentTokenResponse
 */
export const InvoicePaymentTokenResponse = new InvoicePaymentTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentToken$Type extends MessageType {
    constructor() {
        super("InvoicePaymentToken", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount_to_pay", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.paymentType = "";
        message.amountToPay = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string payment_type */ 2:
                    message.paymentType = reader.string();
                    break;
                case /* double amount_to_pay */ 3:
                    message.amountToPay = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string payment_type = 2; */
        if (message.paymentType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentType);
        /* double amount_to_pay = 3; */
        if (message.amountToPay !== 0)
            writer.tag(3, WireType.Bit64).double(message.amountToPay);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentToken
 */
export const InvoicePaymentToken = new InvoicePaymentToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicInvoicePaymentResponse$Type extends MessageType {
    constructor() {
        super("PublicInvoicePaymentResponse", [
            { no: 1, name: "event", kind: "message", T: () => Event },
            { no: 2, name: "invoice", kind: "message", T: () => Invoice },
            { no: 3, name: "quote_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 4, name: "materials", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Quotable },
            { no: 5, name: "quote_used_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteUsed },
            { no: 6, name: "customer", kind: "message", T: () => User },
            { no: 7, name: "property", kind: "message", T: () => Property },
            { no: 8, name: "payments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Payment },
            { no: 9, name: "totals", kind: "message", T: () => InvoiceTotals },
            { no: 10, name: "stripe_payment_intent", kind: "message", T: () => StripePaymentIntent },
            { no: 11, name: "token_info", kind: "message", T: () => TokenInfo },
            { no: 12, name: "stripe_publishable_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "checkout_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteLines = [];
        message.materials = [];
        message.quoteUsedData = [];
        message.payments = [];
        message.stripePublishableKey = "";
        message.checkoutToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event event */ 1:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* Invoice invoice */ 2:
                    message.invoice = Invoice.internalBinaryRead(reader, reader.uint32(), options, message.invoice);
                    break;
                case /* repeated QuoteLine quote_lines */ 3:
                    message.quoteLines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Quotable materials */ 4:
                    message.materials.push(Quotable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated QuoteUsed quote_used_data */ 5:
                    message.quoteUsedData.push(QuoteUsed.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* User customer */ 6:
                    message.customer = User.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* Property property */ 7:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* repeated Payment payments */ 8:
                    message.payments.push(Payment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* InvoiceTotals totals */ 9:
                    message.totals = InvoiceTotals.internalBinaryRead(reader, reader.uint32(), options, message.totals);
                    break;
                case /* StripePaymentIntent stripe_payment_intent */ 10:
                    message.stripePaymentIntent = StripePaymentIntent.internalBinaryRead(reader, reader.uint32(), options, message.stripePaymentIntent);
                    break;
                case /* TokenInfo token_info */ 11:
                    message.tokenInfo = TokenInfo.internalBinaryRead(reader, reader.uint32(), options, message.tokenInfo);
                    break;
                case /* string stripe_publishable_key */ 12:
                    message.stripePublishableKey = reader.string();
                    break;
                case /* string checkout_token */ 13:
                    message.checkoutToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event event = 1; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Invoice invoice = 2; */
        if (message.invoice)
            Invoice.internalBinaryWrite(message.invoice, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated QuoteLine quote_lines = 3; */
        for (let i = 0; i < message.quoteLines.length; i++)
            QuoteLine.internalBinaryWrite(message.quoteLines[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated Quotable materials = 4; */
        for (let i = 0; i < message.materials.length; i++)
            Quotable.internalBinaryWrite(message.materials[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated QuoteUsed quote_used_data = 5; */
        for (let i = 0; i < message.quoteUsedData.length; i++)
            QuoteUsed.internalBinaryWrite(message.quoteUsedData[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* User customer = 6; */
        if (message.customer)
            User.internalBinaryWrite(message.customer, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 7; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated Payment payments = 8; */
        for (let i = 0; i < message.payments.length; i++)
            Payment.internalBinaryWrite(message.payments[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* InvoiceTotals totals = 9; */
        if (message.totals)
            InvoiceTotals.internalBinaryWrite(message.totals, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* StripePaymentIntent stripe_payment_intent = 10; */
        if (message.stripePaymentIntent)
            StripePaymentIntent.internalBinaryWrite(message.stripePaymentIntent, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* TokenInfo token_info = 11; */
        if (message.tokenInfo)
            TokenInfo.internalBinaryWrite(message.tokenInfo, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_publishable_key = 12; */
        if (message.stripePublishableKey !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.stripePublishableKey);
        /* string checkout_token = 13; */
        if (message.checkoutToken !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.checkoutToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicInvoicePaymentResponse
 */
export const PublicInvoicePaymentResponse = new PublicInvoicePaymentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceTotals$Type extends MessageType {
    constructor() {
        super("InvoiceTotals", [
            { no: 1, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "discount_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "grand_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "is_warranty_or_no_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "tax_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_paid", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "total_due", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "retainage_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subtotal = 0;
        message.discountAmount = 0;
        message.grandTotal = 0;
        message.isWarrantyOrNoCharge = false;
        message.taxAmount = 0;
        message.totalPaid = 0;
        message.totalDue = 0;
        message.retainageAmount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double subtotal */ 1:
                    message.subtotal = reader.double();
                    break;
                case /* double discount_amount */ 2:
                    message.discountAmount = reader.double();
                    break;
                case /* double grand_total */ 3:
                    message.grandTotal = reader.double();
                    break;
                case /* bool is_warranty_or_no_charge */ 4:
                    message.isWarrantyOrNoCharge = reader.bool();
                    break;
                case /* double tax_amount */ 5:
                    message.taxAmount = reader.double();
                    break;
                case /* double total_paid */ 6:
                    message.totalPaid = reader.double();
                    break;
                case /* double total_due */ 7:
                    message.totalDue = reader.double();
                    break;
                case /* double retainage_amount */ 8:
                    message.retainageAmount = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double subtotal = 1; */
        if (message.subtotal !== 0)
            writer.tag(1, WireType.Bit64).double(message.subtotal);
        /* double discount_amount = 2; */
        if (message.discountAmount !== 0)
            writer.tag(2, WireType.Bit64).double(message.discountAmount);
        /* double grand_total = 3; */
        if (message.grandTotal !== 0)
            writer.tag(3, WireType.Bit64).double(message.grandTotal);
        /* bool is_warranty_or_no_charge = 4; */
        if (message.isWarrantyOrNoCharge !== false)
            writer.tag(4, WireType.Varint).bool(message.isWarrantyOrNoCharge);
        /* double tax_amount = 5; */
        if (message.taxAmount !== 0)
            writer.tag(5, WireType.Bit64).double(message.taxAmount);
        /* double total_paid = 6; */
        if (message.totalPaid !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalPaid);
        /* double total_due = 7; */
        if (message.totalDue !== 0)
            writer.tag(7, WireType.Bit64).double(message.totalDue);
        /* double retainage_amount = 8; */
        if (message.retainageAmount !== 0)
            writer.tag(8, WireType.Bit64).double(message.retainageAmount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceTotals
 */
export const InvoiceTotals = new InvoiceTotals$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripePaymentIntent$Type extends MessageType {
    constructor() {
        super("StripePaymentIntent", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.clientSecret = "";
        message.amount = 0n;
        message.currency = "";
        message.paymentIntentId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_secret */ 1:
                    message.clientSecret = reader.string();
                    break;
                case /* int64 amount */ 2:
                    message.amount = reader.int64().toBigInt();
                    break;
                case /* string currency */ 3:
                    message.currency = reader.string();
                    break;
                case /* string payment_intent_id */ 4:
                    message.paymentIntentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string client_secret = 1; */
        if (message.clientSecret !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientSecret);
        /* int64 amount = 2; */
        if (message.amount !== 0n)
            writer.tag(2, WireType.Varint).int64(message.amount);
        /* string currency = 3; */
        if (message.currency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currency);
        /* string payment_intent_id = 4; */
        if (message.paymentIntentId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.paymentIntentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripePaymentIntent
 */
export const StripePaymentIntent = new StripePaymentIntent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenInfo$Type extends MessageType {
    constructor() {
        super("TokenInfo", [
            { no: 1, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "expires_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.isValid = false;
        message.expiresAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_valid */ 1:
                    message.isValid = reader.bool();
                    break;
                case /* string expires_at */ 2:
                    message.expiresAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool is_valid = 1; */
        if (message.isValid !== false)
            writer.tag(1, WireType.Varint).bool(message.isValid);
        /* string expires_at = 2; */
        if (message.expiresAt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TokenInfo
 */
export const TokenInfo = new TokenInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordInvoicePaymentRequest$Type extends MessageType {
    constructor() {
        super("RecordInvoicePaymentRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "payment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.amount = 0;
        message.paymentDate = "";
        message.paymentMethod = "";
        message.referenceNumber = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* double amount */ 2:
                    message.amount = reader.double();
                    break;
                case /* string payment_date */ 3:
                    message.paymentDate = reader.string();
                    break;
                case /* string payment_method */ 4:
                    message.paymentMethod = reader.string();
                    break;
                case /* string reference_number */ 5:
                    message.referenceNumber = reader.string();
                    break;
                case /* string notes */ 6:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* double amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit64).double(message.amount);
        /* string payment_date = 3; */
        if (message.paymentDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentDate);
        /* string payment_method = 4; */
        if (message.paymentMethod !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.paymentMethod);
        /* string reference_number = 5; */
        if (message.referenceNumber !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.referenceNumber);
        /* string notes = 6; */
        if (message.notes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RecordInvoicePaymentRequest
 */
export const RecordInvoicePaymentRequest = new RecordInvoicePaymentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordInvoicePaymentResponse$Type extends MessageType {
    constructor() {
        super("RecordInvoicePaymentResponse", [
            { no: 1, name: "payment", kind: "message", T: () => InvoicePayment },
            { no: 2, name: "payment_line", kind: "message", T: () => InvoicePaymentLine },
            { no: 3, name: "updated_balance", kind: "message", T: () => InvoiceBalance }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InvoicePayment payment */ 1:
                    message.payment = InvoicePayment.internalBinaryRead(reader, reader.uint32(), options, message.payment);
                    break;
                case /* InvoicePaymentLine payment_line */ 2:
                    message.paymentLine = InvoicePaymentLine.internalBinaryRead(reader, reader.uint32(), options, message.paymentLine);
                    break;
                case /* InvoiceBalance updated_balance */ 3:
                    message.updatedBalance = InvoiceBalance.internalBinaryRead(reader, reader.uint32(), options, message.updatedBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InvoicePayment payment = 1; */
        if (message.payment)
            InvoicePayment.internalBinaryWrite(message.payment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* InvoicePaymentLine payment_line = 2; */
        if (message.paymentLine)
            InvoicePaymentLine.internalBinaryWrite(message.paymentLine, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* InvoiceBalance updated_balance = 3; */
        if (message.updatedBalance)
            InvoiceBalance.internalBinaryWrite(message.updatedBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RecordInvoicePaymentResponse
 */
export const RecordInvoicePaymentResponse = new RecordInvoicePaymentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentHistoryRequest$Type extends MessageType {
    constructor() {
        super("InvoicePaymentHistoryRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentHistoryRequest
 */
export const InvoicePaymentHistoryRequest = new InvoicePaymentHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoicePaymentHistoryResponse$Type extends MessageType {
    constructor() {
        super("InvoicePaymentHistoryResponse", [
            { no: 1, name: "payment_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoicePaymentLine },
            { no: 2, name: "total_paid", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_due", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.paymentLines = [];
        message.totalPaid = 0;
        message.totalDue = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated InvoicePaymentLine payment_lines */ 1:
                    message.paymentLines.push(InvoicePaymentLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* double total_paid */ 2:
                    message.totalPaid = reader.double();
                    break;
                case /* double total_due */ 3:
                    message.totalDue = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated InvoicePaymentLine payment_lines = 1; */
        for (let i = 0; i < message.paymentLines.length; i++)
            InvoicePaymentLine.internalBinaryWrite(message.paymentLines[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* double total_paid = 2; */
        if (message.totalPaid !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalPaid);
        /* double total_due = 3; */
        if (message.totalDue !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalDue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoicePaymentHistoryResponse
 */
export const InvoicePaymentHistoryResponse = new InvoicePaymentHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceBalance$Type extends MessageType {
    constructor() {
        super("InvoiceBalance", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_paid", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "amount_due", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.totalAmount = 0;
        message.totalPaid = 0;
        message.amountDue = 0;
        message.paymentStatus = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* double total_amount */ 2:
                    message.totalAmount = reader.double();
                    break;
                case /* double total_paid */ 3:
                    message.totalPaid = reader.double();
                    break;
                case /* double amount_due */ 4:
                    message.amountDue = reader.double();
                    break;
                case /* string payment_status */ 5:
                    message.paymentStatus = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* double total_amount = 2; */
        if (message.totalAmount !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalAmount);
        /* double total_paid = 3; */
        if (message.totalPaid !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalPaid);
        /* double amount_due = 4; */
        if (message.amountDue !== 0)
            writer.tag(4, WireType.Bit64).double(message.amountDue);
        /* string payment_status = 5; */
        if (message.paymentStatus !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceBalance
 */
export const InvoiceBalance = new InvoiceBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnifiedJobSearchRequest$Type extends MessageType {
    constructor() {
        super("UnifiedJobSearchRequest", [
            { no: 1, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "property_additional_address_line", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_started_from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "date_started_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "date_ended_from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "date_ended_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "technician_assigned", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "projects_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "service_calls_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "log_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "is_residential", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "services_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "global_search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "geo_lat", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 36, name: "geo_lng", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 37, name: "radius_miles", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 40, name: "date_completed_from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "date_completed_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "pending_billing_queue", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 42, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobNumber = "";
        message.departmentId = 0;
        message.customerName = "";
        message.businessName = "";
        message.propertyAddress = "";
        message.propertyAdditionalAddressLine = "";
        message.city = "";
        message.state = "";
        message.zip = "";
        message.jobStatus = "";
        message.paymentStatus = "";
        message.dateStartedFrom = "";
        message.dateStartedTo = "";
        message.dateEndedFrom = "";
        message.dateEndedTo = "";
        message.technicianAssigned = "";
        message.poNumber = "";
        message.isActive = false;
        message.projectsOnly = false;
        message.serviceCallsOnly = false;
        message.pageNumber = 0;
        message.pageSize = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.countOnly = false;
        message.withoutLimit = false;
        message.name = "";
        message.logNotes = "";
        message.isResidential = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.servicesNeeded = "";
        message.firstName = "";
        message.lastName = "";
        message.globalSearch = "";
        message.geoLat = 0;
        message.geoLng = 0;
        message.radiusMiles = 0;
        message.dateCompletedFrom = "";
        message.dateCompletedTo = "";
        message.pendingBillingQueue = false;
        message.propertyId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string job_number */ 1:
                    message.jobNumber = reader.string();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* string customer_name */ 3:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 4:
                    message.businessName = reader.string();
                    break;
                case /* string property_address */ 5:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_additional_address_line */ 38:
                    message.propertyAdditionalAddressLine = reader.string();
                    break;
                case /* string city */ 6:
                    message.city = reader.string();
                    break;
                case /* string state */ 7:
                    message.state = reader.string();
                    break;
                case /* string zip */ 8:
                    message.zip = reader.string();
                    break;
                case /* string job_status */ 9:
                    message.jobStatus = reader.string();
                    break;
                case /* string payment_status */ 10:
                    message.paymentStatus = reader.string();
                    break;
                case /* string date_started_from */ 11:
                    message.dateStartedFrom = reader.string();
                    break;
                case /* string date_started_to */ 12:
                    message.dateStartedTo = reader.string();
                    break;
                case /* string date_ended_from */ 13:
                    message.dateEndedFrom = reader.string();
                    break;
                case /* string date_ended_to */ 14:
                    message.dateEndedTo = reader.string();
                    break;
                case /* string technician_assigned */ 15:
                    message.technicianAssigned = reader.string();
                    break;
                case /* string po_number */ 16:
                    message.poNumber = reader.string();
                    break;
                case /* bool is_active */ 17:
                    message.isActive = reader.bool();
                    break;
                case /* bool projects_only */ 18:
                    message.projectsOnly = reader.bool();
                    break;
                case /* bool service_calls_only */ 19:
                    message.serviceCallsOnly = reader.bool();
                    break;
                case /* int32 page_number */ 20:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 page_size */ 21:
                    message.pageSize = reader.int32();
                    break;
                case /* string order_by */ 22:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 23:
                    message.orderDir = reader.string();
                    break;
                case /* bool count_only */ 24:
                    message.countOnly = reader.bool();
                    break;
                case /* bool without_limit */ 25:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string name */ 26:
                    message.name = reader.string();
                    break;
                case /* string log_notes */ 27:
                    message.logNotes = reader.string();
                    break;
                case /* int32 is_residential */ 28:
                    message.isResidential = reader.int32();
                    break;
                case /* int32 job_type_id */ 29:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 30:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string services_needed */ 31:
                    message.servicesNeeded = reader.string();
                    break;
                case /* string first_name */ 32:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 33:
                    message.lastName = reader.string();
                    break;
                case /* string global_search */ 34:
                    message.globalSearch = reader.string();
                    break;
                case /* double geo_lat */ 35:
                    message.geoLat = reader.double();
                    break;
                case /* double geo_lng */ 36:
                    message.geoLng = reader.double();
                    break;
                case /* double radius_miles */ 37:
                    message.radiusMiles = reader.double();
                    break;
                case /* string date_completed_from */ 40:
                    message.dateCompletedFrom = reader.string();
                    break;
                case /* string date_completed_to */ 41:
                    message.dateCompletedTo = reader.string();
                    break;
                case /* bool pending_billing_queue */ 39:
                    message.pendingBillingQueue = reader.bool();
                    break;
                case /* int32 property_id */ 42:
                    message.propertyId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string job_number = 1; */
        if (message.jobNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jobNumber);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* string customer_name = 3; */
        if (message.customerName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 4; */
        if (message.businessName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.businessName);
        /* string property_address = 5; */
        if (message.propertyAddress !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.propertyAddress);
        /* string city = 6; */
        if (message.city !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.city);
        /* string state = 7; */
        if (message.state !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.state);
        /* string zip = 8; */
        if (message.zip !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.zip);
        /* string job_status = 9; */
        if (message.jobStatus !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.jobStatus);
        /* string payment_status = 10; */
        if (message.paymentStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.paymentStatus);
        /* string date_started_from = 11; */
        if (message.dateStartedFrom !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateStartedFrom);
        /* string date_started_to = 12; */
        if (message.dateStartedTo !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.dateStartedTo);
        /* string date_ended_from = 13; */
        if (message.dateEndedFrom !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.dateEndedFrom);
        /* string date_ended_to = 14; */
        if (message.dateEndedTo !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.dateEndedTo);
        /* string technician_assigned = 15; */
        if (message.technicianAssigned !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.technicianAssigned);
        /* string po_number = 16; */
        if (message.poNumber !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.poNumber);
        /* bool is_active = 17; */
        if (message.isActive !== false)
            writer.tag(17, WireType.Varint).bool(message.isActive);
        /* bool projects_only = 18; */
        if (message.projectsOnly !== false)
            writer.tag(18, WireType.Varint).bool(message.projectsOnly);
        /* bool service_calls_only = 19; */
        if (message.serviceCallsOnly !== false)
            writer.tag(19, WireType.Varint).bool(message.serviceCallsOnly);
        /* int32 page_number = 20; */
        if (message.pageNumber !== 0)
            writer.tag(20, WireType.Varint).int32(message.pageNumber);
        /* int32 page_size = 21; */
        if (message.pageSize !== 0)
            writer.tag(21, WireType.Varint).int32(message.pageSize);
        /* string order_by = 22; */
        if (message.orderBy !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 23; */
        if (message.orderDir !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.orderDir);
        /* bool count_only = 24; */
        if (message.countOnly !== false)
            writer.tag(24, WireType.Varint).bool(message.countOnly);
        /* bool without_limit = 25; */
        if (message.withoutLimit !== false)
            writer.tag(25, WireType.Varint).bool(message.withoutLimit);
        /* string name = 26; */
        if (message.name !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.name);
        /* string log_notes = 27; */
        if (message.logNotes !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.logNotes);
        /* int32 is_residential = 28; */
        if (message.isResidential !== 0)
            writer.tag(28, WireType.Varint).int32(message.isResidential);
        /* int32 job_type_id = 29; */
        if (message.jobTypeId !== 0)
            writer.tag(29, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 30; */
        if (message.jobSubtypeId !== 0)
            writer.tag(30, WireType.Varint).int32(message.jobSubtypeId);
        /* string services_needed = 31; */
        if (message.servicesNeeded !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.servicesNeeded);
        /* string first_name = 32; */
        if (message.firstName !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 33; */
        if (message.lastName !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.lastName);
        /* string global_search = 34; */
        if (message.globalSearch !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.globalSearch);
        /* double geo_lat = 35; */
        if (message.geoLat !== 0)
            writer.tag(35, WireType.Bit64).double(message.geoLat);
        /* double geo_lng = 36; */
        if (message.geoLng !== 0)
            writer.tag(36, WireType.Bit64).double(message.geoLng);
        /* double radius_miles = 37; */
        if (message.radiusMiles !== 0)
            writer.tag(37, WireType.Bit64).double(message.radiusMiles);
        /* string property_additional_address_line = 38; */
        if (message.propertyAdditionalAddressLine !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.propertyAdditionalAddressLine);
        /* bool pending_billing_queue = 39; */
        if (message.pendingBillingQueue !== false)
            writer.tag(39, WireType.Varint).bool(message.pendingBillingQueue);
        /* string date_completed_from = 40; */
        if (message.dateCompletedFrom !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.dateCompletedFrom);
        /* string date_completed_to = 41; */
        if (message.dateCompletedTo !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.dateCompletedTo);
        /* int32 property_id = 42; */
        if (message.propertyId !== 0)
            writer.tag(42, WireType.Varint).int32(message.propertyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnifiedJobSearchRequest
 */
export const UnifiedJobSearchRequest = new UnifiedJobSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnifiedJobSearchResult$Type extends MessageType {
    constructor() {
        super("UnifiedJobSearchResult", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "primary_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "is_project_job", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_primary_event", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "project_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "property_zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "technician_assigned", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "log_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "is_residential", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "distance_miles", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 36, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "time_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "contract_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "sub_job_numbers", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "date_completed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "amount_charged", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.jobNumber = "";
        message.parentId = 0;
        message.projectId = 0;
        message.primaryEventId = 0;
        message.isProjectJob = false;
        message.isPrimaryEvent = false;
        message.name = "";
        message.description = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.jobStatus = "";
        message.paymentStatus = "";
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.projectName = "";
        message.customerName = "";
        message.businessName = "";
        message.customerId = 0;
        message.propertyId = 0;
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.propertyZip = "";
        message.technicianAssigned = "";
        message.poNumber = "";
        message.isActive = false;
        message.dateCreated = "";
        message.dateUpdated = "";
        message.logNotes = "";
        message.isResidential = 0;
        message.firstName = "";
        message.lastName = "";
        message.distanceMiles = 0;
        message.timeStarted = "";
        message.timeEnded = "";
        message.contractNumber = "";
        message.subJobNumbers = "";
        message.dateCompleted = "";
        message.amountCharged = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string job_number */ 2:
                    message.jobNumber = reader.string();
                    break;
                case /* int32 parent_id */ 3:
                    message.parentId = reader.int32();
                    break;
                case /* int32 project_id */ 4:
                    message.projectId = reader.int32();
                    break;
                case /* int32 primary_event_id */ 5:
                    message.primaryEventId = reader.int32();
                    break;
                case /* bool is_project_job */ 6:
                    message.isProjectJob = reader.bool();
                    break;
                case /* bool is_primary_event */ 7:
                    message.isPrimaryEvent = reader.bool();
                    break;
                case /* string name */ 8:
                    message.name = reader.string();
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* string date_started */ 10:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 11:
                    message.dateEnded = reader.string();
                    break;
                case /* string job_status */ 12:
                    message.jobStatus = reader.string();
                    break;
                case /* string payment_status */ 13:
                    message.paymentStatus = reader.string();
                    break;
                case /* int32 department_id */ 14:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 15:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 16:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string project_name */ 17:
                    message.projectName = reader.string();
                    break;
                case /* string customer_name */ 18:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 19:
                    message.businessName = reader.string();
                    break;
                case /* int32 customer_id */ 20:
                    message.customerId = reader.int32();
                    break;
                case /* int32 property_id */ 21:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_address */ 22:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 23:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 24:
                    message.propertyState = reader.string();
                    break;
                case /* string property_zip */ 25:
                    message.propertyZip = reader.string();
                    break;
                case /* string technician_assigned */ 26:
                    message.technicianAssigned = reader.string();
                    break;
                case /* string po_number */ 27:
                    message.poNumber = reader.string();
                    break;
                case /* bool is_active */ 28:
                    message.isActive = reader.bool();
                    break;
                case /* string date_created */ 29:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_updated */ 30:
                    message.dateUpdated = reader.string();
                    break;
                case /* string log_notes */ 31:
                    message.logNotes = reader.string();
                    break;
                case /* int32 is_residential */ 32:
                    message.isResidential = reader.int32();
                    break;
                case /* string first_name */ 33:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 34:
                    message.lastName = reader.string();
                    break;
                case /* double distance_miles */ 35:
                    message.distanceMiles = reader.double();
                    break;
                case /* string time_started */ 36:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_ended */ 37:
                    message.timeEnded = reader.string();
                    break;
                case /* string contract_number */ 38:
                    message.contractNumber = reader.string();
                    break;
                case /* string sub_job_numbers */ 42:
                    message.subJobNumbers = reader.string();
                    break;
                case /* string date_completed */ 39:
                    message.dateCompleted = reader.string();
                    break;
                case /* string amount_charged */ 40:
                    message.amountCharged = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string job_number = 2; */
        if (message.jobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobNumber);
        /* int32 parent_id = 3; */
        if (message.parentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.parentId);
        /* int32 project_id = 4; */
        if (message.projectId !== 0)
            writer.tag(4, WireType.Varint).int32(message.projectId);
        /* int32 primary_event_id = 5; */
        if (message.primaryEventId !== 0)
            writer.tag(5, WireType.Varint).int32(message.primaryEventId);
        /* bool is_project_job = 6; */
        if (message.isProjectJob !== false)
            writer.tag(6, WireType.Varint).bool(message.isProjectJob);
        /* bool is_primary_event = 7; */
        if (message.isPrimaryEvent !== false)
            writer.tag(7, WireType.Varint).bool(message.isPrimaryEvent);
        /* string name = 8; */
        if (message.name !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.name);
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* string date_started = 10; */
        if (message.dateStarted !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 11; */
        if (message.dateEnded !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateEnded);
        /* string job_status = 12; */
        if (message.jobStatus !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.jobStatus);
        /* string payment_status = 13; */
        if (message.paymentStatus !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.paymentStatus);
        /* int32 department_id = 14; */
        if (message.departmentId !== 0)
            writer.tag(14, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 15; */
        if (message.jobTypeId !== 0)
            writer.tag(15, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 16; */
        if (message.jobSubtypeId !== 0)
            writer.tag(16, WireType.Varint).int32(message.jobSubtypeId);
        /* string project_name = 17; */
        if (message.projectName !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.projectName);
        /* string customer_name = 18; */
        if (message.customerName !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 19; */
        if (message.businessName !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.businessName);
        /* int32 customer_id = 20; */
        if (message.customerId !== 0)
            writer.tag(20, WireType.Varint).int32(message.customerId);
        /* int32 property_id = 21; */
        if (message.propertyId !== 0)
            writer.tag(21, WireType.Varint).int32(message.propertyId);
        /* string property_address = 22; */
        if (message.propertyAddress !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 23; */
        if (message.propertyCity !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 24; */
        if (message.propertyState !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.propertyState);
        /* string property_zip = 25; */
        if (message.propertyZip !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.propertyZip);
        /* string technician_assigned = 26; */
        if (message.technicianAssigned !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.technicianAssigned);
        /* string po_number = 27; */
        if (message.poNumber !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.poNumber);
        /* bool is_active = 28; */
        if (message.isActive !== false)
            writer.tag(28, WireType.Varint).bool(message.isActive);
        /* string date_created = 29; */
        if (message.dateCreated !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_updated = 30; */
        if (message.dateUpdated !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.dateUpdated);
        /* string log_notes = 31; */
        if (message.logNotes !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.logNotes);
        /* int32 is_residential = 32; */
        if (message.isResidential !== 0)
            writer.tag(32, WireType.Varint).int32(message.isResidential);
        /* string first_name = 33; */
        if (message.firstName !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 34; */
        if (message.lastName !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.lastName);
        /* double distance_miles = 35; */
        if (message.distanceMiles !== 0)
            writer.tag(35, WireType.Bit64).double(message.distanceMiles);
        /* string time_started = 36; */
        if (message.timeStarted !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_ended = 37; */
        if (message.timeEnded !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.timeEnded);
        /* string contract_number = 38; */
        if (message.contractNumber !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.contractNumber);
        /* string date_completed = 39; */
        if (message.dateCompleted !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.dateCompleted);
        /* string amount_charged = 40; */
        if (message.amountCharged !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.amountCharged);
        /* string sub_job_numbers = 42; */
        if (message.subJobNumbers !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.subJobNumbers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnifiedJobSearchResult
 */
export const UnifiedJobSearchResult = new UnifiedJobSearchResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnifiedJobSearchResponse$Type extends MessageType {
    constructor() {
        super("UnifiedJobSearchResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UnifiedJobSearchResult },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "context", kind: "message", T: () => UnifiedJobSearchResponse_SearchContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated UnifiedJobSearchResult results */ 1:
                    message.results.push(UnifiedJobSearchResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* UnifiedJobSearchResponse.SearchContext context */ 3:
                    message.context = UnifiedJobSearchResponse_SearchContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated UnifiedJobSearchResult results = 1; */
        for (let i = 0; i < message.results.length; i++)
            UnifiedJobSearchResult.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* UnifiedJobSearchResponse.SearchContext context = 3; */
        if (message.context)
            UnifiedJobSearchResponse_SearchContext.internalBinaryWrite(message.context, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnifiedJobSearchResponse
 */
export const UnifiedJobSearchResponse = new UnifiedJobSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnifiedJobSearchResponse_SearchContext$Type extends MessageType {
    constructor() {
        super("UnifiedJobSearchResponse.SearchContext", [
            { no: 1, name: "found_project", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "project_job_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "service_call_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "departments_found", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.foundProject = false;
        message.projectJobCount = 0;
        message.serviceCallCount = 0;
        message.departmentsFound = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool found_project */ 1:
                    message.foundProject = reader.bool();
                    break;
                case /* int32 project_job_count */ 2:
                    message.projectJobCount = reader.int32();
                    break;
                case /* int32 service_call_count */ 3:
                    message.serviceCallCount = reader.int32();
                    break;
                case /* repeated int32 departments_found */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentsFound.push(reader.int32());
                    else
                        message.departmentsFound.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool found_project = 1; */
        if (message.foundProject !== false)
            writer.tag(1, WireType.Varint).bool(message.foundProject);
        /* int32 project_job_count = 2; */
        if (message.projectJobCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectJobCount);
        /* int32 service_call_count = 3; */
        if (message.serviceCallCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.serviceCallCount);
        /* repeated int32 departments_found = 4; */
        if (message.departmentsFound.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentsFound.length; i++)
                writer.int32(message.departmentsFound[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnifiedJobSearchResponse.SearchContext
 */
export const UnifiedJobSearchResponse_SearchContext = new UnifiedJobSearchResponse_SearchContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventPhoto$Type extends MessageType {
    constructor() {
        super("EventPhoto", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "include_in_proposal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "include_in_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "service_item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "filter_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "include_in_service_channel", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.quoteDocumentId = 0;
        message.invoiceId = 0;
        message.fileId = 0;
        message.fileName = "";
        message.isActive = false;
        message.includeInProposal = false;
        message.includeInInvoice = false;
        message.createdAt = "";
        message.fieldMask = [];
        message.withoutLimit = false;
        message.serviceItemId = 0;
        message.fileBucket = "";
        message.serviceItemName = "";
        message.filterOrderId = 0;
        message.includeInServiceChannel = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 quote_document_id */ 3:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* int32 invoice_id */ 4:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 file_id */ 5:
                    message.fileId = reader.int32();
                    break;
                case /* string file_name */ 6:
                    message.fileName = reader.string();
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                case /* bool include_in_proposal */ 8:
                    message.includeInProposal = reader.bool();
                    break;
                case /* bool include_in_invoice */ 9:
                    message.includeInInvoice = reader.bool();
                    break;
                case /* string created_at */ 10:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 service_item_id */ 13:
                    message.serviceItemId = reader.int32();
                    break;
                case /* string file_bucket */ 14:
                    message.fileBucket = reader.string();
                    break;
                case /* string service_item_name */ 15:
                    message.serviceItemName = reader.string();
                    break;
                case /* int32 filter_order_id */ 16:
                    message.filterOrderId = reader.int32();
                    break;
                case /* bool include_in_service_channel */ 17:
                    message.includeInServiceChannel = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 quote_document_id = 3; */
        if (message.quoteDocumentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteDocumentId);
        /* int32 invoice_id = 4; */
        if (message.invoiceId !== 0)
            writer.tag(4, WireType.Varint).int32(message.invoiceId);
        /* int32 file_id = 5; */
        if (message.fileId !== 0)
            writer.tag(5, WireType.Varint).int32(message.fileId);
        /* string file_name = 6; */
        if (message.fileName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.fileName);
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        /* bool include_in_proposal = 8; */
        if (message.includeInProposal !== false)
            writer.tag(8, WireType.Varint).bool(message.includeInProposal);
        /* bool include_in_invoice = 9; */
        if (message.includeInInvoice !== false)
            writer.tag(9, WireType.Varint).bool(message.includeInInvoice);
        /* string created_at = 10; */
        if (message.createdAt !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        /* int32 service_item_id = 13; */
        if (message.serviceItemId !== 0)
            writer.tag(13, WireType.Varint).int32(message.serviceItemId);
        /* string file_bucket = 14; */
        if (message.fileBucket !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.fileBucket);
        /* string service_item_name = 15; */
        if (message.serviceItemName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.serviceItemName);
        /* int32 filter_order_id = 16; */
        if (message.filterOrderId !== 0)
            writer.tag(16, WireType.Varint).int32(message.filterOrderId);
        /* bool include_in_service_channel = 17; */
        if (message.includeInServiceChannel !== false)
            writer.tag(17, WireType.Varint).bool(message.includeInServiceChannel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventPhoto
 */
export const EventPhoto = new EventPhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventPhotoList$Type extends MessageType {
    constructor() {
        super("EventPhotoList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventPhoto },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated EventPhoto results */ 1:
                    message.results.push(EventPhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated EventPhoto results = 1; */
        for (let i = 0; i < message.results.length; i++)
            EventPhoto.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventPhotoList
 */
export const EventPhotoList = new EventPhotoList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventFeedItem$Type extends MessageType {
    constructor() {
        super("EventFeedItem", [
            { no: 1, name: "feed_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "feed_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "source_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "user_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "classification_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "activity_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "task_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "timesheet_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "diagnosis_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "is_internal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "is_pinned", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "group_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.feedId = "";
        message.feedType = "";
        message.sourceId = 0;
        message.eventId = 0;
        message.title = "";
        message.content = "";
        message.createdDate = "";
        message.userId = 0;
        message.userName = "";
        message.isActive = false;
        message.fileId = "";
        message.statusId = 0;
        message.classificationId = 0;
        message.activityName = "";
        message.propertyId = 0;
        message.contractId = 0;
        message.taskId = 0;
        message.timesheetLineId = 0;
        message.diagnosisId = 0;
        message.isInternal = false;
        message.isPinned = false;
        message.userIdList = "";
        message.category = "";
        message.groupBy = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string feed_id */ 1:
                    message.feedId = reader.string();
                    break;
                case /* string feed_type */ 2:
                    message.feedType = reader.string();
                    break;
                case /* int32 source_id */ 3:
                    message.sourceId = reader.int32();
                    break;
                case /* int32 event_id */ 4:
                    message.eventId = reader.int32();
                    break;
                case /* string title */ 5:
                    message.title = reader.string();
                    break;
                case /* string content */ 6:
                    message.content = reader.string();
                    break;
                case /* string created_date */ 7:
                    message.createdDate = reader.string();
                    break;
                case /* int32 user_id */ 8:
                    message.userId = reader.int32();
                    break;
                case /* string user_name */ 9:
                    message.userName = reader.string();
                    break;
                case /* bool is_active */ 10:
                    message.isActive = reader.bool();
                    break;
                case /* string file_id */ 11:
                    message.fileId = reader.string();
                    break;
                case /* int32 status_id */ 12:
                    message.statusId = reader.int32();
                    break;
                case /* int32 classification_id */ 13:
                    message.classificationId = reader.int32();
                    break;
                case /* string activity_name */ 14:
                    message.activityName = reader.string();
                    break;
                case /* int32 property_id */ 15:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 contract_id */ 16:
                    message.contractId = reader.int32();
                    break;
                case /* int32 task_id */ 17:
                    message.taskId = reader.int32();
                    break;
                case /* int32 timesheet_line_id */ 18:
                    message.timesheetLineId = reader.int32();
                    break;
                case /* int32 diagnosis_id */ 24:
                    message.diagnosisId = reader.int32();
                    break;
                case /* bool is_internal */ 25:
                    message.isInternal = reader.bool();
                    break;
                case /* bool is_pinned */ 26:
                    message.isPinned = reader.bool();
                    break;
                case /* string user_id_list */ 27:
                    message.userIdList = reader.string();
                    break;
                case /* string category */ 28:
                    message.category = reader.string();
                    break;
                case /* string group_by */ 29:
                    message.groupBy = reader.string();
                    break;
                case /* repeated string field_mask */ 19:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 20:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 21:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 22:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 23:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string feed_id = 1; */
        if (message.feedId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.feedId);
        /* string feed_type = 2; */
        if (message.feedType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.feedType);
        /* int32 source_id = 3; */
        if (message.sourceId !== 0)
            writer.tag(3, WireType.Varint).int32(message.sourceId);
        /* int32 event_id = 4; */
        if (message.eventId !== 0)
            writer.tag(4, WireType.Varint).int32(message.eventId);
        /* string title = 5; */
        if (message.title !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.title);
        /* string content = 6; */
        if (message.content !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.content);
        /* string created_date = 7; */
        if (message.createdDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdDate);
        /* int32 user_id = 8; */
        if (message.userId !== 0)
            writer.tag(8, WireType.Varint).int32(message.userId);
        /* string user_name = 9; */
        if (message.userName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.userName);
        /* bool is_active = 10; */
        if (message.isActive !== false)
            writer.tag(10, WireType.Varint).bool(message.isActive);
        /* string file_id = 11; */
        if (message.fileId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.fileId);
        /* int32 status_id = 12; */
        if (message.statusId !== 0)
            writer.tag(12, WireType.Varint).int32(message.statusId);
        /* int32 classification_id = 13; */
        if (message.classificationId !== 0)
            writer.tag(13, WireType.Varint).int32(message.classificationId);
        /* string activity_name = 14; */
        if (message.activityName !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.activityName);
        /* int32 property_id = 15; */
        if (message.propertyId !== 0)
            writer.tag(15, WireType.Varint).int32(message.propertyId);
        /* int32 contract_id = 16; */
        if (message.contractId !== 0)
            writer.tag(16, WireType.Varint).int32(message.contractId);
        /* int32 task_id = 17; */
        if (message.taskId !== 0)
            writer.tag(17, WireType.Varint).int32(message.taskId);
        /* int32 timesheet_line_id = 18; */
        if (message.timesheetLineId !== 0)
            writer.tag(18, WireType.Varint).int32(message.timesheetLineId);
        /* repeated string field_mask = 19; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 20; */
        if (message.pageNumber !== 0)
            writer.tag(20, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 21; */
        if (message.orderBy !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 22; */
        if (message.orderDir !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 23; */
        if (message.withoutLimit !== false)
            writer.tag(23, WireType.Varint).bool(message.withoutLimit);
        /* int32 diagnosis_id = 24; */
        if (message.diagnosisId !== 0)
            writer.tag(24, WireType.Varint).int32(message.diagnosisId);
        /* bool is_internal = 25; */
        if (message.isInternal !== false)
            writer.tag(25, WireType.Varint).bool(message.isInternal);
        /* bool is_pinned = 26; */
        if (message.isPinned !== false)
            writer.tag(26, WireType.Varint).bool(message.isPinned);
        /* string user_id_list = 27; */
        if (message.userIdList !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.userIdList);
        /* string category = 28; */
        if (message.category !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.category);
        /* string group_by = 29; */
        if (message.groupBy !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.groupBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventFeedItem
 */
export const EventFeedItem = new EventFeedItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventFeedResponse$Type extends MessageType {
    constructor() {
        super("EventFeedResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventFeedItem },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "stats", kind: "message", T: () => EventFeedResponse_FeedStats }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated EventFeedItem results */ 1:
                    message.results.push(EventFeedItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* EventFeedResponse.FeedStats stats */ 3:
                    message.stats = EventFeedResponse_FeedStats.internalBinaryRead(reader, reader.uint32(), options, message.stats);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated EventFeedItem results = 1; */
        for (let i = 0; i < message.results.length; i++)
            EventFeedItem.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* EventFeedResponse.FeedStats stats = 3; */
        if (message.stats)
            EventFeedResponse_FeedStats.internalBinaryWrite(message.stats, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventFeedResponse
 */
export const EventFeedResponse = new EventFeedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventFeedResponse_FeedStats$Type extends MessageType {
    constructor() {
        super("EventFeedResponse.FeedStats", [
            { no: 1, name: "memo_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "activity_log_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "total_files", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.memoCount = 0;
        message.activityLogCount = 0;
        message.totalFiles = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 memo_count */ 1:
                    message.memoCount = reader.int32();
                    break;
                case /* int32 activity_log_count */ 2:
                    message.activityLogCount = reader.int32();
                    break;
                case /* int32 total_files */ 3:
                    message.totalFiles = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 memo_count = 1; */
        if (message.memoCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.memoCount);
        /* int32 activity_log_count = 2; */
        if (message.activityLogCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.activityLogCount);
        /* int32 total_files = 3; */
        if (message.totalFiles !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalFiles);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventFeedResponse.FeedStats
 */
export const EventFeedResponse_FeedStats = new EventFeedResponse_FeedStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowEventSearchRequest$Type extends MessageType {
    constructor() {
        super("CallWindowEventSearchRequest", [
            { no: 1, name: "search_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "property_is_residential", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.searchQuery = "";
        message.pageNumber = 0;
        message.pageSize = 0;
        message.jobStatus = "";
        message.jobTypeId = 0;
        message.propertyIsResidential = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string search_query */ 1:
                    message.searchQuery = reader.string();
                    break;
                case /* int32 page_number */ 2:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string job_status */ 4:
                    message.jobStatus = reader.string();
                    break;
                case /* int32 job_type_id */ 5:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 property_is_residential */ 6:
                    message.propertyIsResidential = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string search_query = 1; */
        if (message.searchQuery !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.searchQuery);
        /* int32 page_number = 2; */
        if (message.pageNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNumber);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string job_status = 4; */
        if (message.jobStatus !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jobStatus);
        /* int32 job_type_id = 5; */
        if (message.jobTypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.jobTypeId);
        /* int32 property_is_residential = 6; */
        if (message.propertyIsResidential !== 0)
            writer.tag(6, WireType.Varint).int32(message.propertyIsResidential);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowEventSearchRequest
 */
export const CallWindowEventSearchRequest = new CallWindowEventSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateJobNumberRequest$Type extends MessageType {
    constructor() {
        super("ValidateJobNumberRequest", [
            { no: 1, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobNumber = 0;
        message.departmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_number */ 1:
                    message.jobNumber = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_number = 1; */
        if (message.jobNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobNumber);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ValidateJobNumberRequest
 */
export const ValidateJobNumberRequest = new ValidateJobNumberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateJobNumberResponse$Type extends MessageType {
    constructor() {
        super("ValidateJobNumberResponse", [
            { no: 1, name: "project", kind: "message", T: () => ProjectEvent },
            { no: 2, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 3, name: "cost_job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "cost_job_matched_department", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobs = [];
        message.costJobNumber = 0;
        message.costJobMatchedDepartment = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProjectEvent project */ 1:
                    message.project = ProjectEvent.internalBinaryRead(reader, reader.uint32(), options, message.project);
                    break;
                case /* repeated Event jobs */ 2:
                    message.jobs.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 cost_job_number */ 3:
                    message.costJobNumber = reader.int32();
                    break;
                case /* bool cost_job_matched_department */ 4:
                    message.costJobMatchedDepartment = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ProjectEvent project = 1; */
        if (message.project)
            ProjectEvent.internalBinaryWrite(message.project, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event jobs = 2; */
        for (let i = 0; i < message.jobs.length; i++)
            Event.internalBinaryWrite(message.jobs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 cost_job_number = 3; */
        if (message.costJobNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.costJobNumber);
        /* bool cost_job_matched_department = 4; */
        if (message.costJobMatchedDepartment !== false)
            writer.tag(4, WireType.Varint).bool(message.costJobMatchedDepartment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ValidateJobNumberResponse
 */
export const ValidateJobNumberResponse = new ValidateJobNumberResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkWindowBlockSlot$Type extends MessageType {
    constructor() {
        super("BulkWindowBlockSlot", [
            { no: 1, name: "day_of_week", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "start_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dayOfWeek = 0;
        message.startTime = "";
        message.endTime = "";
        message.departmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 day_of_week */ 1:
                    message.dayOfWeek = reader.int32();
                    break;
                case /* string start_time */ 2:
                    message.startTime = reader.string();
                    break;
                case /* string end_time */ 3:
                    message.endTime = reader.string();
                    break;
                case /* int32 department_id */ 4:
                    message.departmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 day_of_week = 1; */
        if (message.dayOfWeek !== 0)
            writer.tag(1, WireType.Varint).int32(message.dayOfWeek);
        /* string start_time = 2; */
        if (message.startTime !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.startTime);
        /* string end_time = 3; */
        if (message.endTime !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.endTime);
        /* int32 department_id = 4; */
        if (message.departmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.departmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BulkWindowBlockSlot
 */
export const BulkWindowBlockSlot = new BulkWindowBlockSlot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkWindowBlockRequest$Type extends MessageType {
    constructor() {
        super("BulkWindowBlockRequest", [
            { no: 1, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "date_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "date_end", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "call_windows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkWindowBlockSlot }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentIds = [];
        message.jobTypeIds = [];
        message.dateStart = "";
        message.dateEnd = "";
        message.callWindows = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 department_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                case /* repeated int32 job_type_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.jobTypeIds.push(reader.int32());
                    else
                        message.jobTypeIds.push(reader.int32());
                    break;
                case /* string date_start */ 3:
                    message.dateStart = reader.string();
                    break;
                case /* string date_end */ 4:
                    message.dateEnd = reader.string();
                    break;
                case /* repeated BulkWindowBlockSlot call_windows */ 5:
                    message.callWindows.push(BulkWindowBlockSlot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int32 department_ids = 1; */
        if (message.departmentIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        /* repeated int32 job_type_ids = 2; */
        if (message.jobTypeIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.jobTypeIds.length; i++)
                writer.int32(message.jobTypeIds[i]);
            writer.join();
        }
        /* string date_start = 3; */
        if (message.dateStart !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dateStart);
        /* string date_end = 4; */
        if (message.dateEnd !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateEnd);
        /* repeated BulkWindowBlockSlot call_windows = 5; */
        for (let i = 0; i < message.callWindows.length; i++)
            BulkWindowBlockSlot.internalBinaryWrite(message.callWindows[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BulkWindowBlockRequest
 */
export const BulkWindowBlockRequest = new BulkWindowBlockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkWindowBlockResponse$Type extends MessageType {
    constructor() {
        super("BulkWindowBlockResponse", [
            { no: 1, name: "created", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.created = 0;
        message.skipped = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 created */ 1:
                    message.created = reader.int32();
                    break;
                case /* int32 skipped */ 2:
                    message.skipped = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 created = 1; */
        if (message.created !== 0)
            writer.tag(1, WireType.Varint).int32(message.created);
        /* int32 skipped = 2; */
        if (message.skipped !== 0)
            writer.tag(2, WireType.Varint).int32(message.skipped);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BulkWindowBlockResponse
 */
export const BulkWindowBlockResponse = new BulkWindowBlockResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PmQueueRequest$Type extends MessageType {
    constructor() {
        super("PmQueueRequest", [
            { no: 1, name: "job_statuses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "due_window", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sector", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "assigned_csr_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "customer_group_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "waitlisted_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "for_export", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "event_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobStatuses = [];
        message.dueWindow = "";
        message.search = "";
        message.customerUserId = 0;
        message.sector = "";
        message.departmentIds = [];
        message.propertyId = 0;
        message.contractId = 0;
        message.assignedCsrUserId = 0;
        message.dateRange = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.countOnly = false;
        message.withoutLimit = false;
        message.fieldMask = [];
        message.customerGroupIds = [];
        message.waitlistedOnly = false;
        message.forExport = false;
        message.eventIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string job_statuses */ 1:
                    message.jobStatuses.push(reader.string());
                    break;
                case /* string due_window */ 2:
                    message.dueWindow = reader.string();
                    break;
                case /* string search */ 3:
                    message.search = reader.string();
                    break;
                case /* int32 customer_user_id */ 4:
                    message.customerUserId = reader.int32();
                    break;
                case /* string sector */ 5:
                    message.sector = reader.string();
                    break;
                case /* repeated int32 department_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                case /* int32 property_id */ 7:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 contract_id */ 8:
                    message.contractId = reader.int32();
                    break;
                case /* int32 assigned_csr_user_id */ 9:
                    message.assignedCsrUserId = reader.int32();
                    break;
                case /* repeated string date_range */ 10:
                    message.dateRange.push(reader.string());
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 13:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool count_only */ 14:
                    message.countOnly = reader.bool();
                    break;
                case /* bool without_limit */ 15:
                    message.withoutLimit = reader.bool();
                    break;
                case /* repeated string field_mask */ 16:
                    message.fieldMask.push(reader.string());
                    break;
                case /* repeated int32 customer_group_ids */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.customerGroupIds.push(reader.int32());
                    else
                        message.customerGroupIds.push(reader.int32());
                    break;
                case /* bool waitlisted_only */ 18:
                    message.waitlistedOnly = reader.bool();
                    break;
                case /* bool for_export */ 19:
                    message.forExport = reader.bool();
                    break;
                case /* repeated int32 event_ids */ 20:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.eventIds.push(reader.int32());
                    else
                        message.eventIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string job_statuses = 1; */
        for (let i = 0; i < message.jobStatuses.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.jobStatuses[i]);
        /* string due_window = 2; */
        if (message.dueWindow !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dueWindow);
        /* string search = 3; */
        if (message.search !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.search);
        /* int32 customer_user_id = 4; */
        if (message.customerUserId !== 0)
            writer.tag(4, WireType.Varint).int32(message.customerUserId);
        /* string sector = 5; */
        if (message.sector !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sector);
        /* repeated int32 department_ids = 6; */
        if (message.departmentIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        /* int32 property_id = 7; */
        if (message.propertyId !== 0)
            writer.tag(7, WireType.Varint).int32(message.propertyId);
        /* int32 contract_id = 8; */
        if (message.contractId !== 0)
            writer.tag(8, WireType.Varint).int32(message.contractId);
        /* int32 assigned_csr_user_id = 9; */
        if (message.assignedCsrUserId !== 0)
            writer.tag(9, WireType.Varint).int32(message.assignedCsrUserId);
        /* repeated string date_range = 10; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.dateRange[i]);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 13; */
        if (message.pageNumber !== 0)
            writer.tag(13, WireType.Varint).int32(message.pageNumber);
        /* bool count_only = 14; */
        if (message.countOnly !== false)
            writer.tag(14, WireType.Varint).bool(message.countOnly);
        /* bool without_limit = 15; */
        if (message.withoutLimit !== false)
            writer.tag(15, WireType.Varint).bool(message.withoutLimit);
        /* repeated string field_mask = 16; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* repeated int32 customer_group_ids = 17; */
        if (message.customerGroupIds.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.customerGroupIds.length; i++)
                writer.int32(message.customerGroupIds[i]);
            writer.join();
        }
        /* bool waitlisted_only = 18; */
        if (message.waitlistedOnly !== false)
            writer.tag(18, WireType.Varint).bool(message.waitlistedOnly);
        /* bool for_export = 19; */
        if (message.forExport !== false)
            writer.tag(19, WireType.Varint).bool(message.forExport);
        /* repeated int32 event_ids = 20; */
        if (message.eventIds.length) {
            writer.tag(20, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.eventIds.length; i++)
                writer.int32(message.eventIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PmQueueRequest
 */
export const PmQueueRequest = new PmQueueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PmQueueRow$Type extends MessageType {
    constructor() {
        super("PmQueueRow", [
            { no: 1, name: "event", kind: "message", T: () => Event },
            { no: 2, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "last_pm_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_first_visit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "next_pm_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "visit_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "visit_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "cadence_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "assigned_csr_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "assigned_csr_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "last_activity_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "last_activity_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "last_activity_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "membership_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "filter_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "filter_order_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "contract_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "welcome_call_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "last_pm_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "last_pm_scheduled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "is_benefit_visit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "included_filters_with_pm", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.propertyAddress = "";
        message.propertyCity = "";
        message.customerId = 0;
        message.customerName = "";
        message.businessName = "";
        message.lastPmDate = "";
        message.isFirstVisit = false;
        message.nextPmDue = "";
        message.visitIndex = 0;
        message.visitTotal = 0;
        message.cadenceLabel = "";
        message.assignedCsrUserId = 0;
        message.assignedCsrName = "";
        message.lastActivityName = "";
        message.lastActivityDate = "";
        message.lastActivityUserId = 0;
        message.membershipTypeName = "";
        message.filterOrderId = 0;
        message.filterOrderStatus = "";
        message.contractNumber = "";
        message.welcomeCallDue = "";
        message.lastPmEventId = 0;
        message.lastPmScheduled = false;
        message.isBenefitVisit = false;
        message.includedFiltersWithPm = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event event */ 1:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* string property_address */ 2:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 3:
                    message.propertyCity = reader.string();
                    break;
                case /* int32 customer_id */ 4:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 5:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 6:
                    message.businessName = reader.string();
                    break;
                case /* string last_pm_date */ 7:
                    message.lastPmDate = reader.string();
                    break;
                case /* bool is_first_visit */ 8:
                    message.isFirstVisit = reader.bool();
                    break;
                case /* string next_pm_due */ 9:
                    message.nextPmDue = reader.string();
                    break;
                case /* int32 visit_index */ 10:
                    message.visitIndex = reader.int32();
                    break;
                case /* int32 visit_total */ 11:
                    message.visitTotal = reader.int32();
                    break;
                case /* string cadence_label */ 12:
                    message.cadenceLabel = reader.string();
                    break;
                case /* int32 assigned_csr_user_id */ 13:
                    message.assignedCsrUserId = reader.int32();
                    break;
                case /* string assigned_csr_name */ 14:
                    message.assignedCsrName = reader.string();
                    break;
                case /* string last_activity_name */ 15:
                    message.lastActivityName = reader.string();
                    break;
                case /* string last_activity_date */ 16:
                    message.lastActivityDate = reader.string();
                    break;
                case /* int32 last_activity_user_id */ 17:
                    message.lastActivityUserId = reader.int32();
                    break;
                case /* string membership_type_name */ 18:
                    message.membershipTypeName = reader.string();
                    break;
                case /* int32 filter_order_id */ 19:
                    message.filterOrderId = reader.int32();
                    break;
                case /* string filter_order_status */ 20:
                    message.filterOrderStatus = reader.string();
                    break;
                case /* string contract_number */ 21:
                    message.contractNumber = reader.string();
                    break;
                case /* string welcome_call_due */ 22:
                    message.welcomeCallDue = reader.string();
                    break;
                case /* int32 last_pm_event_id */ 23:
                    message.lastPmEventId = reader.int32();
                    break;
                case /* bool last_pm_scheduled */ 24:
                    message.lastPmScheduled = reader.bool();
                    break;
                case /* bool is_benefit_visit */ 25:
                    message.isBenefitVisit = reader.bool();
                    break;
                case /* bool included_filters_with_pm */ 26:
                    message.includedFiltersWithPm = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event event = 1; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string property_address = 2; */
        if (message.propertyAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 3; */
        if (message.propertyCity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.propertyCity);
        /* int32 customer_id = 4; */
        if (message.customerId !== 0)
            writer.tag(4, WireType.Varint).int32(message.customerId);
        /* string customer_name = 5; */
        if (message.customerName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 6; */
        if (message.businessName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.businessName);
        /* string last_pm_date = 7; */
        if (message.lastPmDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.lastPmDate);
        /* bool is_first_visit = 8; */
        if (message.isFirstVisit !== false)
            writer.tag(8, WireType.Varint).bool(message.isFirstVisit);
        /* string next_pm_due = 9; */
        if (message.nextPmDue !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.nextPmDue);
        /* int32 visit_index = 10; */
        if (message.visitIndex !== 0)
            writer.tag(10, WireType.Varint).int32(message.visitIndex);
        /* int32 visit_total = 11; */
        if (message.visitTotal !== 0)
            writer.tag(11, WireType.Varint).int32(message.visitTotal);
        /* string cadence_label = 12; */
        if (message.cadenceLabel !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.cadenceLabel);
        /* int32 assigned_csr_user_id = 13; */
        if (message.assignedCsrUserId !== 0)
            writer.tag(13, WireType.Varint).int32(message.assignedCsrUserId);
        /* string assigned_csr_name = 14; */
        if (message.assignedCsrName !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.assignedCsrName);
        /* string last_activity_name = 15; */
        if (message.lastActivityName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.lastActivityName);
        /* string last_activity_date = 16; */
        if (message.lastActivityDate !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.lastActivityDate);
        /* int32 last_activity_user_id = 17; */
        if (message.lastActivityUserId !== 0)
            writer.tag(17, WireType.Varint).int32(message.lastActivityUserId);
        /* string membership_type_name = 18; */
        if (message.membershipTypeName !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.membershipTypeName);
        /* int32 filter_order_id = 19; */
        if (message.filterOrderId !== 0)
            writer.tag(19, WireType.Varint).int32(message.filterOrderId);
        /* string filter_order_status = 20; */
        if (message.filterOrderStatus !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.filterOrderStatus);
        /* string contract_number = 21; */
        if (message.contractNumber !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.contractNumber);
        /* string welcome_call_due = 22; */
        if (message.welcomeCallDue !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.welcomeCallDue);
        /* int32 last_pm_event_id = 23; */
        if (message.lastPmEventId !== 0)
            writer.tag(23, WireType.Varint).int32(message.lastPmEventId);
        /* bool last_pm_scheduled = 24; */
        if (message.lastPmScheduled !== false)
            writer.tag(24, WireType.Varint).bool(message.lastPmScheduled);
        /* bool is_benefit_visit = 25; */
        if (message.isBenefitVisit !== false)
            writer.tag(25, WireType.Varint).bool(message.isBenefitVisit);
        /* bool included_filters_with_pm = 26; */
        if (message.includedFiltersWithPm !== false)
            writer.tag(26, WireType.Varint).bool(message.includedFiltersWithPm);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PmQueueRow
 */
export const PmQueueRow = new PmQueueRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PmQueueResponse$Type extends MessageType {
    constructor() {
        super("PmQueueResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PmQueueRow },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "first_call_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "welcome_call_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        message.firstCallCount = 0;
        message.welcomeCallCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PmQueueRow results */ 1:
                    message.results.push(PmQueueRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 first_call_count */ 3:
                    message.firstCallCount = reader.int32();
                    break;
                case /* int32 welcome_call_count */ 4:
                    message.welcomeCallCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PmQueueRow results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PmQueueRow.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* int32 first_call_count = 3; */
        if (message.firstCallCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.firstCallCount);
        /* int32 welcome_call_count = 4; */
        if (message.welcomeCallCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.welcomeCallCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PmQueueResponse
 */
export const PmQueueResponse = new PmQueueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommercialServiceQueue$Type extends MessageType {
    constructor() {
        super("CommercialServiceQueue", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 55, name: "tracking_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "service_channel_wo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "sc_wo_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "sc_status_primary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 58, name: "sc_status_extended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 59, name: "sc_status_received_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 60, name: "sc_sync_issue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 64, name: "sc_checkout_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 65, name: "sc_completion_held", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sla_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_priority_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "priority_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 62, name: "priority_level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "priority_response_time", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "priority_response_time_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "amount_quoted", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "services_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "time_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "technician_assigned", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "quote_pending", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "is_callback", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 53, name: "acknowledged_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "acknowledged_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "store_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "property_zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "search_blob", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "latest_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "latest_note_author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "latest_note_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "pinned_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "pinned_note_author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "pinned_note_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "customer_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "property_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "job_status_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 61, name: "sc_status_primary_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 63, name: "priority_level_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 50, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 51, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 52, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.jobNumber = "";
        message.trackingNumber = "";
        message.serviceChannelWo = "";
        message.scWoNumber = "";
        message.scStatusPrimary = "";
        message.scStatusExtended = "";
        message.scStatusReceivedAt = "";
        message.scSyncIssue = 0;
        message.scCheckoutState = "";
        message.scCompletionHeld = 0;
        message.slaDue = "";
        message.customerPriorityId = 0;
        message.priorityLabel = "";
        message.priorityLevel = "";
        message.priorityResponseTime = 0;
        message.priorityResponseTimeUnit = "";
        message.amountQuoted = "";
        message.jobStatus = "";
        message.paymentStatus = "";
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.servicesNeeded = "";
        message.dateCreated = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.timeStarted = "";
        message.timeEnded = "";
        message.technicianAssigned = "";
        message.quotePending = 0;
        message.isCallback = 0;
        message.acknowledgedBy = 0;
        message.acknowledgedDate = "";
        message.customerId = 0;
        message.customerName = "";
        message.businessName = "";
        message.propertyId = 0;
        message.storeNumber = "";
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.propertyZip = "";
        message.searchBlob = "";
        message.latestNote = "";
        message.latestNoteAuthor = "";
        message.latestNoteDate = "";
        message.pinnedNote = "";
        message.pinnedNoteAuthor = "";
        message.pinnedNoteDate = "";
        message.departmentIdList = "";
        message.customerIdList = "";
        message.propertyIdList = "";
        message.jobStatusList = "";
        message.scStatusPrimaryList = "";
        message.priorityLevelList = "";
        message.notEquals = [];
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.countOnly = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string job_number */ 2:
                    message.jobNumber = reader.string();
                    break;
                case /* string tracking_number */ 55:
                    message.trackingNumber = reader.string();
                    break;
                case /* string service_channel_wo */ 3:
                    message.serviceChannelWo = reader.string();
                    break;
                case /* string sc_wo_number */ 56:
                    message.scWoNumber = reader.string();
                    break;
                case /* string sc_status_primary */ 57:
                    message.scStatusPrimary = reader.string();
                    break;
                case /* string sc_status_extended */ 58:
                    message.scStatusExtended = reader.string();
                    break;
                case /* string sc_status_received_at */ 59:
                    message.scStatusReceivedAt = reader.string();
                    break;
                case /* int32 sc_sync_issue */ 60:
                    message.scSyncIssue = reader.int32();
                    break;
                case /* string sc_checkout_state */ 64:
                    message.scCheckoutState = reader.string();
                    break;
                case /* int32 sc_completion_held */ 65:
                    message.scCompletionHeld = reader.int32();
                    break;
                case /* string sla_due */ 4:
                    message.slaDue = reader.string();
                    break;
                case /* int32 customer_priority_id */ 5:
                    message.customerPriorityId = reader.int32();
                    break;
                case /* string priority_label */ 6:
                    message.priorityLabel = reader.string();
                    break;
                case /* string priority_level */ 62:
                    message.priorityLevel = reader.string();
                    break;
                case /* int32 priority_response_time */ 7:
                    message.priorityResponseTime = reader.int32();
                    break;
                case /* string priority_response_time_unit */ 8:
                    message.priorityResponseTimeUnit = reader.string();
                    break;
                case /* string amount_quoted */ 9:
                    message.amountQuoted = reader.string();
                    break;
                case /* string job_status */ 10:
                    message.jobStatus = reader.string();
                    break;
                case /* string payment_status */ 11:
                    message.paymentStatus = reader.string();
                    break;
                case /* int32 department_id */ 12:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 13:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 14:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string services_needed */ 15:
                    message.servicesNeeded = reader.string();
                    break;
                case /* string date_created */ 16:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_started */ 17:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 18:
                    message.dateEnded = reader.string();
                    break;
                case /* string time_started */ 19:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_ended */ 20:
                    message.timeEnded = reader.string();
                    break;
                case /* string technician_assigned */ 21:
                    message.technicianAssigned = reader.string();
                    break;
                case /* int32 quote_pending */ 22:
                    message.quotePending = reader.int32();
                    break;
                case /* int32 is_callback */ 23:
                    message.isCallback = reader.int32();
                    break;
                case /* int32 acknowledged_by */ 53:
                    message.acknowledgedBy = reader.int32();
                    break;
                case /* string acknowledged_date */ 54:
                    message.acknowledgedDate = reader.string();
                    break;
                case /* int32 customer_id */ 24:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 25:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 26:
                    message.businessName = reader.string();
                    break;
                case /* int32 property_id */ 27:
                    message.propertyId = reader.int32();
                    break;
                case /* string store_number */ 28:
                    message.storeNumber = reader.string();
                    break;
                case /* string property_address */ 29:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 30:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 31:
                    message.propertyState = reader.string();
                    break;
                case /* string property_zip */ 32:
                    message.propertyZip = reader.string();
                    break;
                case /* string search_blob */ 33:
                    message.searchBlob = reader.string();
                    break;
                case /* string latest_note */ 34:
                    message.latestNote = reader.string();
                    break;
                case /* string latest_note_author */ 35:
                    message.latestNoteAuthor = reader.string();
                    break;
                case /* string latest_note_date */ 36:
                    message.latestNoteDate = reader.string();
                    break;
                case /* string pinned_note */ 37:
                    message.pinnedNote = reader.string();
                    break;
                case /* string pinned_note_author */ 38:
                    message.pinnedNoteAuthor = reader.string();
                    break;
                case /* string pinned_note_date */ 39:
                    message.pinnedNoteDate = reader.string();
                    break;
                case /* string department_id_list */ 40:
                    message.departmentIdList = reader.string();
                    break;
                case /* string customer_id_list */ 41:
                    message.customerIdList = reader.string();
                    break;
                case /* string property_id_list */ 42:
                    message.propertyIdList = reader.string();
                    break;
                case /* string job_status_list */ 43:
                    message.jobStatusList = reader.string();
                    break;
                case /* string sc_status_primary_list */ 61:
                    message.scStatusPrimaryList = reader.string();
                    break;
                case /* string priority_level_list */ 63:
                    message.priorityLevelList = reader.string();
                    break;
                case /* repeated string not_equals */ 44:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string date_range */ 45:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 46:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 47:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 48:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 49:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 50:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 51:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool count_only */ 52:
                    message.countOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string job_number = 2; */
        if (message.jobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobNumber);
        /* string service_channel_wo = 3; */
        if (message.serviceChannelWo !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serviceChannelWo);
        /* string sla_due = 4; */
        if (message.slaDue !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.slaDue);
        /* int32 customer_priority_id = 5; */
        if (message.customerPriorityId !== 0)
            writer.tag(5, WireType.Varint).int32(message.customerPriorityId);
        /* string priority_label = 6; */
        if (message.priorityLabel !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.priorityLabel);
        /* int32 priority_response_time = 7; */
        if (message.priorityResponseTime !== 0)
            writer.tag(7, WireType.Varint).int32(message.priorityResponseTime);
        /* string priority_response_time_unit = 8; */
        if (message.priorityResponseTimeUnit !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.priorityResponseTimeUnit);
        /* string amount_quoted = 9; */
        if (message.amountQuoted !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.amountQuoted);
        /* string job_status = 10; */
        if (message.jobStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.jobStatus);
        /* string payment_status = 11; */
        if (message.paymentStatus !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.paymentStatus);
        /* int32 department_id = 12; */
        if (message.departmentId !== 0)
            writer.tag(12, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 13; */
        if (message.jobTypeId !== 0)
            writer.tag(13, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 14; */
        if (message.jobSubtypeId !== 0)
            writer.tag(14, WireType.Varint).int32(message.jobSubtypeId);
        /* string services_needed = 15; */
        if (message.servicesNeeded !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.servicesNeeded);
        /* string date_created = 16; */
        if (message.dateCreated !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_started = 17; */
        if (message.dateStarted !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 18; */
        if (message.dateEnded !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.dateEnded);
        /* string time_started = 19; */
        if (message.timeStarted !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_ended = 20; */
        if (message.timeEnded !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.timeEnded);
        /* string technician_assigned = 21; */
        if (message.technicianAssigned !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.technicianAssigned);
        /* int32 quote_pending = 22; */
        if (message.quotePending !== 0)
            writer.tag(22, WireType.Varint).int32(message.quotePending);
        /* int32 is_callback = 23; */
        if (message.isCallback !== 0)
            writer.tag(23, WireType.Varint).int32(message.isCallback);
        /* int32 customer_id = 24; */
        if (message.customerId !== 0)
            writer.tag(24, WireType.Varint).int32(message.customerId);
        /* string customer_name = 25; */
        if (message.customerName !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 26; */
        if (message.businessName !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.businessName);
        /* int32 property_id = 27; */
        if (message.propertyId !== 0)
            writer.tag(27, WireType.Varint).int32(message.propertyId);
        /* string store_number = 28; */
        if (message.storeNumber !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.storeNumber);
        /* string property_address = 29; */
        if (message.propertyAddress !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 30; */
        if (message.propertyCity !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 31; */
        if (message.propertyState !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.propertyState);
        /* string property_zip = 32; */
        if (message.propertyZip !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.propertyZip);
        /* string search_blob = 33; */
        if (message.searchBlob !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.searchBlob);
        /* string latest_note = 34; */
        if (message.latestNote !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.latestNote);
        /* string latest_note_author = 35; */
        if (message.latestNoteAuthor !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.latestNoteAuthor);
        /* string latest_note_date = 36; */
        if (message.latestNoteDate !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.latestNoteDate);
        /* string pinned_note = 37; */
        if (message.pinnedNote !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.pinnedNote);
        /* string pinned_note_author = 38; */
        if (message.pinnedNoteAuthor !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.pinnedNoteAuthor);
        /* string pinned_note_date = 39; */
        if (message.pinnedNoteDate !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.pinnedNoteDate);
        /* string department_id_list = 40; */
        if (message.departmentIdList !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.departmentIdList);
        /* string customer_id_list = 41; */
        if (message.customerIdList !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.customerIdList);
        /* string property_id_list = 42; */
        if (message.propertyIdList !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.propertyIdList);
        /* string job_status_list = 43; */
        if (message.jobStatusList !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.jobStatusList);
        /* repeated string not_equals = 44; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(44, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string date_range = 45; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(45, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 46; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(46, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 47; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(47, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 48; */
        if (message.orderBy !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 49; */
        if (message.orderDir !== "")
            writer.tag(49, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 50; */
        if (message.pageNumber !== 0)
            writer.tag(50, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 51; */
        if (message.withoutLimit !== false)
            writer.tag(51, WireType.Varint).bool(message.withoutLimit);
        /* bool count_only = 52; */
        if (message.countOnly !== false)
            writer.tag(52, WireType.Varint).bool(message.countOnly);
        /* int32 acknowledged_by = 53; */
        if (message.acknowledgedBy !== 0)
            writer.tag(53, WireType.Varint).int32(message.acknowledgedBy);
        /* string acknowledged_date = 54; */
        if (message.acknowledgedDate !== "")
            writer.tag(54, WireType.LengthDelimited).string(message.acknowledgedDate);
        /* string tracking_number = 55; */
        if (message.trackingNumber !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.trackingNumber);
        /* string sc_wo_number = 56; */
        if (message.scWoNumber !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.scWoNumber);
        /* string sc_status_primary = 57; */
        if (message.scStatusPrimary !== "")
            writer.tag(57, WireType.LengthDelimited).string(message.scStatusPrimary);
        /* string sc_status_extended = 58; */
        if (message.scStatusExtended !== "")
            writer.tag(58, WireType.LengthDelimited).string(message.scStatusExtended);
        /* string sc_status_received_at = 59; */
        if (message.scStatusReceivedAt !== "")
            writer.tag(59, WireType.LengthDelimited).string(message.scStatusReceivedAt);
        /* int32 sc_sync_issue = 60; */
        if (message.scSyncIssue !== 0)
            writer.tag(60, WireType.Varint).int32(message.scSyncIssue);
        /* string sc_status_primary_list = 61; */
        if (message.scStatusPrimaryList !== "")
            writer.tag(61, WireType.LengthDelimited).string(message.scStatusPrimaryList);
        /* string priority_level = 62; */
        if (message.priorityLevel !== "")
            writer.tag(62, WireType.LengthDelimited).string(message.priorityLevel);
        /* string priority_level_list = 63; */
        if (message.priorityLevelList !== "")
            writer.tag(63, WireType.LengthDelimited).string(message.priorityLevelList);
        /* string sc_checkout_state = 64; */
        if (message.scCheckoutState !== "")
            writer.tag(64, WireType.LengthDelimited).string(message.scCheckoutState);
        /* int32 sc_completion_held = 65; */
        if (message.scCompletionHeld !== 0)
            writer.tag(65, WireType.Varint).int32(message.scCompletionHeld);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommercialServiceQueue
 */
export const CommercialServiceQueue = new CommercialServiceQueue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommercialServiceQueueList$Type extends MessageType {
    constructor() {
        super("CommercialServiceQueueList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CommercialServiceQueue },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommercialServiceQueue results */ 1:
                    message.results.push(CommercialServiceQueue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CommercialServiceQueue results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CommercialServiceQueue.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommercialServiceQueueList
 */
export const CommercialServiceQueueList = new CommercialServiceQueueList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommercialServiceQueueLocation$Type extends MessageType {
    constructor() {
        super("CommercialServiceQueueLocation", [
            { no: 1, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "store_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "property_zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "open_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "incomplete_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "active_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "oldest_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "next_visit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "min_priority_response_hours", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "search_blob", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "next_up_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "next_up_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "next_up_tracking_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "next_up_service_channel_wo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "next_up_sla_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "next_up_priority_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "next_up_job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "next_up_services_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "next_up_latest_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "next_up_latest_note_author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "next_up_latest_note_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "next_up_amount_quoted", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "statuses_blob", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "has_quote_pending", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 40, name: "has_overdue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 41, name: "has_due_soon", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "has_new", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "customer_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "property_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.propertyId = 0;
        message.departmentId = 0;
        message.storeNumber = "";
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.propertyZip = "";
        message.customerId = 0;
        message.customerName = "";
        message.businessName = "";
        message.openCount = 0;
        message.incompleteCount = 0;
        message.activeCount = 0;
        message.oldestDays = 0;
        message.nextVisit = "";
        message.minPriorityResponseHours = 0;
        message.searchBlob = "";
        message.nextUpEventId = 0;
        message.nextUpJobNumber = "";
        message.nextUpTrackingNumber = "";
        message.nextUpServiceChannelWo = "";
        message.nextUpSlaDue = "";
        message.nextUpPriorityLabel = "";
        message.nextUpJobStatus = "";
        message.nextUpServicesNeeded = "";
        message.nextUpLatestNote = "";
        message.nextUpLatestNoteAuthor = "";
        message.nextUpLatestNoteDate = "";
        message.nextUpAmountQuoted = "";
        message.statusesBlob = "";
        message.hasQuotePending = 0;
        message.hasOverdue = 0;
        message.hasDueSoon = 0;
        message.hasNew = 0;
        message.departmentIdList = "";
        message.customerIdList = "";
        message.propertyIdList = "";
        message.notEquals = [];
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.countOnly = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 property_id */ 1:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* string store_number */ 3:
                    message.storeNumber = reader.string();
                    break;
                case /* string property_address */ 4:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 5:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 6:
                    message.propertyState = reader.string();
                    break;
                case /* string property_zip */ 7:
                    message.propertyZip = reader.string();
                    break;
                case /* int32 customer_id */ 8:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 9:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 10:
                    message.businessName = reader.string();
                    break;
                case /* int32 open_count */ 11:
                    message.openCount = reader.int32();
                    break;
                case /* int32 incomplete_count */ 12:
                    message.incompleteCount = reader.int32();
                    break;
                case /* int32 active_count */ 13:
                    message.activeCount = reader.int32();
                    break;
                case /* int32 oldest_days */ 14:
                    message.oldestDays = reader.int32();
                    break;
                case /* string next_visit */ 15:
                    message.nextVisit = reader.string();
                    break;
                case /* int32 min_priority_response_hours */ 16:
                    message.minPriorityResponseHours = reader.int32();
                    break;
                case /* string search_blob */ 17:
                    message.searchBlob = reader.string();
                    break;
                case /* int32 next_up_event_id */ 18:
                    message.nextUpEventId = reader.int32();
                    break;
                case /* string next_up_job_number */ 19:
                    message.nextUpJobNumber = reader.string();
                    break;
                case /* string next_up_tracking_number */ 44:
                    message.nextUpTrackingNumber = reader.string();
                    break;
                case /* string next_up_service_channel_wo */ 20:
                    message.nextUpServiceChannelWo = reader.string();
                    break;
                case /* string next_up_sla_due */ 21:
                    message.nextUpSlaDue = reader.string();
                    break;
                case /* string next_up_priority_label */ 22:
                    message.nextUpPriorityLabel = reader.string();
                    break;
                case /* string next_up_job_status */ 23:
                    message.nextUpJobStatus = reader.string();
                    break;
                case /* string next_up_services_needed */ 24:
                    message.nextUpServicesNeeded = reader.string();
                    break;
                case /* string next_up_latest_note */ 25:
                    message.nextUpLatestNote = reader.string();
                    break;
                case /* string next_up_latest_note_author */ 26:
                    message.nextUpLatestNoteAuthor = reader.string();
                    break;
                case /* string next_up_latest_note_date */ 27:
                    message.nextUpLatestNoteDate = reader.string();
                    break;
                case /* string next_up_amount_quoted */ 43:
                    message.nextUpAmountQuoted = reader.string();
                    break;
                case /* string statuses_blob */ 38:
                    message.statusesBlob = reader.string();
                    break;
                case /* int32 has_quote_pending */ 39:
                    message.hasQuotePending = reader.int32();
                    break;
                case /* int32 has_overdue */ 40:
                    message.hasOverdue = reader.int32();
                    break;
                case /* int32 has_due_soon */ 41:
                    message.hasDueSoon = reader.int32();
                    break;
                case /* int32 has_new */ 42:
                    message.hasNew = reader.int32();
                    break;
                case /* string department_id_list */ 28:
                    message.departmentIdList = reader.string();
                    break;
                case /* string customer_id_list */ 29:
                    message.customerIdList = reader.string();
                    break;
                case /* string property_id_list */ 30:
                    message.propertyIdList = reader.string();
                    break;
                case /* repeated string not_equals */ 31:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string field_mask */ 32:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 33:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 34:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 35:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 36:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool count_only */ 37:
                    message.countOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 property_id = 1; */
        if (message.propertyId !== 0)
            writer.tag(1, WireType.Varint).int32(message.propertyId);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* string store_number = 3; */
        if (message.storeNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.storeNumber);
        /* string property_address = 4; */
        if (message.propertyAddress !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 5; */
        if (message.propertyCity !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 6; */
        if (message.propertyState !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.propertyState);
        /* string property_zip = 7; */
        if (message.propertyZip !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.propertyZip);
        /* int32 customer_id = 8; */
        if (message.customerId !== 0)
            writer.tag(8, WireType.Varint).int32(message.customerId);
        /* string customer_name = 9; */
        if (message.customerName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 10; */
        if (message.businessName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.businessName);
        /* int32 open_count = 11; */
        if (message.openCount !== 0)
            writer.tag(11, WireType.Varint).int32(message.openCount);
        /* int32 incomplete_count = 12; */
        if (message.incompleteCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.incompleteCount);
        /* int32 active_count = 13; */
        if (message.activeCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.activeCount);
        /* int32 oldest_days = 14; */
        if (message.oldestDays !== 0)
            writer.tag(14, WireType.Varint).int32(message.oldestDays);
        /* string next_visit = 15; */
        if (message.nextVisit !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.nextVisit);
        /* int32 min_priority_response_hours = 16; */
        if (message.minPriorityResponseHours !== 0)
            writer.tag(16, WireType.Varint).int32(message.minPriorityResponseHours);
        /* string search_blob = 17; */
        if (message.searchBlob !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.searchBlob);
        /* int32 next_up_event_id = 18; */
        if (message.nextUpEventId !== 0)
            writer.tag(18, WireType.Varint).int32(message.nextUpEventId);
        /* string next_up_job_number = 19; */
        if (message.nextUpJobNumber !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.nextUpJobNumber);
        /* string next_up_service_channel_wo = 20; */
        if (message.nextUpServiceChannelWo !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.nextUpServiceChannelWo);
        /* string next_up_sla_due = 21; */
        if (message.nextUpSlaDue !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.nextUpSlaDue);
        /* string next_up_priority_label = 22; */
        if (message.nextUpPriorityLabel !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.nextUpPriorityLabel);
        /* string next_up_job_status = 23; */
        if (message.nextUpJobStatus !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.nextUpJobStatus);
        /* string next_up_services_needed = 24; */
        if (message.nextUpServicesNeeded !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.nextUpServicesNeeded);
        /* string next_up_latest_note = 25; */
        if (message.nextUpLatestNote !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.nextUpLatestNote);
        /* string next_up_latest_note_author = 26; */
        if (message.nextUpLatestNoteAuthor !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.nextUpLatestNoteAuthor);
        /* string next_up_latest_note_date = 27; */
        if (message.nextUpLatestNoteDate !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.nextUpLatestNoteDate);
        /* string department_id_list = 28; */
        if (message.departmentIdList !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.departmentIdList);
        /* string customer_id_list = 29; */
        if (message.customerIdList !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.customerIdList);
        /* string property_id_list = 30; */
        if (message.propertyIdList !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.propertyIdList);
        /* repeated string not_equals = 31; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(31, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string field_mask = 32; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(32, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 33; */
        if (message.orderBy !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 34; */
        if (message.orderDir !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 35; */
        if (message.pageNumber !== 0)
            writer.tag(35, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 36; */
        if (message.withoutLimit !== false)
            writer.tag(36, WireType.Varint).bool(message.withoutLimit);
        /* bool count_only = 37; */
        if (message.countOnly !== false)
            writer.tag(37, WireType.Varint).bool(message.countOnly);
        /* string statuses_blob = 38; */
        if (message.statusesBlob !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.statusesBlob);
        /* int32 has_quote_pending = 39; */
        if (message.hasQuotePending !== 0)
            writer.tag(39, WireType.Varint).int32(message.hasQuotePending);
        /* int32 has_overdue = 40; */
        if (message.hasOverdue !== 0)
            writer.tag(40, WireType.Varint).int32(message.hasOverdue);
        /* int32 has_due_soon = 41; */
        if (message.hasDueSoon !== 0)
            writer.tag(41, WireType.Varint).int32(message.hasDueSoon);
        /* int32 has_new = 42; */
        if (message.hasNew !== 0)
            writer.tag(42, WireType.Varint).int32(message.hasNew);
        /* string next_up_amount_quoted = 43; */
        if (message.nextUpAmountQuoted !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.nextUpAmountQuoted);
        /* string next_up_tracking_number = 44; */
        if (message.nextUpTrackingNumber !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.nextUpTrackingNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommercialServiceQueueLocation
 */
export const CommercialServiceQueueLocation = new CommercialServiceQueueLocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommercialServiceQueueLocationList$Type extends MessageType {
    constructor() {
        super("CommercialServiceQueueLocationList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CommercialServiceQueueLocation },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommercialServiceQueueLocation results */ 1:
                    message.results.push(CommercialServiceQueueLocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CommercialServiceQueueLocation results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CommercialServiceQueueLocation.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommercialServiceQueueLocationList
 */
export const CommercialServiceQueueLocationList = new CommercialServiceQueueLocationList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdoptContractSubscriptionReq$Type extends MessageType {
    constructor() {
        super("AdoptContractSubscriptionReq", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subscription_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "helcim_transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.subscriptionId = 0;
        message.helcimTransactionId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* int32 subscription_id */ 2:
                    message.subscriptionId = reader.int32();
                    break;
                case /* int32 helcim_transaction_id */ 3:
                    message.helcimTransactionId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* int32 subscription_id = 2; */
        if (message.subscriptionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.subscriptionId);
        /* int32 helcim_transaction_id = 3; */
        if (message.helcimTransactionId !== 0)
            writer.tag(3, WireType.Varint).int32(message.helcimTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AdoptContractSubscriptionReq
 */
export const AdoptContractSubscriptionReq = new AdoptContractSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventTradeResolution$Type extends MessageType {
    constructor() {
        super("EventTradeResolution", [
            { no: 1, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "requires_subtype", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventTradeId = 0;
        message.name = "";
        message.requiresSubtype = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_trade_id */ 1:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool requires_subtype */ 3:
                    message.requiresSubtype = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_trade_id = 1; */
        if (message.eventTradeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventTradeId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool requires_subtype = 3; */
        if (message.requiresSubtype !== false)
            writer.tag(3, WireType.Varint).bool(message.requiresSubtype);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EventTradeResolution
 */
export const EventTradeResolution = new EventTradeResolution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubtypeTrade$Type extends MessageType {
    constructor() {
        super("SubtypeTrade", [
            { no: 1, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobSubtypeId = 0;
        message.eventTradeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_subtype_id */ 1:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* int32 event_trade_id */ 2:
                    message.eventTradeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_subtype_id = 1; */
        if (message.jobSubtypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobSubtypeId);
        /* int32 event_trade_id = 2; */
        if (message.eventTradeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventTradeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SubtypeTrade
 */
export const SubtypeTrade = new SubtypeTrade$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubtypeTradeList$Type extends MessageType {
    constructor() {
        super("SubtypeTradeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubtypeTrade },
            { no: 2, name: "groups_by_trade", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.groupsByTrade = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SubtypeTrade results */ 1:
                    message.results.push(SubtypeTrade.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool groups_by_trade */ 2:
                    message.groupsByTrade = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SubtypeTrade results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SubtypeTrade.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool groups_by_trade = 2; */
        if (message.groupsByTrade !== false)
            writer.tag(2, WireType.Varint).bool(message.groupsByTrade);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SubtypeTradeList
 */
export const SubtypeTradeList = new SubtypeTradeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractAmendment$Type extends MessageType {
    constructor() {
        super("ContractAmendment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "date_approved", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "approved_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "review_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "cancel_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.contractId = 0;
        message.invoiceId = 0;
        message.dateCreated = "";
        message.createdByUserId = 0;
        message.dateApproved = "";
        message.approvedByUserId = 0;
        message.reviewStatus = "";
        message.cancelReason = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 contract_id */ 2:
                    message.contractId = reader.int32();
                    break;
                case /* int32 invoice_id */ 3:
                    message.invoiceId = reader.int32();
                    break;
                case /* string date_created */ 4:
                    message.dateCreated = reader.string();
                    break;
                case /* int32 created_by_user_id */ 5:
                    message.createdByUserId = reader.int32();
                    break;
                case /* string date_approved */ 6:
                    message.dateApproved = reader.string();
                    break;
                case /* int32 approved_by_user_id */ 7:
                    message.approvedByUserId = reader.int32();
                    break;
                case /* string review_status */ 9:
                    message.reviewStatus = reader.string();
                    break;
                case /* string cancel_reason */ 10:
                    message.cancelReason = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 contract_id = 2; */
        if (message.contractId !== 0)
            writer.tag(2, WireType.Varint).int32(message.contractId);
        /* int32 invoice_id = 3; */
        if (message.invoiceId !== 0)
            writer.tag(3, WireType.Varint).int32(message.invoiceId);
        /* string date_created = 4; */
        if (message.dateCreated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateCreated);
        /* int32 created_by_user_id = 5; */
        if (message.createdByUserId !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdByUserId);
        /* string date_approved = 6; */
        if (message.dateApproved !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateApproved);
        /* int32 approved_by_user_id = 7; */
        if (message.approvedByUserId !== 0)
            writer.tag(7, WireType.Varint).int32(message.approvedByUserId);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string review_status = 9; */
        if (message.reviewStatus !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.reviewStatus);
        /* string cancel_reason = 10; */
        if (message.cancelReason !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.cancelReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ContractAmendment
 */
export const ContractAmendment = new ContractAmendment$Type();
/**
 * @generated ServiceType for protobuf service EventService
 */
export const EventService = new ServiceType("EventService", [
    { name: "Create", options: {}, I: Event, O: Event },
    { name: "Get", options: {}, I: Event, O: Event },
    { name: "BatchGet", options: {}, I: Event, O: EventList },
    { name: "Update", options: {}, I: Event, O: Event },
    { name: "Delete", options: {}, I: Event, O: Event },
    { name: "ResolveEventTrade", options: {}, I: Event, O: EventTradeResolution },
    { name: "GetSubtypeTrades", options: {}, I: Event, O: SubtypeTradeList },
    { name: "GetCalendarData", options: {}, I: Event, O: CalendarData },
    { name: "WriteQuote", options: {}, I: Quotable, O: Quotable },
    { name: "ReadQuotes", options: {}, I: QuotableRead, O: QuotableList },
    { name: "GetProjectTasks", options: {}, I: ProjectTask, O: ProjectTaskList },
    { name: "GetLaborHoursByEventID", options: {}, I: Int32, O: Double },
    { name: "BatchGetCostReportData", options: {}, I: CostReportReq, O: CostReportData },
    { name: "CreateJobAdmin", options: {}, I: JobAdmin, O: JobAdmin },
    { name: "GetJobAdmin", options: {}, I: JobAdmin, O: JobAdmin },
    { name: "BatchGetJobAdmin", options: {}, I: JobAdmin, O: JobAdminList },
    { name: "UpdateJobAdmin", options: {}, I: JobAdmin, O: JobAdmin },
    { name: "DeleteJobAdmin", options: {}, I: JobAdmin, O: JobAdmin },
    { name: "GetClosestProperty", options: {}, I: ClosestPropertyRequest, O: ClosestPropertyResult },
    { name: "GeolocationCheckout", options: {}, I: Int32, O: Bool },
    { name: "CreateEventAssignment", options: {}, I: EventAssignment, O: EventAssignment },
    { name: "GetEventAssignment", options: {}, I: EventAssignment, O: EventAssignment },
    { name: "BatchGetEventAssignment", options: {}, I: EventAssignment, O: EventAssignmentList },
    { name: "UpdateEventAssignment", options: {}, I: EventAssignment, O: EventAssignment },
    { name: "DeleteEventAssignment", options: {}, I: EventAssignment, O: EventAssignment },
    { name: "CreateQuickBooksTrackingCode", options: {}, I: QuickBooksTrackingCode, O: QuickBooksTrackingCode },
    { name: "GetQuickBooksTrackingCode", options: {}, I: QuickBooksTrackingCode, O: QuickBooksTrackingCode },
    { name: "BatchGetQuickBooksTrackingCode", options: {}, I: QuickBooksTrackingCode, O: QuickBooksTrackingCodeList },
    { name: "UpdateQuickBooksTrackingCode", options: {}, I: QuickBooksTrackingCode, O: QuickBooksTrackingCode },
    { name: "DeleteQuickBooksTrackingCode", options: {}, I: QuickBooksTrackingCode, O: QuickBooksTrackingCode },
    { name: "GetPendingBilling", options: {}, I: PendingBilling, O: PendingBilling },
    { name: "BatchGetPendingBilling", options: {}, I: PendingBilling, O: PendingBillingList },
    { name: "CreateContract", options: {}, I: Contract, O: Contract },
    { name: "GetContract", options: {}, I: Contract, O: Contract },
    { name: "BatchGetContract", options: {}, I: Contract, O: ContractList },
    { name: "UpdateContract", options: {}, I: Contract, O: Contract },
    { name: "ApproveContract", options: {}, I: Contract, O: Contract },
    { name: "CreateContractAmendment", options: {}, I: ContractAmendment, O: ContractAmendment },
    { name: "ApproveContractAmendment", options: {}, I: ContractAmendment, O: ContractAmendment },
    { name: "CancelContractAmendment", options: {}, I: ContractAmendment, O: ContractAmendment },
    { name: "RenewContract", options: {}, I: RenewContractReq, O: Contract },
    { name: "UndoContractRenewal", options: {}, I: UndoContractRenewalReq, O: Contract },
    { name: "CreateContractSubscription", options: {}, I: CreateContractSubscriptionReq, O: Contract },
    { name: "CancelContractSubscription", options: {}, I: CancelContractSubscriptionReq, O: Contract },
    { name: "AdoptContractSubscription", options: {}, I: AdoptContractSubscriptionReq, O: Contract },
    { name: "CompleteWelcomeCall", options: {}, I: CompleteWelcomeCallRequest, O: Contract },
    { name: "DeleteContract", options: {}, I: Contract, O: Contract },
    { name: "PurgeContract", options: {}, I: PurgeContractReq, O: Contract },
    { name: "PreviewPurgeContract", options: {}, I: PurgeContractReq, O: PurgeContractPreview },
    { name: "GetMaterialsByContractID", options: {}, I: Contract, O: ContractMaterialList },
    { name: "CreateContractFrequency", options: {}, I: ContractFrequency, O: ContractFrequency },
    { name: "GetContractFrequency", options: {}, I: ContractFrequency, O: ContractFrequency },
    { name: "BatchGetContractFrequency", options: {}, I: ContractFrequency, O: ContractFrequencyList },
    { name: "UpdateContractFrequency", options: {}, I: ContractFrequency, O: ContractFrequency },
    { name: "DeleteContractFrequency", options: {}, I: ContractFrequency, O: ContractFrequency },
    { name: "CreateInvoice", options: {}, I: Invoice, O: Invoice },
    { name: "GetInvoice", options: {}, I: Invoice, O: Invoice },
    { name: "BatchGetInvoice", options: {}, I: Invoice, O: InvoiceList },
    { name: "UpdateInvoice", options: {}, I: Invoice, O: Invoice },
    { name: "DeleteInvoice", options: {}, I: Invoice, O: Invoice },
    { name: "SendSQSInvoiceEmail", options: {}, I: SQSEmailAndDocument, O: Bool },
    { name: "GetInvoiceBody", options: {}, I: InvoiceBodyRequest, O: InvoiceBodyReturn },
    { name: "CreateSiLink", options: {}, I: SiLink, O: SiLink },
    { name: "GetSiLink", options: {}, I: SiLink, O: SiLink },
    { name: "BatchGetSiLink", options: {}, I: SiLink, O: SiLinkList },
    { name: "UpdateSiLink", options: {}, I: SiLink, O: SiLink },
    { name: "DeleteSiLink", options: {}, I: SiLink, O: SiLink },
    { name: "CreateMaintenanceQuestion", options: {}, I: MaintenanceQuestion, O: MaintenanceQuestion },
    { name: "GetMaintenanceQuestion", options: {}, I: MaintenanceQuestion, O: MaintenanceQuestion },
    { name: "BatchGetMaintenanceQuestion", options: {}, I: MaintenanceQuestion, O: MaintenanceQuestionList },
    { name: "UpdateMaintenanceQuestion", options: {}, I: MaintenanceQuestion, O: MaintenanceQuestion },
    { name: "DeleteMaintenanceQuestion", options: {}, I: MaintenanceQuestion, O: MaintenanceQuestion },
    { name: "CreatePayment", options: {}, I: Payment, O: Payment },
    { name: "GetPayment", options: {}, I: Payment, O: Payment },
    { name: "BatchGetPayment", options: {}, I: Payment, O: PaymentList },
    { name: "UpdatePayment", options: {}, I: Payment, O: Payment },
    { name: "DeletePayment", options: {}, I: Payment, O: Payment },
    { name: "GetPaymentsByEventID", options: {}, I: Int32, O: PaymentList },
    { name: "GetPaymentsByInvoiceID", options: {}, I: Int32, O: PaymentList },
    { name: "CreateServicesRendered", options: {}, I: ServicesRendered, O: ServicesRendered },
    { name: "GetServicesRendered", options: {}, I: ServicesRendered, O: ServicesRendered },
    { name: "BatchGetServicesRendered", options: {}, I: ServicesRendered, O: ServicesRenderedList },
    { name: "UpdateServicesRendered", options: {}, I: ServicesRendered, O: ServicesRendered },
    { name: "DeleteServicesRendered", options: {}, I: ServicesRendered, O: ServicesRendered },
    { name: "GetMostRecentServicesRenderedByEventIDs", options: {}, I: ServicesRendered, O: ServicesRenderedList },
    { name: "GetEventDetails", options: {}, I: JobNumberRequest, O: EventDetails },
    { name: "GeolocationCheckoutReturnTimesheets", options: {}, I: GeolocationCheckoutRequest, O: GeolocationTimesheetData },
    { name: "GenerateStripePaymentLink", options: {}, I: GenerateStripePaymentLinkRequest, O: GenerateStripePaymentLinkResponse },
    { name: "BatchGetPurchaseOrder", options: {}, I: PurchaseOrderBatchGetRequest, O: PurchaseOrderList },
    { name: "GetPurchaseOrder", options: {}, I: IDInt32, O: PurchaseOrder },
    { name: "CreatePurchaseOrder", options: {}, I: PurchaseOrder, O: IDInt32 },
    { name: "UpdatePurchaseOrder", options: {}, I: PurchaseOrderUpdateRequest, O: Empty },
    { name: "DeletePurchaseOrder", options: {}, I: IDInt32, O: Empty },
    { name: "BatchGetPurchaseOrderRequisitionItem", options: {}, I: PurchaseOrderRequisitionItemBatchGetRequest, O: PurchaseOrderRequisitionItemList },
    { name: "GetPurchaseOrderRequisitionItem", options: {}, I: IDInt32, O: PurchaseOrderRequisitionItem },
    { name: "CreatePurchaseOrderRequisitionItem", options: {}, I: PurchaseOrderRequisitionItem, O: IDInt32 },
    { name: "UpdatePurchaseOrderRequisitionItem", options: {}, I: PurchaseOrderRequisitionItemUpdateRequest, O: Empty },
    { name: "DeletePurchaseOrderRequisitionItem", options: {}, I: IDInt32, O: Empty },
    { name: "FetchUpcomingSubAccountEvents", options: {}, I: SubAccountEventRequest, O: EventList },
    { name: "FetchSubAccountEventHistory", options: {}, I: SubAccountEventRequest, O: EventList },
    { name: "MostLikelyJob", options: {}, I: MostLikelyJobRequest, O: EventList },
    { name: "GetProjectEvent", options: {}, I: ProjectEvent, O: ProjectEvent },
    { name: "BatchGetProjectEvent", options: {}, I: ProjectEvent, O: ProjectEventList },
    { name: "CreateProjectEvent", options: {}, I: ProjectEvent, O: ProjectEvent },
    { name: "UpdateProjectEvent", options: {}, I: ProjectEvent, O: ProjectEvent },
    { name: "DeleteProjectEvent", options: {}, I: ProjectEvent, O: ProjectEvent },
    { name: "GetInvoicePayment", options: {}, I: InvoicePayment, O: InvoicePayment },
    { name: "BatchGetInvoicePayment", options: {}, I: InvoicePayment, O: InvoicePaymentList },
    { name: "CreateInvoicePayment", options: {}, I: InvoicePayment, O: InvoicePayment },
    { name: "UpdateInvoicePayment", options: {}, I: InvoicePayment, O: InvoicePayment },
    { name: "DeleteInvoicePayment", options: {}, I: InvoicePayment, O: InvoicePayment },
    { name: "GetInvoicePaymentLine", options: {}, I: InvoicePaymentLine, O: InvoicePaymentLine },
    { name: "BatchGetInvoicePaymentLine", options: {}, I: InvoicePaymentLine, O: InvoicePaymentLineList },
    { name: "CreateInvoicePaymentLine", options: {}, I: InvoicePaymentLine, O: InvoicePaymentLine },
    { name: "UpdateInvoicePaymentLine", options: {}, I: InvoicePaymentLine, O: InvoicePaymentLine },
    { name: "DeleteInvoicePaymentLine", options: {}, I: InvoicePaymentLine, O: InvoicePaymentLine },
    { name: "GetCallCountForTimeRange", options: {}, I: CallCountRequest, O: CallCountResponse },
    { name: "SendInvoiceDocumentLinkWithStripe", options: {}, I: PropertyDocumentRequest, O: Bool },
    { name: "SearchUserByPhone", options: {}, I: SearchUserByPhoneRequest, O: SearchUserByPhoneResponse },
    { name: "GetPaymentType", options: {}, I: PaymentType, O: PaymentType },
    { name: "BatchGetPaymentType", options: {}, I: PaymentType, O: PaymentTypeList },
    { name: "GetServicesRenderedPaymentType", options: {}, I: ServicesRenderedPaymentType, O: ServicesRenderedPaymentType },
    { name: "BatchGetServicesRenderedPaymentType", options: {}, I: ServicesRenderedPaymentType, O: ServicesRenderedPaymentTypeList },
    { name: "FetchProjectCostAndEstimate", options: {}, I: FetchProjectCostAndEstimateRequest, O: FetchProjectCostAndEstimateResponse },
    { name: "GetEventFeed", options: {}, I: EventFeedItem, O: EventFeedResponse },
    { name: "BatchGetPmQueue", options: {}, I: PmQueueRequest, O: PmQueueResponse },
    { name: "PreviewInvoice", options: {}, I: InvoiceRequest, O: URLObject },
    { name: "SendPendingInvoice", options: {}, I: InvoiceRequest, O: Bool },
    { name: "SendPaidInvoice", options: {}, I: InvoiceRequest, O: Bool },
    { name: "GetInvoiceDownloadLink", options: {}, I: IDInt32, O: String$ },
    { name: "PreviewProjectInvoice", options: {}, I: InvoiceRequest, O: URLObject },
    { name: "SendPendingProjectInvoice", options: {}, I: InvoiceRequest, O: Bool },
    { name: "SendPaidProjectInvoice", options: {}, I: InvoiceRequest, O: Bool },
    { name: "CreatePaymentIntent", options: {}, I: CreatePaymentIntentRequest, O: CreatePaymentIntentResponse },
    { name: "GetStripePublishableKey", options: {}, I: Empty, O: String$ },
    { name: "CreateInvoicePaymentToken", options: {}, I: InvoicePaymentTokenRequest, O: InvoicePaymentTokenResponse },
    { name: "CreateInvoicePaymentLink", options: {}, I: InvoicePaymentLinkRequest, O: InvoicePaymentTokenResponse },
    { name: "GetPublicInvoicePaymentData", options: {}, I: InvoicePaymentToken, O: PublicInvoicePaymentResponse },
    { name: "CalculateInvoiceTotal", options: {}, I: InvoiceRequest, O: InvoiceTotals },
    { name: "CalculateProjectInvoiceTotal", options: {}, I: InvoiceRequest, O: InvoiceTotals },
    { name: "RecordInvoicePaymentV2", options: {}, I: RecordInvoicePaymentRequest, O: RecordInvoicePaymentResponse },
    { name: "CalculateInvoiceBalance", options: {}, I: Invoice, O: InvoiceBalance },
    { name: "GetInvoicePaymentHistory", options: {}, I: InvoicePaymentHistoryRequest, O: InvoicePaymentHistoryResponse },
    { name: "SearchJobs", options: {}, I: UnifiedJobSearchRequest, O: UnifiedJobSearchResponse },
    { name: "SearchJobsV2", options: {}, I: UnifiedJobSearchRequest, O: UnifiedJobSearchResponse },
    { name: "SearchEventsCallWindow", options: {}, I: CallWindowEventSearchRequest, O: EventList },
    { name: "ValidateJobNumber", options: {}, I: ValidateJobNumberRequest, O: ValidateJobNumberResponse },
    { name: "BatchGetReminders", options: {}, I: Event, O: EventList },
    { name: "BulkCreateWindowBlocks", options: {}, I: BulkWindowBlockRequest, O: BulkWindowBlockResponse },
    { name: "CreateEventPhoto", options: {}, I: EventPhoto, O: EventPhoto },
    { name: "GetEventPhoto", options: {}, I: EventPhoto, O: EventPhoto },
    { name: "BatchGetEventPhoto", options: {}, I: EventPhoto, O: EventPhotoList },
    { name: "UpdateEventPhoto", options: {}, I: EventPhoto, O: EventPhoto },
    { name: "DeleteEventPhoto", options: {}, I: EventPhoto, O: Empty },
    { name: "BatchGetCommercialServiceQueue", options: {}, I: CommercialServiceQueue, O: CommercialServiceQueueList },
    { name: "BatchGetCommercialServiceQueueLocation", options: {}, I: CommercialServiceQueueLocation, O: CommercialServiceQueueLocationList }
]);
